let tr = {
  translation: {
    legacy_timeline_repair: {
      title: "Kısa bir güncelleme gerekiyor",
      body: "Bu eğitim, yeni zaman çizelgesi yapısından önce hazırlanmış. Video ve ses öğeleri henüz bu yapıya uygun olmadığı için sahneler kısa kalabilir ve dışa aktarılan videoda ses kaybolabilir.",
      note: "Birkaç saniye sürer. Eğitiminizde başka hiçbir şey değişmez.",
      videos: "Video",
      audios: "Ses öğesi",
      scenes: "Etkilenen sahne",
      repair: "Şimdi güncelle",
      later: "Şimdi değil",
      running: "Güncelleniyor…",
      retry: "Tekrar dene",
      preparing: "Hazırlanıyor…",
      progress: "Medya dosyaları kontrol ediliyor… {{done}} / {{total}}",
      saving: "Kaydediliyor…",
      error: "Güncelleme tamamlanamadı. Bağlantınızı kontrol edip tekrar deneyin.",
    },
    unknownPlugin: "Bu öğe bu sürümde desteklenmiyor ({{id}})",
    help: {
      title: "Yardım ve rehberler",
      nav: "Yardım",
      search_placeholder: "Özellik ara…",
      no_results: "Eşleşen rehber yok.",
      video_soon: "Video yakında",
    },
    shortcuts: {
      title: "Klavye kısayolları",
      trigger_label: "Klavye kısayolları (? tuşuna basın)",
      foot_hint: "Bu listeyi açıp kapatmak için istediğiniz zaman ? tuşuna basın.",
      click: "Tıkla",
      section_general: "Genel",
      section_editing: "Düzenleme",
      section_canvas: "Seçim ve yerleşim",
      section_scenes: "Sahne listesi",
      help_open: "Bu listeyi göster veya gizle",
      esc_close: "Açık iletişim kutusunu, paneli veya menüyü kapat",
      preview: "Eğitimi önizle",
      print_pdf: "Eğitimi yazdır veya PDF olarak kaydet",
      undo: "Geri al",
      redo: "Yinele",
      redo_alt: "Yinele (alternatif)",
      copy: "Seçili öğeyi kopyala (hiçbir şey seçili değilse tüm sahneyi kopyalar)",
      cut: "Seçili öğeyi kes",
      paste: "Kopyalanan öğeyi veya sahneyi ya da panodaki görseli veya metni yapıştır",
      duplicate: "Seçili öğeyi çoğalt",
      delete_box: "Seçili öğeleri veya zaman çizelgesinde seçili klibi sil",
      select_all: "Geçerli sahnedeki tüm öğeleri seç",
      multi_select: "Bir öğeyi seçime ekle veya seçimden çıkar (Shift + tıklama da çalışır)",
      clear_selection: "Çoklu öğe seçimini temizle",
      move_box: "Seçili öğeyi kaydır (her basışta sahnenin %1'i kadar)",
      resize_aspect:
        "Bir öğeyi yeniden boyutlandırırken en-boy oranını kilitlemek veya kilidi açmak için basılı tutun",
      scenes_toggle_select: "Bir sahneyi seçime ekle veya seçimden çıkar",
      scenes_range_select: "Son tıklanan sahne ile bu sahne arasındaki tüm sahneleri seç",
      scenes_clear_select: "Sahne seçimini temizle",
    },
    aideaChat: {
      buildNotice: {
        frozen: "Sahneler üretilirken düzenleme kapalı — önizleyebilirsiniz.",
        progress: "{{total}} sahneden {{n}}. hazır",
        ready: "Eğitiminiz hazır — artık düzenleyebilirsiniz.",
        readyMessage:
          "Eğitiminiz hazır — {{count}} sahne oluşturuldu. Değiştirmek istediğiniz her şeyi bana söyleyin: anlatım, görseller, yeni bir sahne.",
        readyMessage_plural:
          "Eğitiminiz hazır — {{count}} sahne oluşturuldu. Değiştirmek istediğiniz her şeyi bana söyleyin: anlatım, görseller, yeni bir sahne.",
        paused: "Sahne 1 hazır — bir göz atın.",
        pausedLine:
          "Kalan {{count}} sahneyle devam edin (≈{{credits}} kredi) ya da sahne 1'i bir notla iyileştirin.",
        continue: "Devam et",
        improve: "Sahne 1'i iyileştir",
        improvePlaceholder: "Sahne 1'de ne değişsin?",
        send: "Sahne 1'i yeniden oluştur",
        cancel: "Vazgeç",
        pauseFailed: "Olmadı — tekrar deneyin.",
        pauseBusy: "Çok fazla istek — biraz bekleyin.",
        pauseNoCredits: "Kalan sahneler için yeterli kredi yok — kredi yükleyip tekrar deneyin.",
        improving: "Sahne 1 notunuzla yeniden oluşturuluyor…",
        composerWait: "Oluşturma duraklayınca veya bitince buraya yeniden yazabilirsiniz.",
        askPlaceholder: "Bir soru sorun ya da sahne 1 için bir değişiklik yazın",
        chatThinking: "Düşünüyorum…",
        chatFailed:
          "Mesajınızı anlayamadım. Sahne 1'i bu notla yeniden oluşturmak mı istiyorsunuz, yoksa sadece soru mu soruyorsunuz?",
        continueAsk: "Devam etmeye hazır mısınız?",
        continueConfirm: "Kalan sahneler oluşturulmaya devam edilsin mi?",
        rebuildWith: "Sahne 1'i şu notla yeniden oluştur: “{{note}}”",
        rebuildCost: "Bu işlem sahne 1'i yeniden oluşturur ve yeniden kredi harcar.",
        rebuild: "Yeniden oluştur",
        rebuildThisNote: "Bu notla yeniden oluştur",
        justAsk: "Sadece soru",
        optionSelect: "Seç",
        optionSelected: "Seçildi",
        requested: "İstendi",
        recommended: "Önerilen",
        seeAll: "Tümünü gör",
        seeAllTitle: "Sahne 1 için bir stil veya format seçin",
        tabStyles: "Stiller",
        tabFormats: "Formatlar",
        pickLoading: "Yükleniyor…",
        pickFailed: "Liste yüklenemedi — yeniden deneyin.",
        pickEmpty: "Burada gösterilecek bir şey yok.",
        pickConfirm: "{{name}} seç",
        variantN: "Varyant {{n}}",
        close: "Kapat",
        rebuildIn: "Sahne 1'i {{name}} ile yeniden oluştur",
        rebuildStyleAll: "Kalan sahneler de bu stili izleyecek.",
        noScene: "Oluşturma hiçbir sahne oluşturamadı.",
        noSceneVoice: "Ses hizmeti şu anda kullanılamıyor — başka bir ses seçip yeniden deneyin.",
        noSceneAgent: "Tasarım ajanı şu anda kullanılamıyor — biraz sonra yeniden deneyin.",
        noSceneGeneric: "Oluşturma sırasında bir sorun oluştu — yeniden deneyin.",
      },
      buildBrief: {
        title: "Eğitim özeti",
        objectives: "Öğrenme hedefleri",
        themes: "Temalar",
        scenes: "Sahneler ve anlatım",
        loading: "Eğitim tarifiniz yükleniyor…",
        fallback: "Kursunuz hazırlanıyor — tarif burada görünecek.",
        recipe: "Tarifiniz",
        recipeKeys: {
          flow: "Akış",
          format: "Görsel format",
          style: "Görsel stil",
          language: "Dil",
          length: "Süre",
          sceneCount: "Sahneler",
          voice: "Ses",
          brand: "Marka",
        },
        minutes: "{{count}} dakika",
        minutes_plural: "{{count}} dakika",
        sceneCount: "{{count}} sahne",
        sceneCount_plural: "{{count}} sahne",
        sceneN: "Sahne {{n}}",
      },
      tekno3: {
        composerNotEmpty: "Yazı alanı boş değil",
        chipTextMotions: "Metin hareketi ekle",
        chipVideoMotion: "Video hareketi ekle",
        chipTextMotionsPrompt: "Bu sahneye metin hareketleri ekle",
        chipVideoMotionPrompt: "Bu sahneye bir video hareketi ekle",
        quick: "Sahneyi incele",
        running: "tekno3 bu sahneyi inceliyor… bir dakika kadar sürebilir.",
        found: "tekno3 {{count}} sorun buldu.",
        found_plural: "tekno3 {{count}} sorun buldu.",
        clean: "tekno3 sorun bulmadı — sahne iyi görünüyor.",
        applyAll: "Tüm düzeltmeleri uygula ({{count}})",
        fix: "Düzelt",
        recheck: "Yeniden kontrol et",
        close: "Kapat",
        retry: "Tekrar dene",
        undo: "Geri al",
        applied: "{{count}} düzeltme uygulandı — tek bir Geri Al hepsini geri alır.",
        applied_plural: "{{count}} düzeltme uygulandı — tek bir Geri Al hepsini geri alır.",
        skipped: "{{count}} düzeltme uygulanamadı.",
        skipped_plural: "{{count}} düzeltme uygulanamadı.",
        undone: "Düzeltmeler geri alındı.",
        undoStale: "Sahne o zamandan beri değişti — editördeki Geri Al'ı (Ctrl+Z) kullan.",
        at: "{{sec}}. saniyede",
        frameAlt: "Sahneyi {{sec}}. saniyede göster",
        severity: { high: "Yüksek", med: "Orta", low: "Düşük" },
        category: {
          contrast: "Kontrast",
          overflow: "Taşan metin",
          safe_area: "Güvenli alan dışında",
          overlap: "Çakışma",
          min_font: "Yazı çok küçük",
          reading_speed: "Okuma hızı",
          bible: "Stil rehberi",
          timeline: "Zamanlama",
          media: "Medya",
          hierarchy: "Hiyerarşi",
          layout: "Yerleşim",
          typography: "Tipografi",
          colour_contrast: "Renk kontrastı",
          imagery: "Görseller",
          motion_timing: "Hareket zamanlaması",
          content_fit: "İçerik uyumu",
          accessibility: "Erişilebilirlik",
          other: "Diğer",
        },
        err: {
          failed: "İnceleme yapılamadı — tekrar dene.",
          busy: "tekno3 meşgul — biraz bekleyip tekrar dene.",
          tooLarge: "Bu sahne inceleme için gönderilemeyecek kadar büyük.",
          notFound: "Bu sahne incelenemiyor — eğitimi kaydedip tekrar dene.",
          timeout: "İnceleme çok uzun sürüyor — birazdan tekrar dene.",
        },
      },
      buildWait: {
        stages: {
          plan: "Eğitim planlanıyor",
          style: "Stil ve tasarım seçiliyor",
          voice: "Anlatım sesi hazırlanıyor",
          scene: "Sahne 1 oluşturuluyor · görseller ve yerleşim",
          ready: "Sahne 1 hazır",
          pause: "İncelemeniz için duraklatıldı",
          rest: "Kalan sahneler oluşturuluyor",
        },
        stagesTitle: "Yapay zekâ çalışma aşamaları",
        mindmap: "Zihin haritası",
        mindmapPreparing: "Zihin haritası hazırlanıyor…",
        mindmapClose: "İlerlemeye dön",
        progress: "Sahne {{done}}/{{total}}",
        progressDot: "Sahne {{n}}: {{title}}",
        agents: {
          planner: { name: "Planlayıcı", a: "sahneler çıkarılıyor…", b: "hikâye şekilleniyor…" },
          art: { name: "Sanat yönetmeni", a: "palet seçiliyor…", b: "stil eşleştiriliyor…" },
          narrator: { name: "Anlatıcı", a: "ses kaydediliyor…", b: "anlatım zamanlanıyor…" },
          designer: {
            name: "Tasarımcı",
            a: "sahne 1 yerleştiriliyor…",
            b: "görseller konumlanıyor…",
          },
        },
        wait: {
          title: "Siz beklerken",
          slide: "{{n}} / {{total}}",
          narration: "Anlatım · sahne {{n}}",
          flows: "Aidea'nın başka bir akışı",
          models: "Çalışan modeller",
          quote: "Üzerine düşünmeye değer",
          kind: {
            narration: "Anlatımı göster",
            flows: "Aidea'nın diğer akışlarını göster",
            models: "Çalışan modelleri göster",
            quotes: "Bir alıntı göster",
          },
          roles: {
            drafter: "Taslak yazarı (tarif, stil)",
            narrator: "Anlatıcı",
            planner: "Planlayıcı",
            sceneBuilder: "Sahne oluşturucu",
            motion: "Hareketli öğe",
          },
          effort: { low: "düşük", medium: "orta", high: "yüksek" },
        },
      },
      build: {
        title: "Eğitiminiz hazırlanıyor",
        titleDone: "Eğitiminiz",
        sceneReady: "Sahne {{n}} hazır",
        sceneFailed: "{{n}}. sahne oluşturulamadı — diğerleriyle devam ediyorum",
        done: "Eğitiminiz hazır — {{count}} sahne",
        none: "Hiç sahne oluşturulamadı. Sohbete dönüp yeniden deneyin.",
        stoppedBudget: "Ekip bütçesi aşıldı — yöneticinizle iletişime geçin",
        stoppedHold: "Yapım durduruldu, kredi ayrılamadı. Tekrar deneyin.",
        stoppedByUser: "Yapım durduruldu. Hazır sahneler korundu.",
        stop: "Durdur",
        stopConfirm: "Yapım durdurulsun mu? Biten sahneler kalır.",
        stopYes: "Evet, durdur",
        stopNo: "Devam et",
        stopping: "Mevcut sahneden sonra durduruluyor…",
        stopFailed: "Yapım durdurulamadı.",
        stoppedBalance: "Yapım durdu: sonraki sahne için kredi yetersiz.",
        expired: "Bu yapım tamamlandı",
        expiredEmpty:
          "Bu yapım sona erdi ve kaydedilmiş sahne yok. Yeniden başlatmak için konsoldaki sohbete dönün.",
        balanceCta: "Krediyi gör",
        connIssue: "Bağlantı sorunu, yeniden deneniyor…",
        chatClosed: "Sohbet bu kurs için kapandı",
        loadingChat: "Sohbet yükleniyor…",
        noToken: "Oturum bekleniyor — giriş yapılır yapılmaz yapıma bağlanacağım.",
        saveLocked: "Yapım sürüyor — kaydetme yapım bitince açılır",
        preview: "Göster",
        watch: "Baştan izle",
        showAgain: "{{n}}. sahneyi yeniden göster",
        ghost: "(hazırlanıyor)",
        canvas: {
          scene: "Sahne {{n}} / {{total}} hazırlanıyor",
          phase: {
            style_bible: "Görsel stil belirleniyor",
            plan: "Sahne planlanıyor",
            generate: "Görseller ve medya üretiliyor",
            compose: "Yerleşim oluşturuluyor",
            review: "Tasarım gözden geçiriliyor",
            fix: "Son rötuşlar yapılıyor",
            saved: "Hazır",
          },
        },
        step: {
          waiting: "Yapım hazırlanıyor…",
          narration: "Sahne {{n}} · seslendirme ve görseller üretiliyor",
          images: "Sahne {{n}} · görseller hazır",
          video: "Sahne {{n}} · bir an canlandırılıyor",
          motion: "Sahne {{n}} · hareketli grafikler tasarlanıyor",
          saving: "Sahne {{n}} · editöre yerleştiriliyor",
        },
        stepName: {
          narration: "seslendirme",
          images: "görseller",
          video: "video",
          motion: "hareket",
          saving: "kaydediliyor",
        },
        phase: {
          style_bible: "Eğitimin görsel dili tasarlanıyor…",
          plan: "Sahne {{n}} · anlatım vuruşları planlanıyor",
          generate: "Sahne {{n}} · görseller ve hareket üretiliyor",
          compose: "Sahne {{n}} · sahne kuruluyor",
          review: "Sahne {{n}} · önizleme kontrol ediliyor",
          fix: "Sahne {{n}} · ayrıntılar düzeltiliyor",
        },
        status: "Sahne {{n}} hazırlanıyor — {{step}}",
        hint: "Her sahne yaklaşık 2–4 dakika sürer",
        thumb: "{{n}}. görseli önizlemede göster",
        note: {
          plan_ready: "Hareket planı hazır",
          plan_failed: "Bu sahne hareketli grafiksiz",
          video_ready: "Video anı hazır",
          video_failed: "Sabit görsel kullanılacak",
        },
      },
      assistant: "Aidea Asistan",
      newThread: "Yeni Konuşma",
      newConversation: "Yeni konuşma",
      courseBuild: "Eğitim oluşturma",
      empty: "Boş",
      messages: "{{count}} mesaj",
      messagesPlural: "{{count}} mesaj",
      greetingTitle: "Merhaba!",
      greetingSubtitle: "Bugün sana nasıl yardımcı olabilirim?",
      placeholder: "Aidea'ya yaz…",
      hint: "Aidea hata yapabilir. Göndermek için Enter, yeni satır için Shift+Enter.",
      suggestions: {
        infographicTitle: "İnfografik sahne oluştur",
        infographicPrompt: "Ana noktaları özetleyen bir infografik sahne oluştur.",
        imageTitle: "Görsel oluştur",
        imagePrompt: "Ana kavramı anlatan bir görsel oluştur.",
        narrationTitle: "Anlatımı güncelle",
        narrationPrompt: "Bu sahnenin anlatımını güncelle.",
        avatarTitle: "Avatar ekle",
        avatarPrompt: "Bu sahneyi sunması için konuşan bir avatar ekle.",
        videoTitle: "Video oluştur",
        videoPrompt: "Bu sahne için bir video klip oluştur.",
        motionTitle: "Bu sahneyi hareketlendir",
        motionPrompt: "Bu sahneye hareketli grafikler ekle.",
      },
      motionEdit: {
        chip: "Düzenle",
        running: "Sahne düzenleniyor...",
        cancelled: "İptal edildi — sahne değişmedi.",
        failed: "Düzenleme yapılamadı — sahne olduğu gibi kaldı.",
        done: "Hazır. Aynı an, öncesi ve sonrası:",
      },
      motion: {
        appliedFromTray: "İş tepsisinden onaylandı — plan sahneye uygulandı.",
        declinedFromTray: "İş tepsisinden reddedildi — sahne değişmedi.",
        confirm:
          "Bu sahnenin görsellerinden ve anlatımından ekran yazıları, okunabilirlik katmanları ve ikonlar tasarla.",
        summary: "Bu sahnenin {{count}} görselinden ve anlatımından hareketli grafikler tasarla.",
        cost: "≤{{credits}} kredi",
        chip: "Hareket",
        design: "Hareketli grafik tasarla",
        cancel: "Vazgeç",
        cancelled: "Vazgeçildi — hiçbir şey tasarlanmadı.",
        designing:
          "Hareketli grafikler tasarlanıyor… 1–3 dakika sürebilir. Çalışmaya devam edebilirsin.",
        ready: "Hareketli grafik planı hazır — {{count}} öğe. Sahneye eklensin mi?",
        apply: "Sahneye uygula",
        applied: "Sahneye {{count}} öğe eklendi. Tek bir Geri Al hepsini kaldırır.",
        undo: "Geri al",
        failed: "Hareketli grafikler tasarlanamadı. Lütfen tekrar dene.",
        sceneMissing: "Bu sahne artık yok.",
        noImages: "Bu sahnede henüz görsel yok. Önce bir arka plan görseli ekle.",
        noTraining: "Önce bu eğitimi kitaplığından aç, sonra tekrar dene.",
        insufficientBalance: "Bunun için yeterli kredin yok. Kredi yükleyip tekrar dene.",
        timeout: "Beklenenden uzun sürüyor. Birkaç dakika sonra tekrar dene.",
        densityLabel: "Ekran yazıları",
        densityKey: "Önemli metinler",
        densityFull: "Tüm metinler",
        graphicsLabel: "Grafikler",
        graphicsMinimal: "Sade",
        graphicsBalanced: "Dengeli",
        graphicsRich: "Zengin",
        textLabel: "Görsellerdeki yazı",
        textAuto: "Aidea karar versin",
        textExtract: "Canlandır",
        textAdd: "Yeni yazı ekle",
        iconsLabel: "İkonlar",
        iconsAuto: "Aidea karar versin",
        iconsYes: "Evet",
        iconsNo: "Hayır",
        someKept: "Bazı görseller yazılarını korudu",
        adjusted: "{{count}} öğe okunabilirlik için ayarlandı.",
      },
      redesign: {
        chip: "Yeniden tasarım",
        summary: "Bu sahneyi {{format}} formatında (varyant {{variant}}) yeniden tasarla.",
        cost: "≤{{credits}} kredi",
        run: "Sahneyi yeniden tasarla",
        cancel: "Vazgeç",
        cancelled: "Vazgeçildi — sahne değişmedi.",
        running:
          "Sahne yeniden tasarlanıyor… birkaç dakika sürebilir. Çalışmaya devam edebilirsin.",
        done: "Sahne yeniden tasarlandı. Yeni sürüm sunucudan geldiği için geri alma geçmişi sıfırlandı.",
        failed: "Sahne yeniden tasarlanamadı. Lütfen tekrar dene.",
        sceneMissing: "Bu sahne artık yok.",
        noTraining: "Önce bu eğitimi kitaplığından aç, sonra tekrar dene.",
        busy: "Bu kurs için başka bir oluşturma sürüyor. Bitmesini bekle, sonra tekrar dene.",
        unsupported: "Bu sahne yeni bir formatta yeniden tasarlanamaz.",
        insufficientBalance: "Bunun için yeterli kredin yok. Kredi yükleyip tekrar dene.",
        timeout: "Beklenenden uzun sürüyor. Birkaç dakika sonra sahneyi kontrol et.",
        saveFailed:
          "Son değişikliklerin önce kaydedilemedi, bu yüzden yeniden tasarım başlatılmadı. Kaydedip tekrar dene.",
        tooLarge: "Bu sahne yeniden tasarlanamayacak kadar büyük.",
      },
      formats: {
        chip: "Sahne formatları",
        loading: "Formatlar aranıyor…",
        current: "Mevcut",
        currentLine: "Bu sahne şu formatta:",
        variant: "Varyant {{n}}",
        redesign: "Bu formatta yeniden tasarla",
        sent: "İstendi",
        redesignMessage:
          'Bu sahneyi "{{name}}" formatında yeniden tasarla (format: {{slug}}, varyant {{variant}}).',
        empty: "Bu sahne için format önerisi yok.",
        failed: "Format önerileri yüklenemedi.",
      },
    },
    scene: "Sahne",
    Delete: "Sil",
    Edit: "Düzenle",
    Copy: "Kopyala",
    Duplicate: "Çoğalt",
    Show: "Göster",
    Hide: "Gizle",
    Lock: "Kilitle",
    Unlock: "Kilidi Aç",
    layerOrder: {
      bringToFront: "Öne Getir",
      forward: "İleri",
      backward: "Geri",
      sendToBack: "Arkaya Gönder",
    },
    Add: "Ekle",
    add_to_scene: "Sahneye Ekle",
    HtmlContentAdd: "HTML İçerik Ekle",
    AddAnswer: "Cevap Ekle",
    Design: "Tasarım",
    Simulator: "Simülatör",
    bgPreset: {
      transparent: "Şeffaf",
      dark: "Koyu",
      navy: "Lacivert",
      white: "Beyaz",
      gray: "Gri",
    },
    All: "Tümü",
    Videos: "Videolar",
    Images: "Görseller",
    Audios: "Sesler",
    Skip: "Atla",
    No: "Hayır",
    PleaseWait: "Lütfen Bekleyin...",
    AnimationEntrance: "Giriş",
    AnimationExit: "Çıkış",
    ScreenTraining: "Ekran Eğitimi",
    CustomHtmlContent: "Özel HTML İçerik",
    DownloadMP4: "MP4 İndir",
    SharedUsers: "Paylaşılan Kullanıcılar",
    NoUsersAddedYet: "Henüz kullanıcı eklenmedi",
    InvitedOnly: "Sadece davet edilenler",
    TTS: {
      AddedToMyFiles: "Oluşturduğunuz ses 'Dosyalarım' a eklenmiştir.",
      AccessPreviousSounds:
        "Daha önce oluşturduğunuz seslere buradan ulaşabilir ya da kullanmadığınız sesleri silebilirsiniz.",
    },
    EditImage: {
      processing: "Görsel düzenleniyor…",
    },
    timeline: {
      mediaLoadFailed: "Medya yüklenemedi",
      mediaRetry: "Tekrar dene",
      addTrack: "Track Ekle",
      WaitingForInteractive: "Timeline interaktif element bekliyor",
      SkipInteractive: "Interaktifi atla ve timeline'ı devam ettir",
    },
    ScreenTrainingUseReadyTemplate: "Hazır ekran eğitimi şablonunu kullan",
    PickCustomColor: "Özel renk seç",
    SeekToStart: "Başa al",
    Pause: "Duraklat",
    ShowMediaAssets: "Medya Varlıklarını Göster",
    ZoomOut: "Uzaklaştır",
    ZoomReset: "Zoom'u sıfırla (%100)",
    ZoomIn: "Yakınlaştır",
    HideAll: "Tümünü Gizle",
    TimelineRowImages: "Görseller",
    TimelineRowVideos: "Videolar",
    TimelineRowAudios: "Sesler",
    TimelineRowTexts: "Metinler",
    ShowAll: "Tümünü Göster",
    LockAll: "Tümünü Kilitle",
    UnlockAll: "Tümünü Aç",
    SplitClipSourceSame: "Bölünmüş parça — kaynağı aynı",
    EntranceAnimation: "Giriş animasyonu",
    ExitAnimation: "Çıkış animasyonu",
    SplitAtPlayhead: "Playhead'den Böl",
    AlignToPrevious: "Önceki elemente hizala",
    AlignToNext: "Sonraki elemente hizala",
    OpenPanel: "Paneli Aç",
    ClosePanel: "Paneli Kapat",
    SplitAtPlayheadHint: "Klibi playhead'de iki parçaya böler",
    CutAndDelete: "Kes ve Sil",
    CutAndDeleteHint: "Playhead'e kadarki kısmı siler, kalanı başa çeker",
    CutPlayheadOutsideHint: "Önce playhead'i klibin içine getirin",
    OpenInVideoDirector: "Video Yönetmeninde Aç",
    PasteHtmlContentHere: "<div>HTML içeriğinizi buraya yapıştırın...</div>",
    FontCategory: {
      System: "Sistem",
      Accessible: "Erişilebilir",
      Handwriting: "El Yazısı",
      Other: "Diğer",
      Custom: "Özel",
    },
    InteractiveKind: {
      MCQ: "Çoktan Seçmeli",
      VisualImage: "Görsel",
    },
    InteractiveCategory: {
      Questions: "Sorular",
      Media: "Medya",
    },
    ElementType: {
      TextCard: "Metin Kartı",
      ImageCard: "Görsel Kart",
      VideoCard: "Video Kart",
      FlipCard: "Çift Yüzlü Kart",
      TrueFalse: "Doğru / Yanlış",
      MCQ: "Çoktan Seçmeli",
    },
    ClickToAddAnimation: "animasyon eklemek için tıklayın",
    ItemProps: {
      AlignLeft: "Sol",
      AlignCenter: "Orta",
      AlignRight: "Sağ",
      Kind: {
        VisualLabel: "Görsel Etiket",
        VisualImage: "Görsel",
        TrueFalse: "Doğru / Yanlış",
        YesNo: "Evet / Hayır",
        FlipCard: "Flip Kart",
        MCQ: "Çoktan Seçmeli",
        MultipleAnswer: "Çok Cevaplı",
        FillInBlank: "Boşluk Doldur",
        DragDrop: "Sürükle Bırak",
        Matching: "Eşleştirme",
        Ordering: "Sıralama",
        BranchingQuestion: "Dallanma Sorusu",
        EndScreen: "Bitiş Ekranı",
        DialogCards: "Diyalog Kartları",
        MemoryGame: "Hafıza Oyunu",
        DragTheWords: "Kelime Sürükle",
        FindTheWords: "Kelime Bul",
        ImageHotspots: "Sıcak Noktalar",
        QuestionSet: "Soru Seti",
        PersonalityQuiz: "Kişilik Testi",
        CoursePresentation: "Slayt Sunumu",
        SpeakTheWords: "Konuşarak Cevapla",
        ImageSequencing: "Görsel Sırala",
        SingleChoiceSet: "Tek Seçim Seti",
        DragQuestion: "Sürükle Soru",
        Essay: "Açık Uçlu Yazı",
        ShortLabel: "Etiket",
      },
      Action: {
        ShowItem: "Elementi göster",
        HideItem: "Elementi gizle",
        Resume: "Devam et (timeline)",
        Complete: "İnteraktifi tamamla",
        None: "None",
        ResumeLabel: "Devam Et",
        ResumeHint: "Timeline'ı sürdür",
        CompleteLabel: "Tamamla",
        CompleteHint: "Etkileşimi sonlandır",
        ShowItemLabel: "Elementi Göster",
        ShowItemHint: "Seçili öğeyi görünür yapar",
        HideItemLabel: "Elementi Gizle",
        HideItemHint: "Seçili öğeyi gizler",
        JumpSceneLabel: "Sahneye Git",
        JumpSceneHint: "Belirtilen sahneye atla",
      },
      SelectPlaceholder: "— Seç —",
      AddAction: "+ Eylem Ekle",
      AnswerActions: "Cevap Eylemleri",
      OnCorrect: "✓ Doğruysa",
      OnWrong: "✗ Yanlışsa",
      ClickActions: "Tıklama Eylemleri",
      OnClick: "👆 Tıklanınca",
      OnCorrectShort: "Doğruysa",
      OnWrongShort: "Yanlışsa",
      OnClickShort: "Tıklanınca",
      PromptDefault: "Soru / Açıklama",
      Text: "Metin",
      FontSize: "Yazı Boyutu",
      Color: "Renk",
      Alignment: "Hizalama",
      Bold: "Kalın (Bold)",
      ImageUrl: "Görsel URL",
      ObjectFit: "Sığdırma (Fit)",
      AltText: "Alt Metin",
      AltTextPlaceholder: "Erişilebilirlik açıklaması",
      Question: "Soru",
      CorrectAnswer: "Doğru Cevap",
      True: "Doğru",
      False: "Yanlış",
      TrueLabel: "'Doğru' Etiketi",
      FalseLabel: "'Yanlış' Etiketi",
      Yes: "Evet",
      No: "Hayır",
      YesLabel: "'Evet' Etiketi",
      NoLabel: "'Hayır' Etiketi",
      Options: "Seçenekler",
      Add: "+ Ekle",
      CorrectAnswerTitle: "Doğru cevap",
      AcceptedAnswers: "Kabul Edilen Cevaplar (virgülle ayırın)",
      CaseSensitive: "Büyük/küçük harf duyarlı",
      FrontFace: "Ön Yüz",
      BackFace: "Arka Yüz",
      Title: "Başlık",
      Subtitle: "Alt Başlık",
      ShowScore: "Skoru göster",
      QuestionInstruction: "Soru / Yönerge",
      PlaceholderText: "Placeholder Metin",
      MinWordCount: "Min. Kelime Sayısı",
      ComplexNote: "Bu element türü için ek ayarlar Workflow sekmesinden yönetilir.",
      AddClickAction: "Tıklanınca eylem ekle",
      AddCorrectAction: "Doğru cevap için eylem ekle",
      AddWrongAction: "Yanlış cevap için eylem ekle",
      InteractionPanel: "Etkileşim paneli",
      Interaction: "Etkileşim",
      Trigger: "Tetikleyici",
      ActionLabel: "Eylem",
      Target: "Hedef",
      NoDisplayableItems: "Görüntülenebilir öğe yok",
      Scene: "Sahne",
      SelectScene: "— Sahne seç —",
      NoScenesFound: "Sahne bulunamadı",
      GoToScene: "Sahneye git",
    },
    filter_by_scene: "Sahneye göre filtrele",
    all_files: "Tüm Dosyalar",
    no_scene_media: "Bu sahnede medya yok",
    Tools: "Araçlar",
    PointerEvents: "İşaretçi Olayları",
    Crop: "Kırp",
    Border: "Kenarlık",
    RemoveBackground: "Arka Planı Sil",
    ChromaKey: "Renk Fonu Sil",
    PickColor: "Renk seç",
    ClickToPickColor: "Silinecek rengi seçmek için resme tıklayın",
    ConfirmRemoveBg: "Onayla",
    ClearPickedColor: "Rengi temizle",
    RemoveBgHint: "Renk fonu seçmeden onaylarsan arka plan otomatik silinir",
    ImageAdjustments: "Renk ayarları",
    WhiteBalance: "Beyaz dengesi",
    Temperature: "Sıcaklık",
    Tint: "Renk Tonu",
    Light: "Aydınlık",
    Brightness: "Parlaklık",
    Contrast: "Kontrast",
    Color: "Renk",
    Vibrance: "Canlılık",
    Saturation: "Doygunluk",
    Invert: "Ters çevir",
    Texture: "Doku",
    Blur: "Bulanıklık",
    ResetAdjustments: "Ayarları sıfırla",
    Tolerance: "Tolerans",
    BorderWidth: "Kenarlık kalınlığı",
    BorderStyle: "Kenarlık stili",
    BorderColor: "Kenarlık rengi",
    BorderRadius: "Köşe yuvarlaklığı",
    QuickBorder: "Hızlı çerçeve",
    None: "Yok",
    Sharp: "Keskin",
    Rounded: "Yuvarlak",
    Soft: "Yumuşak",
    Pill: "Hap",
    Circle: "Tam yuvarlak",
    Dashed: "Kesikli",
    Dotted: "Noktalı",
    Padding: "İç boşluk",
    Left: "Sol",
    Right: "Sağ",
    Top: "Üst",
    Bottom: "Alt",
    Reset: "Sıfırla",
    BackgroundColor: "Arka plan rengi",
    Confirm: "Onayla",
    Opacity: "Opaklık",
    Cropping: "Kırpılıyor...",
    DragToCrop: "Kırpmak için bir alan seçin",
    CropFailed: "Kırpma başarısız",
    RestoreOriginalImage: "Görseli orijinal haline döndür",
    RestoreOriginalImageHint: "Kırpmayı geri al ve orijinal görseli geri getir",
    Free: "Serbest",
    AspectRatio: "En-Boy Oranı",
    JobFailed: "İşlem başarısız",
    JobTimedOut: "İşlem zaman aşımına uğradı",
    Filters: "Filtreler",
    FilterGroupNatural: "Doğal",
    FilterGroupWarm: "Sıcak",
    FilterGroupCold: "Soğuk",
    FilterFresh: "Taze",
    FilterVivid: "Seyirlik",
    FilterFlint: "Çakmaktaş",
    FilterLuna: "Luna",
    FilterSky: "Gökyüzü",
    FilterNoir: "Karartı",
    FilterTropic: "Tropik",
    FilterSun: "Güneş",
    FilterLatte: "Latte",
    FilterBronze: "Bronz",
    FilterSand: "Kum",
    FilterGrape: "Üzüm",
    FilterIce: "Buz",
    FilterPolar: "Polar",
    FilterNight: "Gece",
    FilterMist: "Sis",
    FilterOcean: "Okyanus",
    FilterSteel: "Çelik",
    FilterRetro: "Retro",
    FilterGroupVivid: "Canlı",
    FilterGroupSoft: "Yumuşak",
    FilterGroupVintage: "Vintage",
    FilterScandinavian: "İskandinav",
    FilterNordic: "Nordic",
    FilterAstro: "Astro",
    FilterArctic: "Arktik",
    FilterTundra: "Tundra",
    FilterSaturated: "Doygun",
    FilterRural: "Kırsal",
    FilterEffort: "Gayret",
    FilterArya: "Arya",
    FilterHarsh: "Sert",
    FilterAura: "Aura",
    FilterEla: "Ela",
    FilterDreamy: "Hayali",
    FilterRose: "Gül Rengi",
    FilterCloud: "Bulut",
    FilterVinto: "Vinto",
    FilterFade: "Solma",
    FilterOld: "Eski",
    FilterNostalgic: "Nostaljik",
    FilterDream: "Rüya",
    FilterIntensity: "Yoğunluk",
    FilterGroupMono: "Mono",
    FilterGroupColorBurst: "Renk Patlaması",
    FilterClassic: "Klasik",
    FilterInk: "Mürekkep",
    FilterPitchBlack: "Kapkara",
    FilterFilm: "Film",
    FilterNewspaper: "Gazete",
    FilterBlackboard: "Kara Tahta",
    FilterLimitless: "Sınırsız",
    FilterHeatwave: "Sıcak Hava Dalgası",
    FilterAmethyst: "Ametist",
    FilterMinty: "Nanemsi",
    FilterHollyhock: "Hatmi Çiçeği",
    FilterPoster: "Afiş",
    FilterGroupCinematic: "Sinematik",
    FilterTeal: "Turkuaz",
    FilterNoirBlue: "Gece Mavisi",
    FilterAmber: "Kehribar",
    FilterThriller: "Gerilim",
    FilterWestern: "Western",
    FilterEpic: "Destansı",
    FilterGroupPastel: "Pastel",
    FilterPastelPink: "Pembe",
    FilterPastelBlue: "Mavi",
    FilterPastelMint: "Nane",
    FilterPastelLavender: "Lavanta",
    FilterPastelPeach: "Şeftali",
    FilterPastelPowder: "Pudra",
    FilterGroupNeon: "Neon",
    FilterCyber: "Siber",
    FilterElectric: "Elektrik",
    FilterNeonMagenta: "Macenta",
    FilterAcid: "Asit",
    FilterPlasma: "Plazma",
    FilterLaser: "Lazer",
    NarrationDraft: {
      Badge: "Taslak",
      GeneratingInfo:
        "Ses arka planda oluşturuluyor. Başka sahneye geçebilirsiniz; hazır olunca burada taslak olarak bekler.",
      ReadyInfo:
        "Düzenlenmiş metin ve ses taslakta bekliyor. Bu sahneyi onaylayın veya taslağı atın.",
      EditedInfo: "Metin ses üretildikten sonra değişti. Onaylamak için sesi yeniden oluşturun.",
      Approve: "Onayla",
      ApproveHint: "Yalnızca bu sahneye uygula",
      SaveAll: "Tümünü kaydet",
      SaveAllWaitGenerating: "Oluşturulan ses bitene kadar tümü kaydedilemez.",
      ApproveAllPartial:
        "{{ready}}/{{total}} taslak hazır; diğerleri üretiliyor veya metni değişmiş.",
      ShowOriginal: "Orijinali göster",
      ShowDraft: "Taslağı göster",
      Discard: "Taslağı at",
      SceneHasDraft: "Bu sahnede kaydedilmemiş anlatım taslağı var",
    },
    NarrateScope: {
      Title: "Sesi nereye uygulayalım?",
      Description:
        "Oluşturduğunuz bu sesi yalnızca bu sahneye mi, yoksa tüm sahnelere mi uygulamak istersiniz?",
      ThisScene: "Sadece bu sahne",
      ThisSceneDesc: "Bu ses yalnızca bu sahneye kaydedilir.",
      AllScenes: "Tüm sahneler",
      AllScenesDesc: "Bu ses tüm sahnelere uygulanır ve her sahne yeniden seslendirilir.",
      AllScenesDescCount: "Bu ses {{count}} sahneye uygulanır ve her biri yeniden seslendirilir.",
      Recommended: "Önerilen",
      NarrateAllCheckbox: "Tüm sahneleri seslendir",
      ConfirmTitle: "Tüm sahneleri seslendir",
      ConfirmDesc:
        "Bu ses tüm sahnelere uygulanacak ve her sahne yeniden seslendirilecek. Devam etmek istediğinize emin misiniz?",
      ConfirmDescCount:
        "Bu ses {{count}} sahneye uygulanacak ve her biri yeniden seslendirilecek. Devam etmek istediğinize emin misiniz?",
      ConfirmButton: "Evet, seslendir",
      Applying: "Başlatılıyor...",
      StartedTitle: "Seslendirme başlatıldı",
      Started: "Seslendirme işlemi başlatıldı ({{count}} sahne). İşlem arka planda tamamlanacak.",
      NoScenes: "Seslendirilecek metni olan sahne bulunamadı.",
      Error: "Seslendirme başlatılamadı. Lütfen tekrar deneyin.",
      Progress: "Seslendiriliyor... %{{progress}}",
      DoneTitle: "Seslendirme",
      Done: "{{count}} sahne yeniden seslendirildi.",
      PartialDone: "{{success}} sahne güncellendi, {{failed}} sahne başarısız.",
      Failed: "Seslendirme başarısız oldu.",
      Timeout: "İşlem zaman aşımına uğradı.",
    },
    AnimateScope: {
      AnimateSceneButton: "Seçilenleri canlandır",
      AnimateAllButton: "Tümünü canlandır ({{count}})",
      ConfirmDescCount:
        "Bu işlem tüm sahnelerdeki {{count}} infografik görseli canlandıracak ({{alreadyAnimated}} tanesi zaten canlandırılmış).",
      ConfirmSceneDescCount: "Bu işlem, bu sahnedeki {{count}} infografik görseli canlandıracak.",
      WarningNotRevertable: "Başladıktan sonra geri alınamaz.",
      WarningCancelCharges: "İptal etmek, devam etmekte olan klipleri yine de faturalandırır.",
      Applying: "Başlatılıyor...",
      AlreadyAnimatedBadge: "Canlandırılmış",
      StartButton: "Başlat",
      NoImages: "Bu eğitimde infografik görsel bulunamadı.",
      ProgressOf: "{{total}} görselden {{done}} tanesi tamamlandı",
      CancelButton: "İptal",
      CancelConfirm:
        "Bu işlem grubunu durdurur. Devam eden klipler yine de tamamlanır ve faturalandırılır.",
      ResumeButton: "Devam ettir",
      ResetButton: "Tümünü sıfırla",
      ApplyButton: "Sahnelere uygula",
      ApplyingAll: "Uygulanıyor...",
      PreviewButton: "Önizle",
      ItemRunning: "Canlandırılıyor…",
      ItemFailed: "Başarısız",
      BlockedTitle: "Toplu canlandırma işlemi devam ediyor",
    },
    AnimatorPanel: {
      Retry: "Tekrar Dene",
      ApplyToScene: "Bu sahneye uygula",
      NotAnimated: "Canlandırılmamış",
      SelectForAnimate: "Canlandırmak için seç",
      NoAnimatableImages: "Bu sahnede canlandırılacak fotoğraf yok",
      SceneProgress: "{{animated}}/{{total}}",
      SourceInfographic: "İnfografik",
      SourceAllImages: "Tüm görseller",
      UnsupportedFormatReason: "Desteklenmeyen format",
      RevertButton: "Geri Al",
      RevertToImage: "Görsele geri döndür",
      RevertConfirm: "Orijinal görsele geri dönülsün mü?",
      RevertNotFound: "Orijinal görsel bulunamadı — bu öğe geri alınamıyor.",
      UnsavedNotice: "Kaydedilmemiş değişiklikler bu listede henüz yok — eklemek için kaydedin.",
      RefreshList: "Listeyi yenile",
      SaveAndRefresh: "Kaydet ve yenile",
      SaveError: "Değişiklikleriniz kaydedilemedi. Liste hâlâ son kaydettiğiniz sürümü gösteriyor.",
      AnimateButton: "Canlandır",
      ReanimateButton: "Yeniden Canlandır",
      BackToPanel: "Geri",
      ProviderLabel: "Model",
      AppliedBadge: "Uygulandı",
      NarrationLabel: "Anlatım",
      Play: "Oynat",
      Pause: "Durdur",
      NoNarration: "Bu sahne için anlatım yok",
      TimeRange: "{{start}}–{{end}} sn",
      WholeScene: "tüm sahne",
      PredictedDuration: "{{sec}} sn animasyon",
    },
    activity_log: {
      menu_label: "Aktivite Geçmişi",
      title: "Aktivite Geçmişi",
      hint: "Bu eğitim için harcanan kredilerin dökümü.",
      total_spent: "Toplam harcanan",
      total_count: "İşlem sayısı",
      col_date: "Tarih",
      col_operation: "İşlem",
      col_user: "Kullanıcı",
      col_amount: "Kredi",
      empty: "Bu eğitim için henüz bir kredi hareketi yok.",
      error: "Kayıtlar yüklenemedi.",
      retry: "Tekrar dene",
      refresh: "Yenile",
    },
    localDraft: {
      title: "Yerel çalışma bulundu",
      body: "Bu eğitim için kaydedilmemiş yerel bir çalışma bulundu ({{savedAt}}). Görmek ister misiniz?",
      serverNewer:
        "Sunucuda bu yerel kopyadan daha yeni bir kayıt var; yerel çalışmayı açıp kaydederseniz çakışma uyarısı alırsınız.",
      open: "Yerel çalışmayı aç",
      useServer: "Sunucudaki sürümle devam et",
      discardTitle: "Yerel çalışma silinsin mi?",
      discardBody: "Yerel kopya kalıcı olarak silinecek ve sunucudaki sürüm kullanılacak.",
      discard: "Yerel çalışmayı sil",
      keep: "Vazgeç",
      loadedNotice: "Yerel çalışma yüklendi — kaydetmeyi unutmayın.",
      targetRemovedNotice: "Özgün görsel kaldırılmış — video yeni bir öğe olarak eklendi.",
      quotaWarning: "Yerel yedek kaydedilemedi: tarayıcı depolama alanı dolu.",
    },
    navbar: {
      credits: "kredi",
      creditsInfo: {
        title: "Kalan kredi",
        body: "Bu, bu eğitimin kredisinin düşüldüğü kuruluşun kalan toplam kredisidir. Yalnızca bu eğitim için harcananı değil, tüm hesabın kullanılabilir bakiyesini gösterir.",
        bodyMember:
          "Bu, {{team}} ekibinde size bu ay ayrılan kredinin kalanıdır. Limit {{date}} tarihinde yenilenir.",
        bodyTeam:
          "Bu, {{team}} ekibinin bu ay kullanabileceği kalan kredidir; ekipteki diğer kişilerle ortak kullanılır. Limit {{date}} tarihinde yenilenir.",
      },
      autosave: {
        label: "Otomatik kaydet",
        prompt:
          "Bu oturum için otomatik kaydetmeyi açmak ister misiniz? Değişiklik olduğunda 2 dakikada bir otomatik kaydedilir.",
        enable: "Etkinleştir",
        notNow: "Şimdi değil",
        pulseTooltip: "Kaydedilmemiş değişiklikler — kaydetmek için tıklayın",
      },
    },
    aideaSmartElements: "Aidea Akıllı Öğeler",
    aideaSmartElementsProcessing: "Görsel ayrıştırılıyor...",
    aideaSmartElementsFailed: "Bu görsel ayrıştırılamadı",
    aideaSmartElementsNoSubjects: "Görselde alt öğe tespit edilemedi",
    aideaSmartElementsUngroup: "Gruptan Çıkar",
    colorPicker: {
      color: "Renk",
      alpha: "Opaklık: {{value}}%",
      preview: "Ön izleme",
      save: "Kaydet",
    },
    knollingView: {
      title: "Medya Varlıkları",
      categories: "Kategoriler",
      currentSceneOnly: "Sadece bu sahne",
      all: "Tümü",
      videos: "Videolar",
      images: "Görseller",
      audios: "Sesler",
      noMedia: "Henüz medya varlığı bulunmuyor.",
      preview: "Önizle",
      goToScene: "Sahneye Git",
      play: "Oynat",
      pause: "Duraklat",
    },
    InsufficientBalance: {
      Title: "Yetersiz Bakiye",
      Description: "Krediniz bitti. Yeni kredi için bizimle iletişime geçin.",
      RequestedAmount: "İstenen kredi",
      CurrentBalance: "Mevcut bakiye",
      ContactUs: "Bizimle İletişime Geçin",
      Close: "Kapat",
      UnitMinutes: "dakika",
      UnitCredits: "kredi",
      MessageLabel: "Mesajınız",
      MessagePlaceholder: "Mesajınızı buraya yazın...",
      Send: "Gönder",
      Sending: "Gönderiliyor...",
      SubmitError: "Mesajınız gönderilirken bir hata oluştu. Lütfen tekrar deneyin.",
      MessageSentDescription: "Talebiniz ekibimize iletildi. En kısa sürede size dönüş yapacağız.",
      TeamTitle: "Takım bütçeniz doldu",
      TeamDescription:
        "{{team}} takımının bu ayki kredi bütçesi bu işlem için yetmiyor. Bütçe {{date}} tarihinde yenilenir; daha önce ihtiyacınız varsa organizasyon yöneticinizle görüşün.",
      TeamRemaining: "Kalan takım bütçesi",
      YourTeam: "Takımınız",
      Failed: "Kredi kontrolü başarısız oldu",
    },
    appModal: {
      showScene: "Sahneyi gör",
      showPanel: "Paneli göster",
    },
    authRequired: {
      title: "Tekrar giriş yapmanız gerekiyor",
      description:
        "Oturumunuzun süresi doldu veya doğrulanamadı. Devam etmek için tekrar giriş yapın.",
      loopDescription:
        "Çok fazla giriş denemesi yapıldı — lütfen sayfayı yenileyin veya kısa süre sonra tekrar deneyin.",
      authenticate: "Giriş yap",
      hardRefresh: "Sayfayı yenile",
      goBack: "Eğitime geri dön",
      serverErrorTitle: "Editör yüklenemedi",
      serverErrorDescription:
        "Sunucuya şu anda ulaşılamıyor. Yeniden denemek için sayfayı yenileyin.",
      runtimeErrorTitle: "Bağlantı sorunu",
      runtimeErrorDescription:
        "Sunucuya ulaşılamadı. Lütfen bağlantınızı kontrol edip tekrar deneyin.",
      crashTitle: "Editörde bir hata oluştu",
      crashDescription:
        "Bir görüntüleme hatası oluştu — bu bir oturum açma sorunu değil. Yeniden denemek için sayfayı yenileyin; sorun devam ederse aşağıdaki mesajı paylaşın.",
    },
    serverErrorToast: {
      message: "Sunucu hatası — lütfen biraz bekleyip tekrar deneyin.",
    },
    styleClipboard: {
      copy: "Stili kopyala",
      copied: "Stil kopyalandı",
      title: "Kopyalanan stil",
      ready: "Uygulamaya hazır",
      hint: "Uygulanacak elementleri seçin",
      apply: "Uygula",
      chip_box: "Kutu",
      chip_text: "Metin",
      chip_image: "Görsel ayarı",
      kind_text: "Metin",
      kind_image: "Görsel",
      kind_video: "Video",
      kind_other: "Öğe",
      details: "Kopyalanan stili göster",
      details_hide: "Detayları gizle",
      group_box: "Kutu",
      group_text: "Metin",
      group_pose: "Duruş",
      group_image: "Görsel ayarı",
      group_animation: "Efekt",
      row_background: "Arka plan",
      row_border: "Kenarlık",
      row_radius: "Köşe",
      row_padding: "Dolgu",
      row_opacity: "Opaklık",
      row_filter: "Filtre",
      row_font: "Yazı tipi",
      row_size: "Punto",
      row_weight: "Biçim",
      row_align: "Hizalama",
      align_left: "Sola",
      align_center: "Ortala",
      align_right: "Sağa",
      align_justify: "İki yana yasla",
      value_on: "Var",
      row_color: "Renk",
      row_highlight: "Vurgu",
      row_rotation: "Döndürme",
      row_flip: "Yansıtma",
      row_preset: "Ön ayar",
      row_intensity: "Yoğunluk",
      row_entry: "Giriş",
      row_exit: "Çıkış",
      value_none: "Yok",
      value_default: "Varsayılan",
      value_transparent: "Şeffaf",
      value_flip_h: "Yatay",
      value_flip_v: "Dikey",
      value_delay: "gecikme",
      chip_pose: "Duruş",
      chip_animation: "Efekt",
      clear: "Stil panosunu temizle",
      applied: "Stil {{n}} elemente uygulandı",
      applied_skipped:
        "Stil {{n}} elemente uygulandı · {{skipped}} element farklı türde olduğu için atlandı",
    },
    Layers: "Katmanlar",
    Elements: "Öğeler",
    Assessments: "Sorular",
    Interactive: "Etkileşim",
    Library: "Kütüphane",
    Audio: "Bilgi Bankası",
    aiToolsMenu: "Yapay Zeka Araçları",
    AddImage: "Görsel Ekle",
    ReferenceImages: "Referans Görseller",
    LoadingCourseReferenceImages: "Eğitimin referans görselleri yükleniyor...",
    UploadFromComputer: "Bilgisayardan Yükle",
    SelectFromLibrary: "Kütüphaneden Seç",
    AddTagPlaceholder: "Etiket ekle...",
    AddVideo: "Video Ekle",
    AddSound: "Ses Ekle",
    SaveAndAdd: "Kaydet ve Ekle",
    AddAvatar: "Avatar Ekle",
    AddPdf: "PDF Ekle",
    SoundSound: "Anlatım Sesi",
    ChooseFromLibrary: "Kütüphaneden Seç",
    GenerateImage: "Görsel Oluştur",
    GenerateInfographicImage: "İnfografik Görsel Oluştur",
    MotionizeScene: "Sahneden Motion Oluştur",
    MotionizeBlocked: "Bu sahnede",
    MotionizeBlockedTail: "var — sahnede yalnızca anlatım ve görsel olmalı",
    MotionizeWorking: "Sahne animasyona dönüştürülüyor...",
    ReviewMotionScene: "Üretilen motion sahne",
    MotionizeHint:
      "Sahnenin anlatımı ve görselleri kullanılarak tamamen kodla çizilen hareketli bir sahne üretilir. Görseller birebir kopyalanmaz; konuyu ve görsel dünyayı anlatmak için örnek alınır. Hareketler anlatımın kelime zamanlamalarına oturur.",
    MotionizeReferences: "Referans görseller",
    GenerateNewScene: "Yeni Sahne Oluştur",
    InfographicScene: "İnfografik Sahne",
    Animator: "Animatör",
    "AI Agent": "Yapay Zeka Asistanı",
    QuestionGenerator: {
      Title: "Soru Üretici",
      TabSingle: "Tek Sahneden",
      TabCombined: "Çoklu Anlatımdan",
      TabInteractive: "İnteraktif",
      IncludeScene: "Soruya dahil et",
      CombinedNarrations: "Seçili Anlatımlar",
      SelectScenesHint: "Sol listeden en az bir sahne seçin.",
      QuestionType: "Soru Tipi",
      MultipleChoice: "Çoktan Seçmeli",
      MultipleAnswer: "Çok Cevaplı",
      FreeResponse: "Açık Uçlu",
      FillInBlank: "Boşluk Doldurma",
      Matching: "Eşleştirme",
      Ordering: "Sıralama",
      SelectScenes: "Sahne Seçimi",
      QuestionCount: "soru",
      UseThisScene: "Bu sahneden soru üret",
      EnableSceneHint: "Bu sahneden soru üretmek için sahnenin anahtarını açın.",
      Review: "Üretilen sorular",
      GeneratingQuestions: "Sorular üretiliyor...",
      NoQuestionsGenerated: "Soru üretilemedi.",
      ErrorOccurred: "Bir hata oluştu",
      CorrectMark: "Doğru",
      History: "Geçmiş",
      NoHistory: "Geçmiş soru yok.",
      PendingApproval: "Onay bekliyor",
      Added: "Eklendi",
      AddedForScene: "Bu sahneye eklenen soru",
      AlreadyInTraining: "Eğitimde mevcut",
      ApproveThisQuestion: "Soruyu onaylıyorum",
    },
    InteractiveScenario: {
      Type: {
        VisualText: "Metin Kartı",
        VisualImage: "Görsel Kart",
        VideoCard: "Video Kart",
        FlipCard: "Çift Yüzlü Kart",
        TrueFalse: "Doğru / Yanlış",
        MCQ: "Çoktan Seçmeli",
      },
      ButtonStyle: {
        Primary: "Birincil",
        Secondary: "İkincil",
        Success: "Başarı",
        Danger: "Tehlike",
      },
      Label: {
        Buttons: "Butonlar",
        Content: "İçerik",
        Image: "Görsel",
        Description: "Açıklama",
        ImageClickAction: "Görsele tıklama aksiyonu",
        Video: "Video",
        Autoplay: "Otomatik oynat",
        FrontFace: "Ön Yüz",
        BackFace: "Arka Yüz",
        BackgroundColor: "Arkaplan rengi",
        FrontFaceBackground: "Ön yüz arkaplan",
        BackFaceBackground: "Arka yüz arkaplan",
        TextColor: "Yazı rengi",
        FrontFaceTextColor: "Ön yüz yazı rengi",
        BackFaceTextColor: "Arka yüz yazı rengi",
        FlipAction: "Çevirince tetiklenen aksiyon",
        ActionButtonOptional: "Aksiyonlu buton (isteğe bağlı)",
        CorrectAnswer: "Doğru cevap:",
        CorrectActions: "Doğru Aksiyonlar",
        IncorrectActions: "Yanlış Aksiyonlar",
        BackActions: "Arka Aksiyonlar",
        Title: "Başlık",
        Start: "BAŞLANGIÇ",
        SceneTitle: "Sahne Başlığı",
        Background: "Arka Plan",
        Pattern: "Desen",
        HiddenStarts: "Gizli başlar",
        VisibleStarts: "Görünür başlar",
        Hidden: "Gizli",
        SceneCountSuffix: "sahne",
        StartTitleCase: "Başlangıç",
        ElementCountSuffix: "element",
        ClickToFlip: "Çevirmek için tıkla",
      },
      Action: {
        SelectFromLibrary: "Kütüphaneden Seç",
        AddButton: "+ Buton Ekle",
        ChangeImage: "Görseli Değiştir",
        AddImage: "Görsel Ekle",
        RemoveImage: "Görseli kaldır",
        AddChoice: "+ Seçenek Ekle",
        AddElement: "+ Element Ekle",
        MakeStart: "Başlangıç Yap",
        AddAction: "+ Aksiyon Ekle",
        AddScene: "Sahne Ekle",
        DeleteScene: "Bu sahneyi sil",
        DeleteAction: "Aksiyonu sil",
        OK: "Tamam",
      },
      Placeholder: {
        ButtonLabel: "Buton etiketi",
        OrEnterUrl: "veya URL gir…",
        ImageDescriptionOptional: "Görsel açıklaması (isteğe bağlı)",
        VideoDescriptionOptional: "Video açıklaması (isteğe bağlı)",
        Title: "Başlık",
        Text: "Metin",
        Question: "Soru",
        TrueLabel: "Doğru",
        FalseLabel: "Yanlış",
        TrueLabelDetailed: "Doğru etiketi",
        FalseLabelDetailed: "Yanlış etiketi",
        ExplanationOptional: "Açıklama (isteğe bağlı)",
        ChoiceText: "Seçenek metni",
        ElementTitle: "Element başlığı",
        AlertMessage: "Bildirim metni",
        Value: "Değer",
        AddImageHint: "Görsel ekleyin",
        AddVideoHint: "Video ekleyin",
      },
      Default: {
        Button: "Buton",
        Title: "Başlık",
        Text: "Metin",
        Continue: "Devam",
        FrontTextHint:
          "Kartın ön yüzüne bir ipucu veya soru yazın. Kullanıcı kartı çevirerek cevabı öğrenir.",
        BackTitle: "Cevap",
        BackTextHint: "Kartın arka yüzüne açıklamayı veya doğru cevabı yazın.",
        QuestionHint:
          "Buraya sorunuzu yazın. Kullanıcı Doğru veya Yanlış seçeneğini seçerek cevap verir.",
        MCQQuestionHint: "Buraya sorunuzu yazın. Aşağıdaki seçeneklerden doğru olanı işaretleyin.",
        ExplanationHint: "Doğru cevabın açıklamasını buraya yazın.",
        Choice1: "Birinci seçenek",
        Choice2: "İkinci seçenek",
        Choice3: "Üçüncü seçenek",
        NewScene: "Yeni Sahne",
        NewScenario: "Yeni Senaryo",
      },
      Badge: {
        VisualText: "Anlatım & Aksiyon Kartı",
        VisualImage: "Görsel Kart",
        VideoCard: "Video Kart",
        FlipCard: "Çift Yüzlü Kart",
        TrueFalse: "Doğru / Yanlış",
        MCQ: "Çoktan Seçmeli Soru",
      },
      ActionType: {
        Navigate: "Sahneye Git",
        SetElementVisibility: "Element Göster/Gizle",
        Alert: "Bildirim",
        SetVariable: "Değişken Güncelle",
        EndScenario: "Senaryoyu Bitir",
      },
      ActionOperator: {
        Set: "Ata (=)",
        Add: "Ekle (+=)",
        Subtract: "Çıkar (-=)",
        Toggle: "Toggle",
      },
      Visibility: {
        Show: "Göster",
        Hide: "Gizle",
        Toggle: "Değiştir (toggle)",
      },
      Option: {
        True: "Doğru",
        False: "Yanlış",
        SelectScene: "— sahne seç —",
        SelectElement: "— element seç —",
        SelectVariable: "— değişken —",
      },
      Empty: {
        Title: "Senaryo bulunamadı",
        Description: "Bu element için yeni bir senaryo oluştur",
        Create: "Senaryo Oluştur",
        NoElementsInScene: "Bu sahnede element yok",
        AddElementFromPanel: "Sağ panelden element ekle",
        NoScenesYet: "Henüz sahne yok",
        StartByAddingFirstScene: "İlk sahneyi ekleyerek başla",
        AddElementFromTopHint: "Yukarıdan element ekle, kanvasta konumlandır.",
      },
      EndScreen: {
        Title: "İnteraktif tamamlandı",
        Restart: "Baştan Başla",
      },
    },
    SceneAudioVoice: "Sahne Sesi",
    NarratorSettings: "Anlatıcı Ayarları",
    OrganizationStyle: "Organizasyon Stili",
    UsedPromptInCourse: "Bu Kursta Kullanılan Özel Stil",
    Generate: "Oluştur",
    Regenerate: "Yeniden Oluştur",
    Generating: "Oluşturuluyor...",
    WriteYourNarration: "Anlatım metninizi yazın...",
    GenerateSceneHint: "(Seçtiğiniz sahneden sonraki sahneye tamamen hazır yeni sahne ekler)",
    ImageText: "Görsel Metni",
    WriteImageText: "Görsele dönüştürmek istediğiniz metni yazın...",
    GenerateImageHint: "(Sadece 1 adet infografik görsel ekler mevcut sahneye)",
    GenerateScene: "Sahne Oluştur",
    GenerateFromNarration: "Anlatımdan Oluştur",
    GenerateFromNarrationHint:
      "(Varolan sahnenizdeki görseller yeni görsellerle değiştirilir. Eğer kaybetmek istemiyorsanız lütfen boş bir sahnede çalışın.)",
    GenerateFromNarrationNewHint: "(Mevcut sahneden sonra yeni bir sahne olarak eklenir.)",
    ApplyToCurrentScene: "Mevcut sahneye ekle",
    CreateAsNewScene: "Yeni sahne oluştur",
    ReviewGeneratedImages: "Üretilen görseller",
    GeneratingScene: "Sahne üretiliyor...",
    GeneratingImage: "Görsel üretiliyor...",
    ToCurrentScene: "mevcut sahne",
    AsNewScene: "yeni sahne",
    Approve: "Onayla",
    Close: "Kapat",
    Discard: "Vazgeç",
    Play: "Oynat",
    Pause: "Durdur",
    NoSoundInScene: "Bu sahnede henüz ses bulunmuyor.",
    RestoreNarrationText: "Anlatım metnini getir",
    CreateEmptySceneAndSound: "(Önce boş bir sahne ve ses oluşturun)",
    CreateAudio: "Ses Oluştur",
    CreatingAudio: "Ses Oluşturuluyor...",
    AIGenerate: "AI İle Oluştur",
    UploadMyImage: "Görsel Yükle",
    ImageEdit: {
      Scope: "Kapsam",
      RemoveAllText: "Tüm Metni Sil",
      RemoveSelectedText: "Seçili Metinleri Sil",
      TranslateAllText: "Tüm Metni Çevir",
      TranslateSelectedText: "Seçili Metinleri Çevir",
      TargetTexts: "Hedef Metinler",
      TargetTextPlaceholder: "Metin (örn. İNDİRİM)",
    },
    // Görsel Ekle'nin iki üretken sekmesi: prompttan 3B obje ve hareketli görsel.
    SceneVisual: {
      Output: "Çıktı",
      OutputMotion: "Standart",
      OutputGif: "GIF",
      OutputWebp: "WebP",
      OutputMp4: "MP4",
      AiEdit: "AI ile düzenle",
      AiEditHint: "Ne değişsin yaz. Değişiklik mevcut hareketli görselin üzerine uygulanır.",
      AiEditHintLoop:
        "Ne değişsin yaz. Değişiklik animasyona uygulanır ve {{format}} yeniden oluşturulur.",
      AiEditPlaceholder: "Örn: daireyi küçült · yazıyı kırmızı yap · arka planı koyulaştır",
      AiEditRunning: "Değişiklik uygulanıyor",
      AiEditRunningMeta:
        "Birkaç dakika sürebilir — pencereyi kapatabilirsin, bitince kutuya uygulanır.",
      AiEditApply: "Uygula",
      AiEditUnavailable:
        "Bu görsel AI ile düzenlenemiyor (kaynağı yok). Yeni bir hareketli görsel üretebilirsin.",
      ToVideo: "MP4 / WebP'ye çevir",
      ToVideoHint:
        "Motion olduğu gibi, kendi süresiyle çevrilir ve sahneye eklenir. Model kullanılmaz, kredi düşmez.",
      ToVideoMp4Hint: "Video olarak eklenir, otomatik oynatma açık. Timeline ile senkron oynar.",
      ToVideoWebpHint:
        "Görsel olarak eklenir, bir kere oynayıp son karede durur. Timeline imlecini izlemez: durdurunca ya da sarınca kendi başına oynamaya devam eder.",
      ToVideoRunning: "Videoya çevriliyor",
      ToWebpRunning: "WebP'ye çevriliyor",
      ToVideoRunningMeta:
        "Birkaç dakika sürebilir — pencereyi kapatabilirsin, bitince sahneye eklenir.",
      ToVideoApply: "Çevir",
      ToVideoUnavailable: "Bu kutu videoya çevrilemiyor.",
      Generate: "Oluştur",
      Regenerate: "Yeniden oluştur",
      GeneratingMeta: "Model yazıyor — birkaç dakika sürebilir, modalı kapatabilirsin.",
      InputRequiredTitle: "Açıklama gerekli",
      InputRequired: "Ne oluşturmak istediğini yaz ya da sahnenin anlatımını kullan.",
      NarrationPlaceholder: "Bu sahnenin anlatımı…",
      StyleBrief: "Stil yönlendirmesi (opsiyonel)",
      StyleBriefPlaceholder: "Palet, his, tipografi — örn: koyu zemin, turkuaz vurgu, sade",
      Model: "Model",
      ModelAuto: "Otomatik (Sonnet 5.5)",
      ModelSonnet: "Sonnet 5.5",
      ModelOpus: "Opus 5.5",
      ModelDeepseekFlash: "DeepSeek V4.1 Flash",
      Orientation: "Yön",
      Duration: "Süre (sn)",
      DurationPlaceholder: "örn. 15",
      ThreeD: {
        Tab: "3B Obje",
        Title: "3B obje",
        Placeholder: "Ne modellensin? Örn: dört odacıklı insan kalbi, kesiti açılabilsin",
        Generating: "3B obje oluşturuluyor…",
        Hint: "Kamera, etiketlenecek noktalar ve anlamlı etkileşimler yazdığın metinden çıkarılır.",
      },
      Motion: {
        GifHint:
          "Animasyon bu sürede tek bir tur atar ve sonsuz döngüye girer (en fazla {{max}} sn). Sahneye görsel olarak eklenir.",
        GifDurationRequired: "{{format}} için 2 ile {{max}} saniye arasında bir süre yaz.",
        DurationRequiredTitle: "Süre gerekli",
        DurationRequired: "Hareketli görselin kaç saniye süreceğini yaz (2 ile {{max}} sn arası).",
        DurationHint:
          "Hareket daha kısa biterse kalan süre boyunca son hâli döngüyle oynamaya devam eder.",
        Tab: "Hareketli Görsel",
        Title: "Hareketli görsel",
        Placeholder:
          "Ekranda ne hareket etsin? Örn: üç aşamalı süreç sırayla belirsin ve son aşama vurgulansın",
        Generating: "Hareketli görsel oluşturuluyor…",
        Hint: "Hareket sırasını metne bakarak model kurar; süreyi sen veriyorsun.",
      },
    },
    ImageHistory: {
      Tab: "Etkinlik Günlüğü",
      AudioTab: "Ses Etkinlik Günlüğü",
      AvatarTab: "Avatar Etkinlik Günlüğü",
      CurrentBalance: "Mevcut Bakiye",
      MonthlySpending: "Bu Ayki Harcama",
      TrainingImageSpending: "Görsel Harcaması",
      TrainingVideoSpending: "Video Harcaması",
      TrainingAudioSpending: "Ses Harcaması",
      TrainingAvatarSpending: "Avatar Harcaması",
      TrainingSpending: "Toplam Harcama",
      Credits: "Kredi",
      Preview: "Ön izleme",
      TaskName: "Görev Adı",
      Name: "İsim",
      Scene: "Sahne",
      Model: "Model",
      DateTime: "Tarih ve Saat",
      Prompt: "Prompt",
      Narration: "Anlatım Sesi",
      Category: "Tür",
      CategoryImage: "Görsel",
      CategoryVideo: "Video",
      CategoryAudio: "Seslendirme",
      CategoryAvatar: "Avatar",
      Status: "Durum",
      Amount: "Tutar",
      Completed: "Tamamlandı",
      Empty: "Henüz görsel oluşturulmamış",
      EmptyVideo: "Henüz video oluşturulmamış",
      EmptyAudio: "Henüz ses oluşturulmamış",
      EmptyAvatar: "Henüz avatar oluşturulmamış",
      EmptyAny: "Henüz oluşturulmamış",
      Play: "Oynat",
      ShowAll: "Tüm Aktiviteler",
      ShowOnlyThis: "Filtreli",
      View: "Görüntüle",
      LoadError: "Geçmiş yüklenemedi",
      AddFailed: "Sahneye eklenemedi; lütfen tekrar deneyin.",
      NoOrganization: "Organizasyon bulunamadı",
      Close: "Kapat",
      DefaultNameImage: "AI ile Oluşturulmuş Görsel",
      DefaultNameVideo: "AI ile Oluşturulmuş Video",
      DefaultNameNarration: "AI ile Oluşturulmuş Anlatım",
      DefaultNameAvatar: "AI ile Oluşturulmuş Avatar",
    },
    CreditEstimate: {
      Button: "Kredi",
      Tooltip: "Bu işlemin kredi maliyetini göster",
      Title: "Kredi Tahmini",
      Cost: "Bu işlem",
      Balance: "Bakiyeniz",
      Sufficient: "Yeterli bakiye",
      Insufficient: "Yetersiz bakiye",
      MultiProvider: "sağlayıcı için toplam",
      Loading: "Yükleniyor",
      Duration: "Süre",
      Failed: "Kredi sorgusu başarısız",
    },
    TopLeft: "Üst Sol",
    TopCenter: "Üst Orta",
    TopRight: "Üst Sağ",
    BottomLeft: "Alt Sol",
    BottomCenter: "Alt Orta",
    BottomRight: "Alt Sağ",
    Center: "Orta",
    BoldWhiteWithShadow: "Kalın Beyaz (Gölgeli)",
    BoldBlackWithShadow: "Kalın Siyah (Gölgeli)",
    LargeWhiteBold: "Büyük Beyaz Kalın",
    MediumWhiteRegular: "Orta Beyaz Normal",
    SmallWhiteItalic: "Küçük Beyaz İtalik",
    SmallGrayItalic: "Küçük Gri İtalik",
    BoldYellowWithShadow: "Kalın Sarı (Gölgeli)",
    Custom: "Özel",
    CustomStyle: "Özel Stil",
    Style: "Stil",
    styles_load_error: "Stil şablonları yüklenemedi",
    Generated: "Oluşturuldu",
    UnknownError: "Bilinmeyen hata",
    SoundUploadFailed: "Ses yüklenemedi",
    Added: "Eklendi",
    Search: "Ara",
    Storyboard: "Storyboard Videoları",
    NoResults: "Görsel bulunamadı",
    "No video selected": "Video seçilmedi",
    aiTools: "AI",
    Rotation: "Döndürme",
    BoxMoveHandle: "Sürükleyerek taşı",
    Cancelled: "İptal edildi",
    warning_title: "Uyarı",
    Page: "Sayfa",
    soundList: "Ses listesi",
    "BoxAnimations--title": "Öğe Animasyonları",
    sound_fx_delete_confirm: "Bu efekti silmek istediğine emin misin?",
    sound_fx_delete_error: "Efekt silinemedi",
    "Insufficient balance": "Yetersiz bakiye",
    "Result not ready yet": "Sonuç henüz hazır değil",
    "Result URL missing": "Sonuç URL'si eksik",
    "No handler to apply result": "Sonucu uygulayacak bir işleyici yok — lütfen bunu bildirin.",
    avatarAnimate: {
      starting: "Gönderiliyor…",
      sent: "Kuyruğa alındı",
      trigger: "Avatarları canlandır",
      sceneNone: "Bu sahnede canlandırılacak avatar yok",
      scene: "Bu sahnedeki avatarı oynat",
      none: "Canlandırılacak avatar kalmadı",
      all: "Tüm sahnelerdeki avatarları oynat",
      history: "Geçmiş",
      use: "Uygula",
      historyEmpty: "Bu sahne için geçmiş yok",
    },
    interactive: {
      library: "Eleman Ekle",
      library_search_placeholder: "Elemanları filtrele…",
      library_search_label: "Etkileşimli elemanları filtrele",
      library_search_clear: "Filtreyi temizle",
      library_search_count: "{{total}} elemandan {{shown}} tanesi gösteriliyor",
      library_search_empty: "“{{query}}” ile eşleşen eleman yok",
      moved_to_left: "Elemanları sol paneldeki Etkileşimli Elemanlar bölümünden ekleyin.",
    },
    LibraryCatalog: {
      title: "Etkileşimli Eleman Kataloğu",
      how_it_works: "Nasıl çalışır",
      live_preview: "Canlı önizleme",
      add_hint:
        "Bu elemanı eklemek için kataloğu kapatın ve Etkileşimli Elemanlar panelindeki etiketine tıklayın.",
    },
    ImageChatEdit: {
      SeedPrompt: "Bu görseli şöyle düzenlemek istiyorum: ",
      ButtonTooltip: "Chatbot ile düzenle",
    },
    EditorNavBar: {
      workflow_tooltip: "İş akışı düzenleyiciyi aç",
      workflow: "İş Akışı",
    },
    Timeline: {
      WaitingForInteractive: "Timeline interaktif element bekliyor",
      SkipInteractive: "Interaktifi atla ve timeline'ı devam ettir",
    },
    FlowItems: {
      selected_element: "Seçili Element",
      no_selection: "Element Özellikleri",
      click_to_select: "Özelliklerini düzenlemek için canvas'tan bir element seçin.",
      title: "ELEMENTLER",
      empty_after_move: "Henüz öğe yok — eklemek için sol paneli kullanın.",
      remove: "Kaldır",
    },
    InteractivePlugin: {
      scenario: "Senaryo",
    },
    Regenerate: "Yeniden Oluştur",
    EditPhoto: "Görseli Düzenle",
    MerlinAI: "Aidea Wizard AI",
    Merlin: "Aidea Wizard",
    MerlinVideoTranscribe: "Metne Çevir",
    ViewTranscript: "Metni Görüntüle",
    MerlinVideoNarration: "Resmi Anlatım",
    MerlinVideoVoiceover: "Seslendirme",
    MerlinComingSoon: "Çok yakında",
    Sestek: "Sestek",
    DefaultOption: "Varsayılan",
    NarrationStyle: "Anlatım Stili",
    NarrationSound: "Anlatım Sesi",
    NarrationStyleNone: "Hiçbiri (aynen seslendir)",
    NarrationFailed: "Anlatım üretimi başarısız.",
    NarrationTextPlaceholder: "Seslendirilecek metni yazın…",
    NarrationReady: "Anlatım hazır.",
    GenerateAgain: "Yeniden üret",
    NoVoicesFound: "Ses bulunamadı.",
    PleaseEnterNarrationText: "Lütfen anlatım metni giriniz.",
    MerlinVideoTranscribing: "Video metne çevriliyor…",
    MerlinVideoTranscribeFailed: "Metne çevirme başarısız. Kapatmak için tıklayın.",
    TranscribeRetry: "Tekrar dene",
    TranscribeStart: "Metne çevirmeyi başlat",
    TranscribeEmptyHint:
      "Bu video için henüz metin yok. Metne çevirmeyi başlatın; arka planda çalışır ve hazır olduğunda burada görünür.",
    TranscribeStartedHint:
      "Metne çevirme başlatıldı. Arka planda çalışıyor; hazır olduğunda burada görünecek.",
    TranscriptionVideoTooLong:
      "Bu video metne çevirmek için çok uzun. En fazla {{maxMinutes}} dakika olabilir.",
    TranscriptionVideoTooLarge:
      "Bu video metne çevirmek için çok büyük. En fazla {{maxMB}} MB olabilir.",
    MerlinNarrationNeedsTranscript: "Önce videoyu metne çevirin",
    TranscriptModal_Title: "Metne Çevir",
    TranscriptModal_Save: "Kaydet",
    TranscriptModal_Saving: "Kaydediliyor…",
    TranscriptModal_Copy: "Kopyala",
    TranscriptModal_Copied: "Kopyalandı",
    TranscriptModal_Close: "Kapat",
    ChangeTool: "Araç Değiştir",
    Collapse: "Daralt",
    AspectRatio: "En Boy Oranı",
    AspectRatioLock: "En boy oranını koru",
    AspectRatioLockHint:
      "Boyutlandırırken oranı korur. Tutamaçtan sürüklerken Shift tuşunu basılı tutarak geçici olarak açıp kapatabilirsiniz.",
    OptionalEnhancements: "Opsiyonel İyileştirmeler",
    TextInVideo: "Videoda Metin",
    TextInImage: "Resimde Metin",
    OverlayText: "Metin Bindirme",
    ClickToUploadOrDragDrop: "Yüklemek için tıklayın veya sürükleyip bırakın",
    PNGJPGOrWEBPMax10MB: "PNG, JPG veya WEBP (maks 100MB)",
    WritePrompt: "Prompt Yaz",
    FromNarration: "Anlatımdan",
    RawPrompt: "Direkt Promptla İlerle",
    NoBalance: "Bu işlem için yeterli krediniz bulunmuyor.",
    EnrichTexts: "AI ile Zenginleştir",
    Enriching: "Zenginleştiriliyor...",
    EnrichMyPrompt: "✨ Promptu Zenginleştir",
    SceneNarration: "Sahne Anlatımı",
    EditToHighlightKeyVisuals: "Anahtar görselleri vurgulamak için düzenle",
    DescribeSceneNarration: "Sahne anlatımını tanımla...",
    EachSentenceBecomesScene:
      "Her cümle bir sahneye dönüşür. Görsel desteğe ihtiyaç duymayanları kaldırın.",
    TipRemoveParts:
      "İpucu: Görsel desteğe ihtiyaç duymayanları kaldırın. Gösterilmesi gereken cümleleri koruyun.",
    GenerateImagePromptFromNarration: "Anlatımdan Görsel Prompt Oluştur",
    AIWillUse: "AI kullanacak",
    AIVoice: "AI Anlatım Sesi",
    AvatarNarration: "Avatar Anlatımı",
    FromLibrary: "Kütüphaneden Seç",
    RecordMyVoice: "Sesimi Kaydet",
    SoundModalTitle: "Ses",
    AvatarModalTitle: "Avatar",
    FromLibraryComingSoon: "Kütüphanede ses bulunamadı.",
    RecordMyVoiceComingSoon: "Ses kaydı özelliği yakında kullanılabilir olacak.",
    CreateNewNarration: "Yeni Anlatım Sesi Oluştur",
    RestorePreviousNarration: "Silinen sesi getir",
    DeletedAudio: "silinmiş",
    RestoreDeletedAudio: "Geri getir",
    GenerateVoice: "Ses Oluştur",
    RegenerateVoice: "Yeniden Oluştur",
    SelectNarrator: "Anlatıcı Seç",
    CreateAvatar: "Avatar Oluştur",
    CreatingAvatar: "Oluşturuluyor...",
    OnlyAvailableForAidea: "Yalnızca Aidea sağlayıcısında kullanılabilir",
    AzureKeepVoiceComingSoon: "Azure Avatar lip-sync ile anlatım sesi yakında kullanıma sunulacak.",
    UploadMyFile: "Dosya Yükle",
    SoundTabTooltip: {
      ai: "Metninizi yapay zeka ile doğal bir anlatım sesine dönüştürün.",
      avatar: "Metninizi sunması için bir avatar oluşturun.",
      library: "Kayıtlı sesler arasından seçim yapın.",
      record: "Kendi sesinizi kaydederek anlatım sesi olarak kullanın.",
      upload: "Cihazınızdan bir ses dosyası yükleyin (mp3, wav vb.).",
    },
    FileSizeLimit: {
      TooLarge: "Dosya çok büyük. En fazla {{max}} MB yükleyebilirsiniz.",
    },
    AddSoundUpload: {
      DropTitle: "Yüklemek için tıkla veya sürükleyip bırak",
      DropSubtitle: "MP3, WAV veya M4A (maks 100MB)",
      Remove: "Kaldır",
      SoundSettings: "Ses Ayarları",
      StartTime: "Başlangıç Zamanı",
      FinishTime: "Bitiş Zamanı",
      Volume: "Ses Seviyesi",
      ErrorInvalidType: "Yalnızca MP3, WAV veya M4A dosyaları yüklenebilir.",
      ErrorTooLarge: "Dosya çok büyük. Maksimum boyut 500MB olmalıdır.",
    },
    SceneAudio: {
      Title: "Anlatım Sesleri",
      ErrorRequestFailed: "İstek başarısız",
      ErrorPrefix: "Hata",
      NoTrainingAudio: "Bu eğitim için kayıtlı anlatım sesi yok.",
      NoSceneAudio: "Anlatım sesi bulunamadı.",
      Collapse: "Daralt",
      Expand: "Genişlet",
      HideText: "Metni gizle",
      ShowText: "Metni göster",
      Pause: "Durdur",
      Play: "Oynat",
      Video: "Video",
      ViewScene: "Sahneyi gör",
      Edit: "Düzenle",
      Delete: "Sil",
      AddAudio: "Ses ekle",
    },
    Mindmap: {
      Title: "Zihin Haritası",
      Open: "Zihin haritasını aç",
      OpenHint: "Yeni sekmede açılır",
      Loading: "Yükleniyor...",
      Empty: "Bu eğitim için zihin haritası oluşturulmadı.",
      EmptyHint: "Zihin haritası yalnızca döküman yüklenen kurslarda üretilir.",
      Error: "Zihin haritası yüklenemedi.",
    },
    ImgTextToImage: {
      TabStyleLibrary: "Stil Kütüphanesi",
      TabTraditionalMode: "Klasik Mod",
      Provider: {
        Flux: "Flux – 1.1 Pro",
        GeminiNano: "Gemini – 3.1 Flash Image",
        Grok: "Grok",
        GPTImage: "GPT-image-1.5",
      },
      WaitMessage: "Lütfen bekleyin...",
    },
    Sound: {
      Languages: {
        enUS: "İngilizce (ABD)",
        enGB: "İngilizce (BK)",
        trTR: "Türkçe",
        deDE: "Almanca",
        frFR: "Fransızca",
        arSA: "Arapça",
        zhCN: "Çince",
        jaJP: "Japonca",
      },
    },
    SelectVoice: "Ses seç",
    Voice1: "Ses 1",
    Voice2: "Ses 2",
    Voice3: "Ses 3",
    Voice4: "Ses 4",
    Voice5: "Ses 5",
    Voice6: "Ses 6",
    Voice7: "Ses 7",
    Voice8: "Ses 8",
    UsingProjectVoice: "✓ Proje sesi kullanılıyor",
    SavedVoiceLoaded: "✓ Kayıtlı ses yüklendi",
    VoiceGenerated: "✓ Ses oluşturuldu",
    OwnVoice: "Kendi Sesim",
    VoiceText: "Ses Metni",
    VoiceTags: "Ses Etiketleri",
    EstimatedVoiceDuration: "Tahmini ses süresi",
    UseSlideNotes: "Slayt notunu kullan",
    Minutes: "dk",
    Seconds: "sn",
    Chars: "karakter",
    chars: "karakter",
    DefaultVoiceText:
      "Ada Lovelaca Test 01 eğitimine hoş geldiniz. Bu modülde kullanıcı davranışının psikolojik temellerini inceleyeceğiz.",
    ProjectVoice: "Proje sesi:",
    Carlos: "Carlos",
    ElevenLabs: "ElevenLabs",
    Hulya: "Hülya",
    German: "Almanca",
    Speed: "1.0x",
    FemaleWarmTurkish: "Kadın · Sıcak · Türkçe",
    ChangeNarrator: "Anlatım Sesi",
    AIVoices: "AI Sesler",
    BringYourOwnVoice: "Ses Klonla",
    Service: "Hizmet",
    LanguageNames: {
      Turkish: "Türkçe",
      English: "İngilizce (ABD)",
      EnglishUK: "İngilizce (UK)",
      Spanish: "İspanyolca",
      French: "Fransızca",
      German: "Almanca",
      Chinese: "Çince",
      Azerbaijani: "Azerice",
      Arabic: "Arapça",
      Russian: "Rusça",
      Japanese: "Japonca",
      Portuguese: "Portekizce (BR)",
      Italian: "İtalyanca",
      Dutch: "Felemenkçe",
      Polish: "Lehçe",
      Korean: "Korece",
      Hindi: "Hintçe",
      Multilingual: "Çok Dilli",
    },
    AccentLanguage: "Aksan / Dil",
    AccentAuto: "Otomatik",
    Voice: "Ses",
    Voices: "Sesler",
    SampleLanguage: "Örnek Dili",
    CloneYourVoice: "Sesinizi Klonlayın",
    CloneVoiceDescription: "Sesinizi klonlamak için bir ses örneği yükleyin",
    VoiceName: "Ses Adı",
    EnterVoiceName: "Ses adını girin",
    AudioFile: "Ses Dosyası",
    ChooseFile: "Dosya Seç",
    NoFileChosen: "Dosya seçilmedi",
    CloneVoice: "Sesi Klonla",
    PleaseSelectAudioFile: "Lütfen geçerli bir ses dosyası seçin",
    DropFileHere: "Ses dosyanızı buraya bırakın",
    DragDropOrClick: "Ses dosyanızı buraya sürükleyip bırakın",
    BrowseFiles: "Dosya Seç",
    Uploading: "Yükleniyor...",
    UploadError: {
      Failed: "Dosya yüklenemedi.",
      TooManyRequests:
        "Aynı anda çok fazla yükleme işlemi var. Devam eden yüklemeler bitince tekrar deneyin.",
      Unauthorized: "Bu işlem için yetkiniz yok. Lütfen tekrar giriş yapın.",
      TooLarge: "Dosya sunucu limitini aşıyor.",
      ServerError: "Sunucu hatası nedeniyle dosya yüklenemedi.",
    },
    YourClonedVoices: "Klonlanmış Sesleriniz",
    NoClonedVoices: "Henüz klonlanmış ses yok. Sesinizi klonlamak için bir ses örneği yükleyin.",
    ClonedVoice: "Klonlanmış",
    ConfirmDeleteVoice: "Bu sesi silmek istediğinizden emin misiniz?",
    VoiceClonedSuccessfully: "Ses başarıyla klonlandı!",
    VoiceDeletedSuccessfully: "Ses başarıyla silindi!",
    PleaseSelectClonedVoice: "Lütfen klonlanmış bir ses seçin",
    Success: "Başarılı",
    UploadFile: "Dosya Yükle",
    UploadVoiceFile: "Ses Dosyası Yükle",
    RecordWithMicrophone: "Mikrofonla Kaydet",
    StartRecording: "Kaydı Başlat",
    StopRecording: "Kaydı Durdur",
    Recording: "Kaydediliyor...",
    RecordingSample: "Kayıt Örneği",
    ReadThisText: "Bu metni okuyun:",
    RecordingInstruction:
      "Ses örneğinizi kaydetmeye başlamak için 'Kaydı Başlat' butonuna tıklayın.",
    NextSample: "Sonraki Örnek",
    FinishRecording: "Kaydı Tamamla",
    MicrophonePermissionDenied: "Mikrofon izni reddedildi. Lütfen mikrofon erişimine izin verin.",
    MicrophoneErrorMessage: "Mikrofon hatası. Lütfen mikrofonunuzu kontrol edin.",
    RecordingText1:
      "Merhaba, bu benim sesimin bir testidir. Ses klonu oluşturmak için bu metni okuyorum. Ses klonlama teknolojisi gerçekten büyüleyicidir. Bu örnek, sesimin doğru bir temsilini oluşturmaya yardımcı olacaktır.",
    RecordingText2:
      "Çabuk kahverengi tilki tembel köpeğin üzerinden atlar. Bu cümle her harfi içerir. Ses klonlama çeşitli konuşma örnekleri gerektirir. Birden fazla kayıt doğruluğu ve doğallığı artırmaya yardımcı olur.",
    RecordingText3:
      "Boş zamanlarımda kitap okumayı ve müzik dinlemeyi severim. Bu aktiviteler uzun bir gün sonrası rahatlamama yardımcı olur. Yeni şeyler öğrenmek en sevdiğim hobilerimden biridir. Sürekli gelişimin kişisel büyüme için gerekli olduğuna inanıyorum.",
    RecordingText4:
      "Teknoloji birbirimizle iletişim kurma şeklimizi değiştiriyor. Yapay zeka günlük hayatımıza giderek daha fazla entegre oluyor. Sesli asistanlar artık birçok evde yaygındır. İnsan-bilgisayar etkileşiminin geleceği hızla gelişiyor.",
    RecordingText5:
      "Her sabah gelecek gün için dinlenmiş ve enerjik bir şekilde uyanırım. İyi bir gece uykusu sağlık ve verimlilik için çok önemlidir. Hafta boyunca tutarlı bir uyku düzeni korumaya çalışırım. Düzenli egzersiz de uyanık ve odaklı kalmama yardımcı olur.",
    RecordingText6:
      "Yapay zeka dünya çapında birçok sektörde devrim yaratıyor. Sağlıktan finansa kadar yapay zeka önemli etkiler yaratıyor. Makine öğrenimi algoritmaları her geçen gün daha sofistike hale geliyor. Potansiyel uygulamalar sınırsız ve heyecan verici görünüyor.",
    RecordingText7:
      "Seyahat etmeyi ve dünyanın farklı yerlerini keşfetmeyi seviyorum. Farklı kültürlerden insanlarla tanışmak zenginleştirici bir deneyimdir. Her yolculuk bana hayat hakkında değerli bir şey öğretiyor. Seyahat bakış açılarını genişletir ve kalıcı anılar yaratır.",
    RecordingText8:
      "Yeni beceriler öğrenmek bireyler olarak büyümemize ve gelişmemize yardımcı olur. Bir dil, enstrüman veya teknik beceri olsun, pratik anahtarıdır. Zaman içinde tutarlı çaba ustalığa yol açar. Öğrenme yolculuğunun kendisi ödüllendirici ve tatmin edicidir.",
    RecordingText9:
      "İyi iletişim başkalarıyla güçlü ilişkiler kurmak için çok önemlidir. Aktif dinlemek net konuşmak kadar önemlidir. Farklı bakış açılarını anlamak çatışmaları barışçıl bir şekilde çözmeye yardımcı olur. Empati ve saygı anlamlı bağlantıların temelini oluşturur.",
    RecordingText10:
      "Zorluklar karşısında çok çalışmaya ve pozitif kalmaya inanıyorum. Başarı genellikle azim ve kararlılıktan gelir. Gelişim odaklı bir zihniyeti korumak engelleri aşmaya yardımcı olur. Her başarısızlık öğrenme ve gelişme fırsatıdır.",
    PlayRecording: "Kaydı Çal",
    ResetRecording: "Kaydı Sıfırla",
    SoundSettings: "Ses Ayarları",
    StartTimeOnSlide: "Slayt Başlangıç Zamanı",
    SoundVolume: "Ses Seviyesi",
    ZeroPercent: "%0",
    HundredPercent: "%100",
    SceneOf: "Sahne {{current}} / {{total}}",
    SceneEndTime: "Sahnede ki bitiş süresi",
    Generating: "Oluşturuluyor...",
    Loading: "Yükleniyor...",
    Google: "Google",
    NoVoicesAvailable: "Mevcut ses yok",
    SelectProvider: "Bir sağlayıcı seçiniz",
    SelectLanguage: "Bir dil seçiniz",
    PleaseSelectProvider: "Lütfen bir sağlayıcı seçiniz",
    PleaseSelectLanguage: "Lütfen bir dil seçiniz",
    PleaseSelectVoice: "Lütfen bir ses seçiniz",
    PleaseSelectNarrator: "Sesi oluşturmak için önce listeden bir anlatıcı seçmelisiniz.",
    Gender: "Cinsiyet",
    SelectGender: "Cinsiyet Seçin",
    AllGenders: "Tümü",
    AllProviders: "Tümü",
    Male: "Erkek",
    Female: "Kadın",
    ChangeVoice: "Sesi değiştir",
    ListenPreview: "Üretilen ön izlemeyi dinle",
    Of: "/",
    NoVoicesFound: "Ses bulunamadı",
    PleaseGenerateVoiceFirst: "Lütfen önce ses oluşturun",
    PleaseUploadFileFirst: "Lütfen önce dosya yükleyin",
    WhatVoiceShouldAvatarUse: "Avatar hangi sesi kullanmalı?",
    KeepMyNarrationVoice: "Anlatım sesimi koru",
    UseSceneAudio: "Sahnedeki sesi kullan",
    LipSyncToHulya: "Hülya ile dudak senkronizasyonu",
    UseADifferentVoice: "Farklı bir ses kullan",
    VoiceProvider: "Ses Sağlayıcı",
    SelectVoiceProvider: "Ses sağlayıcı seçin",
    LipsyncProvider: "Dudak Senkronizasyonu",
    LipsyncAuto: "Otomatik",
    LipsyncCustom: "Özel",
    AvatarAspectRatio: "En/Boy Oranı",
    AvatarAspectSquare: "Kare (1:1)",
    AvatarAspectWide: "Yatay (16:9)",
    // Avatar sekmesi yeniden tasarımı (iki adımlı düzen)
    AvatarStepSubtitle: "Sahnenizi anlatacak bir avatar oluşturun",
    AideaAvatarLibrary: "Aidea Avatar Kütüphanesi",
    AideaAvatarLibraryMeta: "Aidea ve iş ortaklarından hazır sunucular",
    CreateYourOwn: "Kendin oluştur",
    CreateYourOwnMeta: "Yapay zekâ ile üret veya video ya da fotoğraf yükle",
    AvatarSourceChange: "Değiştir",
    AvatarPickGenderHint: "Önce cinsiyet seçin",
    AvatarSelectFirstHint: "Önce bir avatar seçin veya oluşturun",
    AvatarShuffleIdentity: "Rastgele isim & unvan",
    Shuffle: "Rastgele",
    AvatarPlaySample: "Örneği oynat",
    AvatarDelete: {
      Button: "Avatarı sil",
      Title: "Avatarı sil",
      Desc: "Emin misiniz? Kayıtlı avatarınız „{{name}}“ tamamen silinecek ve bu avatar için oluşturulan tüm kayıtlar kaldırılacak. Bu işlem geri alınamaz. Sahnelere daha önce eklenmiş videolar etkilenmez.",
      Cancel: "Vazgeç",
      Confirm: "Evet, sil",
      Deleting: "Siliniyor...",
      ErrorNotDeletable: "Bu avatar silinemez.",
      ErrorGeneric: "Avatar silinemedi, lütfen tekrar deneyin.",
    },
    VoiceDelete: {
      Button: "Sesi sil",
      Title: "Klonlanmış sesi sil",
      Desc: "Emin misiniz? Klonlanmış sesiniz „{{name}}“ silinecek. Bu işlem geri alınamaz. Sahnelere daha önce eklenmiş seslendirmeler etkilenmez.",
    },
    All: "Tümü",
    SeeAllCount: "Tümünü gör ({{num}})",
    AvatarIdentity: "Kimlik",
    AvatarNameShort: "Ad",
    GenerationMethod: "Üretim yöntemi",
    GenerateWithPrompt: "Prompt ile üret",
    GenerateWithPromptMeta: "Avatarını serbestçe tarif et",
    GenerateWithGuide: "Rehber ile üret",
    GenerateWithGuideMeta: "Birkaç kısa soruyu yanıtla",
    UseYourOwnMedia: "Kendi medyanı kullan",
    UseYourOwnMediaMeta: "Video veya fotoğraf yükle",
    DescribeYourAvatar: "Avatarını tanımla",
    Suggestions: "Öneriler",
    AvatarSuggestAge: "yaş",
    AvatarSuggestEthnicity: "etnik köken",
    AvatarSuggestProfession: "meslek",
    AvatarSuggestHairColor: "saç rengi",
    AvatarSuggestFacial: "yüz hatları",
    AvatarSuggestClothing: "kıyafet",
    AvatarSuggestBackground: "arka plan",
    AvatarSuggestPose: "oturuyor / ayakta",
    AvatarSuggestHands: "eller görünür",
    GeneratePersonaPreview: "Persona ön izlemesi üret",
    VoiceAndNarration: "Ses ve anlatım",
    VoiceAndNarrationSub: "Anlatım metnini düzenleyin ve sesi seçin",
    UseSceneAudio: "Sahne sesini kullan",
    UseSceneAudioMeta: "Bu sahnenin mevcut sesiyle anlat",
    GenerateNewVoice: "Yeni ses üret / Sahne sesi düzenle",
    GenerateNewVoiceMeta: "Anlatımı okuyacak bir yapay zekâ sesi seç",
    EditText: "Metni Düzenle",
    AudioTags: "Ses etiketleri",
    GenerateVoicePreview: "Ses ön izlemesi üret",
    GenerateVoicePreviewFull: "Tamamını üret",
    GenerateVoicePreviewShort: "5 sn üret",
    VoicePreviewNotEnoughText:
      "5 saniyelik ön izleme için yeterli metin yok. Lütfen daha fazla metin girin.",
    GeneratingVoicePreview: "Üretiliyor…",
    AvatarGenerateFirst: "Lütfen önce avatarınızı üretin (Persona ön izlemesi üret).",
    AvatarCompleteFieldsHint: "Lütfen önce gerekli seçimleri tamamlayın.",
    AvatarVideoGenerating: "Avatar video üretiliyor…",
    AvatarVideoGeneratingHint: "Bu işlem birkaç dakika sürebilir. Lütfen bu pencereyi açık tutun.",
    GenerateVoicePreviewHint: "Seçili sesle anlatım metnini okur",
    StopPreview: "Ön izlemeyi durdur",
    DeletePreview: "Ön izlemeyi sil",
    LipSync: "Dudak senkr.",
    Engine: "Motor",
    AvatarRendersForScene: "Avatar şunun için işleniyor: {{scene}} · {{duration}}",
    AvatarRendersForSceneNoDuration: "Avatar şunun için işleniyor: {{scene}}",
    // "Doğal konuşan video" (Omni / Seedance + ElevenLabs STS) — add_sound_modal/talking_avatar
    TalkingAvatar: {
      Beta: "Beta",
      SceneHasJob: "Bu sahnede doğal konuşan video işi var",
      Method: {
        Title: "Üretim yöntemi",
        Lipsync: "Dudak senkronu",
        LipsyncMeta: "Avatar videosu seçtiğiniz sesle dudak senkronlanır",
        Talking: "Doğal konuşan video",
        TalkingMeta: "Video ve konuşma birlikte üretilir; ses seçtiğiniz sese çevrilir",
      },
      Step: {
        Title: "Metin ve ses",
        Sub: "Avatarın söyleyeceği metin ve konuşacağı ses",
        Locked: "Önce bir avatar seçin veya oluşturun",
      },
      Text: {
        Label: "Anlatım metni",
        Placeholder: "Avatarın söyleyeceği metni yazın…",
        Meter: "~{{est}} sn / {{max}} sn · {{words}} kelime · ~{{segments}} segment",
        MeterEmpty: "En fazla {{max}} sn konuşma",
        SummaryBase: "~{{seconds}} sn · {{words}} kelime · {{segments}} segment",
        SummaryBaseSingle: "~{{seconds}} sn · {{words}} kelime",
        SummaryCredit: "~{{credits}} kredi",
        WarnMax: "Model sınırına yaklaşıyorsunuz (en fazla {{max}} sn).",
        OverMax: "Metin bu model için çok uzun (en fazla {{max}} sn); lütfen kısaltın.",
        Warn: "Model sınırına yaklaşıyorsunuz.",
        Over: "Metin bu model için çok uzun; lütfen kısaltın.",
        FetchScene: "Sahne Metnini Getir",
        NoSceneText: "Bu sahnede anlatım metni bulunamadı.",
      },
      Voice: {
        Title: "Ses",
        ProviderFilter: "Sağlayıcı",
        GenderFilter: "Cinsiyet",
        ChangeVoice: "Sesi değiştir",
        Count: "{{shown}} / {{total}} Sesler",
        Hint: "Videodaki konuşma seçilen sese dönüştürülür.",
        HintAudioDriven: "Anlatım bu sesle seslendirilir; avatar bu sese göre konuşur.",
        ProviderElevenLabs: "ElevenLabs",
        ProviderAzure: "Azure",
        ProviderUnconfigured: "yapılandırılmamış",
        ProviderUnpriced: "fiyat tanımlı değil",
        Neutral: "Nötr",
        GenderMismatchFemale: "Seçili ses kadın sesi, avatar erkek. Avatar bu sesle konuşacak.",
        GenderMismatchMale: "Seçili ses erkek sesi, avatar kadın. Avatar bu sesle konuşacak.",
        All: "Tümü",
        Female: "Kadın",
        Male: "Erkek",
        Loading: "Sesler yükleniyor…",
        Empty: "Ses bulunamadı.",
        LoadError: "Sesler yüklenemedi.",
        Play: "Örneği dinle",
        Stop: "Durdur",
        Select: "Ses seçin",
        Change: "Değiştir",
        Close: "Kapat",
      },
      Model: {
        Label: "Model",
        Loading: "Modeller yükleniyor…",
        Unavailable: "Bu model şu anda kullanılamıyor",
        Unpriced: "Bu model için fiyat tanımlı değil",
        AudioDrivenHint:
          "Ses önce seçtiğiniz sesle üretilir, avatar bu sese göre tek seferde konuşur (en fazla {{minutes}} dk)",
        SeedanceNotAiAvatar:
          "Seedance yalnızca AI ile üretilmiş avatarlarla kullanılabilir. Bu avatar için Omni seçin.",
        SeedanceAvatarRejected: "Bu karakter bu modelle kullanılamıyor. Omni seçin.",
        LoadError: "Modeller yüklenemedi.",
        Retry: "Tekrar dene",
      },
      Aspect: {
        Label: "En/Boy Oranı",
        Wide: "Yatay (16:9)",
        Tall: "Dikey (9:16)",
        Square: "Kare (1:1)",
        Cropped: "16:9 üretilip kareye kırpılır",
      },
      Language: "Konuşma dili",
      Advanced: "Gelişmiş ayarlar",
      Credit: {
        Line: "~{{credits}} kredi · {{segments}} segment · ~{{seconds}} sn",
        Loading: "Kredi hesaplanıyor…",
        Insufficient: "Bakiyeniz bu iş için yetersiz görünüyor.",
        Error: "Kredi tahmini alınamadı.",
      },
      Missing: {
        Title: "Oluşturmak için",
        Model: "uygun bir model seçin",
        Avatar: "bir avatar seçin",
        AvatarUploading: "avatar yüklemesinin bitmesini bekleyin",
        AvatarUploadFailed: "avatar yüklenemedi, tekrar yükleyin",
        Text: "anlatım metni girin",
        TextOver: "metni kısaltın",
        TextPart: "uzun cümleleri bölün",
        Voice: "bir ses seçin",
        Aspect: "desteklenen bir en/boy oranı seçin",
        ActiveJob: "bu sahnedeki işin bitmesini bekleyin",
      },
      Processing: {
        Title: "Avatar video üretiliyor…",
        Note: "Pencereyi kapatabilirsiniz; bitince Etkinlik panelinde onay bekler.",
        Background: "Arka planda devam et",
        Unknown: "İşin durumu bir süredir alınamıyor. Etkinlik panelinden de takip edebilirsiniz.",
        Refresh: "Durumu yenile",
        Unreachable:
          "Bu işin durumuna ulaşılamıyor (iş bulunamadı veya bu hesaba ait değil). Etkinlik panelinden kontrol edebilirsiniz.",
        Dismiss: "Gizle / Ayarlara dön",
        DismissConfirm: "İş arka planda sürer; bitince Etkinlik panelinden ekleyebilirsiniz.",
        DismissConfirmYes: "Gizle",
        DismissCancel: "Vazgeç",
      },
      Job: {
        SeedancePortraitHint:
          "Karakter Seedance'e hazırlanıyor; ilk seferde birkaç dakika sürebilir.",
      },
      Result: {
        Title: "Avatar Video Oluşturuldu",
        Preview: "Önizleme: video sessiz eklenir, sahnede dönüştürülmüş ses çalar.",
        Target: "Anlatım sesi",
        NewSound: "Yeni ses olarak ekle",
        Split: "bölünmüş",
        ReplaceNote: "Seçili anlatım sesi bu sesle değiştirilecek; video sessiz eklenecek.",
        AddNote: "Ses yeni anlatım olarak eklenecek; video sessiz eklenecek.",
        SplitNote:
          "Bu anlatım zaman çizelgesinde bölünmüş; tüm parçaları tek ses olarak değiştirilecek.",
        BgRemovalFailed: "Arka plan kaldırılamadı; video arka planıyla birlikte eklenecek.",
        CropFailed: "Kare kırpma başarısız oldu; video 16:9 olarak teslim edildi.",
        WebmSafari: "Şeffaf video (WebM) Safari'de oynatılamayabilir.",
        Regenerate: "Yeniden Oluştur",
        AddToScene: "Sahneye Ekle",
        Adding: "Ekleniyor…",
        AddFailed: "Sahneye eklenemedi; lütfen tekrar deneyin.",
        Fetching: "Sonuç alınıyor…",
        FetchFailed:
          "Sonuç henüz alınamadı. Tekrar deneyebilir ya da gizleyip Etkinlik panelinden ekleyebilirsiniz.",
        RetryFetch: "Sonucu tekrar getir",
      },
      History: {
        NoResult: "Bu işin sonucu alınamadı; sahneye eklenemedi.",
      },
      Failed: {
        Title: "Video oluşturulamadı",
        CreditNote: "Başarısız işlerden kredi düşülmez.",
        Back: "Ayarlara dön",
        SwitchToVeo: "Omni'ye geç",
        PickVoice: "Başka ses seç",
        PickModel: "Başka model seç",
      },
      Errors: {
        TEXT_TOO_LONG:
          "Metin bu model için çok uzun (~{{est}} sn / en fazla {{max}} sn). Lütfen kısaltın.",
        TEXT_PART_TOO_LONG:
          "Metinde tek parçada söylenemeyecek kadar uzun bir bölüm var; uzun cümleleri bölün.",
        VOICE_NOT_ALLOWED:
          "Bu ses kullanılamıyor. Listedeki ElevenLabs, kurum veya Azure seslerinden birini seçin.",
        VOICE_PROVIDER_UNAVAILABLE:
          "Bu ses sağlayıcısı şu anda kullanılamıyor; başka bir ses seçin.",
        AVATAR_REJECTED_SEEDANCE: "Bu avatar Seedance ile kullanılamıyor, Omni seçin",
        AVATAR_REJECTED:
          "Bu avatar seçilen model tarafından reddedildi; farklı bir avatar deneyin.",
        CONTENT_FILTERED: "Metin veya avatar sağlayıcının içerik filtresine takıldı.",
        VOICE_DRIFT: "Ses dönüşümü videoyla uyumlu çıkmadı; tekrar deneyin veya başka ses seçin.",
        PROVIDER_FAILED:
          "Video sağlayıcısı işlemi tamamlayamadı; biraz sonra veya başka modelle deneyin.",
        PRICE_LIST_MISSING: "Bu model için fiyat tanımlı değil; başka model seçin.",
        TOO_MANY_ACTIVE: "Aynı anda en fazla 3 doğal konuşan video üretilebilir.",
        MODEL_UNAVAILABLE: "Bu model şu anda kullanılamıyor; başka model seçin.",
        AVATAR_NOT_ALLOWED:
          "Bu avatar kullanılamıyor; kütüphaneden ya da kendi yüklediğiniz bir avatarı seçin.",
        TEXT_EMPTY: "Anlatım metni boş; lütfen metin girin.",
        RATIO_UNSUPPORTED: "Bu en/boy oranı seçilen modelde desteklenmiyor.",
        INVALID_REQUEST: "Gönderilen bilgiler geçersiz.",
        Generic: "Video oluşturulamadı; lütfen tekrar deneyin.",
      },
    },
    HeyGen: "HeyGen",
    Azure: "Azure",
    AzureVideo: "Azure Video",
    Aidea: "Aidea",
    Tavus: "Tavus",
    Synthesia: "Synthesia",
    GoogleAvatars: "Google Avatarları",
    StockAvatars: "Stok Avatarlar",
    ChooseFromBuiltInAvatars: "Yerleşik avatarlardan seç",
    CreateNewAvatar: "Yeni Avatar Oluştur",
    UploadVideoOrRecord: "Video yükle veya kayıt yap",
    ComingSoon: "Yakında",
    SeeAllAvatars: "Tüm Avatarları Gör",
    ShowLess: "Daha Az Göster",
    AvatarName: "Avatar Adı",
    AvatarNamePlaceholder: 'örn. "Kemal"',
    TitleRole: "Unvan / Rol",
    TitleRolePlaceholder: 'örn. "CEO" veya "Eğitmen"',
    HarryBusiness: "Harry - İş",
    MaleGestures: "Erkek - Jestler",
    NarrationText: "Anlatım Metni",
    FetchSceneText: "Sahne Metnini Getir",
    NoNarrationTextFoundInScene: "Bu sahnede anlatım metni bulunamadı.",
    Back: "Geri",
    InfographicEngine: {
      label: "Aidea Engine",
      subtitle: "(görsel davranış motoru seçimi)",
      engine1_label: "Aidea Engine 1",
      engine1_description: "Birbiriyle uyumlu, standart bir stilde infografik görseller üretir.",
      engine2_label: "Aidea Engine 2",
      engine2_description:
        "Slaytlar arasında değişken ve dinamik stillerle görsel açıdan zengin infografikler üretir; sahne başına daha fazla görsel oluşturur.",
      engine3_label: "Aidea Engine 3",
      engine3_description:
        "Görsellerde minimum yazı kullanan, içeriği büyük ölçüde görsellerle anlatan sade ve net bir stil üretir.",
      engine5_label: "Aidea Engine 5",
      engine5_description:
        "Az sayıda, iri ve iyi yerleştirilmiş öğelerle sade ve odaklı bir stil üretir — her görselde en fazla 6 nesne ve minimum, vurucu etiketler.",
      engine6_label: "Aidea Engine 6 (Düzenlenebilir metin)",
      engine6_description:
        "Görseldeki her başlık ve satır, ikonuyla birlikte ayrı düzenlenebilir bir metin kutusu olur ve anlatımda söylendiği anda hareketle ekrana gelir.",
      engine7_label: "Aidea Engine 7 (Karakterli)",
      engine7_description:
        "Eğitimin sabit karakter kadrosunu kullanır — yeni görsellerde de aynı karakterler aynı yüz, saç ve kıyafetle görünür.",
      engine8_label: "Aidea Engine 8 (Karakterli, yazısız)",
      engine8_description:
        "Engine 7 ile aynı karakter kadrosunu kullanır, görsellerde neredeyse hiç yazı kullanmaz.",
      engine9_label: "Aidea Engine 9 (Metin yoğun)",
      engine9_description:
        "Duyulan içeriği ekranda da okutur: başlık ve maddeler anlatımın kendi kelimeleriyle, görselin üzerinde ait oldukları yere (parçanın yanına, adımın düğümüne, haritadaki yerine) yerleştirilir.",
      provider_locked:
        "Karakterli anlatımda görseller karakter referanslarıyla üretildiği için sağlayıcı değiştirilemez.",
    },
    DefaultNarrationText:
      "Ada Lovelaca Test 01 eğitimine hoş geldiniz. Bu modülde kullanıcı davranışının psikolojik temellerini inceleyeceğiz.",
    UseTextFromAIVoice: "AI Sesinden metin kullan",
    EnterTextToBeSpokenByAvatar: "Avatar'ın konuşacağı metni girin...",
    TransparentBackground: "Şeffaf Arka Plan",
    RemoveAvatarBackground: "Avatar arka planını kaldır",
    // Avatar Narration - ek key'ler
    Time: "00:00 / 00:00",
    Avatar: "Avatar",
    Model: "Model",
    CreateFromText: "Metinden Oluştur",
    CreateFromSceneAudio: "Sahne Sesinden Oluştur",
    SelectedAudio: "Seçili Ses:",
    SceneAudioLabel: "Sahne Sesi",
    Preview: "Ön izleme:",
    NoAudioFoundInScene: "Bu sahnede ses bulunamadı.",
    AvatarVideoCreated: "Avatar Video Oluşturuldu",
    NoElementInScene: "Bu sahnede henüz element yok",
    AddToScene: "Sahneye Ekle",
    AddedToScene: "Sahneye eklendi",
    AddAgain: "Tekrar ekle",
    Provider: "Sağlayıcı",
    Language: "Dil",
    Voice: "Ses",
    Loading: "Yükleniyor",
    Gender: "Cinsiyet",
    SourceVideo: "Kaynak Video",
    Uploading: "Yükleniyor...",
    UploadVideo: "Video Yükle",
    VideoFormats: "MP4, MOV · 10s–60s",
    RecordVideo: "Video Kaydet",
    UseYourWebcam: "Webcam'inizi Kullanın",
    StartRecording: "Kaydı Başlat",
    StopRecording: "Kaydı Durdur",
    SourcePhoto: "Kaynak Fotoğraf",
    UploadPhoto: "Fotoğraf Yükle",
    PhotoFormats: "JPG, PNG · Min 512px",
    TakePhoto: "Fotoğraf Çek",
    StopCamera: "Kamerayı Durdur",
    UseYourCamera: "Kameranızı kullanın",
    CapturePhoto: "Fotoğrafı Çek",
    CameraAccessDenied: "Kamera erişimi reddedildi.",
    FailedToUploadPhoto: "Fotoğraf yüklenemedi",
    FailedToUploadPhotoRetry: "Fotoğraf yüklenemedi. Lütfen tekrar deneyin.",
    SourceTypeVideo: "Video",
    SourceTypePhoto: "Fotoğraf",
    SourceTypeAI: "Yapay Zekâ ile",
    SourceAI: "Yapay Zekâ ile Oluştur",
    AnimateProvider: "Animasyon Sağlayıcısı",
    AnimateProviderHint: "Seçilen sağlayıcı fotoğrafı canlandırmak için kullanılacaktır.",
    SaveAndUseAvatar: "Avatar'ı Oluştur ve Kullan",
    AvatarCreatingVideo: "Olu\u015fturuluyor\u2026",
    AvatarCreatingPhoto: "Canland\u0131r\u0131l\u0131yor\u2026",
    AvatarCreatingAi: "\u00dcretiliyor\u2026",
    AvatarAiMode: "Mod",
    AvatarAiModePrompt: "Prompt",
    AvatarAiModeProperties: "\u00d6zel",
    AvatarAiStyle: "Stil",
    AvatarAiPose: "Poz",
    AvatarAiPoseSeated: "Oturan",
    AvatarAiPoseStanding: "Ayakta",
    AvatarAiStyleRealistic: "Ger\u00e7ek\u00e7i",
    AvatarAiStyleCartoon: "\u00c7izgi film",
    AvatarAiStyleAnime: "Anime",
    AvatarAiStyleAnimation: "Animasyon",
    AvatarAiStyle3D: "3B Animasyon",
    AvatarAiStyleIllustration: "\u0130ll\u00fcstrasyon",
    AvatarAiPromptLabel: "Avatar\u0131n\u0131z\u0131 tan\u0131mlay\u0131n",
    AvatarAiPromptPlaceholder:
      '\u00f6rn. "30 ya\u015flar\u0131nda Akdenizli bir kad\u0131n, omuz hizas\u0131nda dalgal\u0131 kahverengi sa\u00e7lar, ela g\u00f6zler, s\u0131cak bir g\u00fcl\u00fcmseme, lacivert i\u015f ceketi, sade st\u00fcdyo arka plan\u0131."',
    AvatarAiEthnicity: "Etnik k\u00f6ken",
    AvatarAiEthnicityPlaceholder: '\u00f6rn. "Akdenizli", "Do\u011fu Asyal\u0131"',
    AvatarAiFacialFeatures: "Y\u00fcz hatlar\u0131",
    AvatarAiFacialFeaturesPlaceholder: '\u00f6rn. "oval y\u00fcz, badem g\u00f6z, d\u00fcz burun"',
    AvatarAiAgeRange: "Ya\u015f aral\u0131\u011f\u0131",
    AvatarAiHairColor: "Sa\u00e7 rengi",
    AvatarAiHairStyle: "Sa\u00e7 stili",
    AvatarAiEyeColor: "G\u00f6z rengi",
    AvatarAiSkinTone: "Ten tonu",
    AvatarAiFaceShape: "Y\u00fcz \u015fekli",
    AvatarAiBodyType: "V\u00fccut tipi",
    AvatarAiExpression: "\u0130fade",
    AvatarAiClothing: "K\u0131yafet stili",
    AvatarAiAccessories: "Aksesuarlar",
    AvatarAiAccessoriesPlaceholder: '\u00f6rn. "g\u00f6zl\u00fck, saat"',
    AvatarAiOptionOther: "Di\u011fer",
    AvatarAiOptionOtherPlaceholder: "Kendiniz yaz\u0131n\u2026",
    AvatarAiAgeCustomPlaceholder: "\u00f6rn. 30 (en az 25)",
    AvatarAiBackground: "Arka plan / ortam",
    AvatarAiEnvironment: "Mekân",
    AvatarAiProvider: "AI Sağlayıcı",
    AvatarAiProviderGemini: "Gemini",
    AvatarAiProviderGeminiFast: "Gemini Fast",
    AvatarAiProviderGrok: "Grok",
    AvatarAiContentFilterError:
      "İçerik uygun değil. Lütfen prompt veya seçimlerinizi yumuşatıp tekrar deneyin.",
    AvatarAiProcessing: "Yapay zekâ avatarın üretiliyor…",
    AvatarAiStageQueued: "Sıraya alındı…",
    AvatarAiStagePromptRefine: "Prompt iyileştiriliyor…",
    AvatarAiStageGenerating: "Video üretiliyor (birkaç dakika sürebilir)…",
    AvatarAiStageFinalizing: "Tamamlanıyor…",
    AvatarAiPreviewTitle: "Üretilen avatar ön izlemesi",
    AvatarAiRefinedPrompt: "İyileştirilmiş prompt",
    AvatarAiUseThis: "Bu avatarı kullan",
    AvatarAiGenerateAnother: "Yeniden üret",
    AvatarAiCategory: "Kategori",
    AvatarAiCategoryEducational: "Eğitim",
    AvatarAiCategoryProfessional: "Profesyonel",
    AvatarAiCategoryMarketing: "Pazarlama",
    AvatarAiCategoryTraining: "Kurs",
    AvatarAiCategoryPresentation: "Sunum",
    AvatarAiAgeTeen: "Genç (13–19)",
    AvatarAiAgeYoungAdult: "Genç yetişkin (20–29)",
    AvatarAiAgeAdult: "Yetişkin (30–49)",
    AvatarAiAgeMiddleAged: "Orta yaşlı (50–65)",
    AvatarAiAgeSenior: "Yaşlı (65+)",
    AvatarAiHairColorBlack: "Siyah",
    AvatarAiHairColorBrown: "Kahverengi",
    AvatarAiHairColorBlonde: "Sarışın",
    AvatarAiHairColorRed: "Kızıl / Kestane",
    AvatarAiHairColorGray: "Gri",
    AvatarAiHairColorWhite: "Beyaz",
    AvatarAiHairColorOther: "Diğer / Boyalı",
    AvatarAiHairStyleShort: "Kısa",
    AvatarAiHairStyleMedium: "Orta uzunluk",
    AvatarAiHairStyleLong: "Uzun",
    AvatarAiHairStyleCurly: "Kıvırcık",
    AvatarAiHairStyleWavy: "Dalgalı",
    AvatarAiHairStyleStraight: "Düz",
    AvatarAiHairStylePonytail: "At kuyruğu",
    AvatarAiHairStyleBald: "Saçsız",
    AvatarAiEyeColorBrown: "Kahverengi",
    AvatarAiEyeColorBlue: "Mavi",
    AvatarAiEyeColorGreen: "Yeşil",
    AvatarAiEyeColorHazel: "Ela",
    AvatarAiEyeColorGray: "Gri",
    AvatarAiEyeColorAmber: "Bal rengi",
    AvatarAiSkinFair: "Çok açık",
    AvatarAiSkinLight: "Açık",
    AvatarAiSkinMedium: "Orta",
    AvatarAiSkinOlive: "Buğday",
    AvatarAiSkinTan: "Bronz",
    AvatarAiSkinDark: "Koyu",
    AvatarAiSkinDeep: "Çok koyu",
    AvatarAiFaceOval: "Oval",
    AvatarAiFaceRound: "Yuvarlak",
    AvatarAiFaceSquare: "Kare",
    AvatarAiFaceHeart: "Kalp",
    AvatarAiFaceOblong: "Uzun",
    AvatarAiFaceDiamond: "Elmas",
    AvatarAiBodySlim: "İnce",
    AvatarAiBodyAthletic: "Atletik",
    AvatarAiBodyAverage: "Ortalama",
    AvatarAiBodyCurvy: "Dolgun",
    AvatarAiBodyHeavy: "Kilolu",
    AvatarAiExpressionSmile: "Gülümseme",
    AvatarAiExpressionNeutral: "Nötr",
    AvatarAiExpressionSerious: "Ciddi",
    AvatarAiExpressionFriendly: "Samimi",
    AvatarAiExpressionProfessional: "Profesyonel",
    AvatarAiClothingBusinessSuit: "İş kıyafeti",
    AvatarAiClothingBusinessCasual: "İş günlüğü",
    AvatarAiClothingSmartCasual: "Şık günlük",
    AvatarAiClothingCasual: "Günlük",
    AvatarAiClothingMedical: "Tıbbi",
    AvatarAiClothingSafetyIndustrial: "İş güvenliği / endüstriyel",
    AvatarAiClothingAcademic: "Akademik",
    AvatarAiClothingFormal: "Resmi",
    AvatarAiClothingTraditional: "Geleneksel",
    AvatarAiClothingAthletic: "Sportif",
    AvatarAiAccessoryGlasses: "Gözlük",
    AvatarAiAccessoryWatch: "Saat",
    AvatarAiAccessoryEarrings: "Küpe",
    AvatarAiAccessoryTie: "Kravat",
    AvatarAiAccessoryHeadscarf: "Başörtüsü",
    AvatarAiAccessoriesMeta: "opsiyonel · birden çok seçebilirsiniz",
    AvatarAiOptionalMeta: "opsiyonel",
    BuildYourAvatar: "Avatarını oluştur",
    AvatarSuggestFaceShape: "yüz şekli",
    AvatarSuggestMood: "ruh hali",
    AvatarSuggestLighting: "ışıklandırma",
    AvatarAiBackgroundPlain: "Sade / nötr",
    AvatarAiBackgroundStudio: "Stüdyo",
    AvatarAiBackgroundOffice: "Ofis",
    AvatarAiBackgroundOutdoor: "Açık alan",
    AvatarAiBackgroundClassroom: "Sınıf",
    AvatarAiBackgroundGradient: "Yumuşak gradyan",
    AvatarAiEnvModernStudio: "Modern minimalist stüdyo",
    AvatarAiEnvCorporateOffice: "Kurumsal ofis",
    AvatarAiEnvHomeOffice: "Ev ofisi",
    AvatarAiEnvClassroom: "Sınıf",
    AvatarAiEnvLibrary: "Kütüphane",
    AvatarAiEnvWarehouse: "Depo",
    AvatarAiEnvLab: "Laboratuvar",
    AvatarAiEnvCafe: "Kafe",
    AvatarAiEnvOutdoorUrban: "Açık alan — kentsel",
    AvatarAiEnvOutdoorNature: "Açık alan — doğa",
    AvatarAiAdditionalDetails: "Ek detaylar",
    AvatarAiAdditionalDetailsPlaceholder:
      "Eklemek istedi\u011fin ba\u015fka \u015fey (ruh hali, \u0131\u015f\u0131k, aksesuar, atmosfer)\u2026",
    InvalidVideoFormat:
      "L\u00fctfen ge\u00e7erli bir video dosyas\u0131 y\u00fckleyin (mp4, webm, mov, vb.)",
    AvatarNameRequired: "L\u00fctfen bir avatar ad\u0131 girin.",
    PleaseUploadVideo: "L\u00fctfen \u00f6nce bir video y\u00fckleyin.",
    PleaseUploadPhoto: "L\u00fctfen \u00f6nce bir foto\u011fraf y\u00fckleyin.",
    AvatarCreatedSuccess: "Avatar ba\u015far\u0131yla olu\u015fturuldu.",
    AvatarCreationFailed: "Avatar olu\u015fturma ba\u015far\u0131s\u0131z oldu.",
    AvatarCreationHint:
      "Yüz iyi aydınlatma ile net görülmelidir. Kaydedilen avatarlar tüm projelerde kullanılabilir.",
    PleaseSelectSceneAudio: "Lütfen sahne sesini seçin.",
    VoiceProfileNotFound:
      "Ses profili bulunamadı. Lütfen eğitim ayarlarından ses ayarlarını yapılandırın.",
    FailedToUploadVideo: "Video yüklenemedi",
    FailedToUploadVideoRetry: "Video yüklenemedi. Lütfen tekrar deneyin.",
    FailedToFetchVoices: "Sesler getirilemedi",
    FailedToLoadVoicesRetry: "Sesler yüklenemedi. Lütfen tekrar deneyin.",
    Use: "Kullan",
    Grid: "Izgara",
    YouDontHaveAnyRecordedScenes: "Kayıtlı bir sahneniz bulunmamaktadır",
    WriteYourSceneName: "Sahne adı yazınız",
    YouCanSeeTheScenesYouHaveRecorded:
      "Kaydettiğiniz sahneleri ekranın sol alt köşesinde 'Kayıtlı Sahnelerim' içerisinde görebilirsiniz",
    YouMustEnterASceneName: "Sahne adı girmelisiniz",
    CheckTheSubscriptionInformation: "Abonelik bilgilerini kontrol edin",
    TypeTheTextYouWantToVoiceover: "Seslendirmek istediğiniz metni yazınız",
    Create: "Oluştur",
    YouMustEnterAVoiceoverText: "Ses Metni girmelisiniz!",
    DefineTheImageYouWantToCreate: "Oluşturmak istediğiniz görseli tanımlayınız",
    YouMustEnterAPromptText: "Komut metni girmelisiniz!",
    YouCanProceedUsingTheFollowingOptionsToCreateImagesWithAI:
      "Yapay Zeka ile resim oluşturmak için aşağıdaki seçenekleri kullanarak ilerleyebilirsiniz",
    TheImageYouCreatedHasBeenAddedToMyFiles: "Oluşturduğunuz resim 'Dosyalarım'a eklenmiştir",
    YouCanAccessTheImagesYouHavePreviouslyCreatedHereOrDeleteTheImagesYouDoNotUse:
      "Daha önce oluşturduğunuz resimler buradan ulaşabilir ya da kullanmadığınız resimleri silebilirsiniz",
    ToMakeVoiceoveWithAIYouCanproceedUsingTheFollowingOptions:
      "Yapay Zeka ile seslendirme yapmak için aşağıdaki seçenekleri kullanarak ilerleyebilirsiniz",
    AiPromptText: "Ses Metni",
    AiService: "Servis",
    AiLanguage: "Dil",
    AiSound: "Ses",
    AiText: "Metin",
    AiDimension: "Boyut",
    AiQuality: "Kalite",
    AiStyle: "Sitil",
    ImprovePrompt: "Prompt'u Yapay Zeka ile geliştir",
    Lipsyncing: "Dudak Senkronizasyonu",
    BackgroundRemoval: "Arka Plan Kaldırma",
    AdvancedSettings: "Gelişmiş Ayarlar",
    GeminiGuideTitle: "Gemini TTS Ses Yönetmeni Rehberi",
    GeminiGuideColType: "Özellik Türü",
    GeminiGuideColCommand: "Komut (Etiket)",
    GeminiGuideColEffect: "Ne Yapar?",
    GeminiGuideColExample: "Örnek Kullanım",
    GeminiGuideExampleText: "Örnek Metin:",
    GeminiDirective: {
      Emotion: { type: "Duygu", effect: "Sesi enerjik ve neşeli yapar." },
      Style: { type: "Stil", effect: "Sesi gizemli bir fısıltıya dönüştürür." },
      Time: { type: "Zaman", effect: "Belirtilen sürede doğal duraklama ekler." },
      Speed: { type: "Hız", effect: "Konuşmayı hızlandırır (Önemli uyarılar vb.)." },
      Pitch: { type: "Perde", effect: "Sesi kalınlaştırıp daha otoriter yapar." },
      Scene: { type: "Sahne", effect: "Yankısız, pürüzsüz stüdyo ortamı sağlar." },
    },
    youtube: "Youtube",
    youtube_search_button: "Ara",
    youtube_search_placeholder: "Youtube'da ara...",
    add_to_scene: "Sahneye Ekle",
    save: "Kaydet",
    save_as: "Farklı Kaydet",
    import: "İçeri Aktar",
    export: "Dışa Aktar",
    export_to_lms: "LMS'e Aktar",
    language: "Dil",
    sign_out: "Çıkış Yap",
    preview: "Ön izleme",
    ai_studio: "AI Studio",
    ai_studio_tooltip: "AI Studio'yu Aç",
    elements: "Öğeler",
    smart_elements: "Akıllı Öğeler",
    basic_elements: "Öğeler",
    click_menu: "Tıklama Menüsü",
    sounds_panel: "Sesler",
    shapes_panel: "Şekiller",
    logo_intro_panel: "Intro",
    ShapeSettings: {
      tab_fill: "Dolgu",
      tab_stroke_color: "Çizgi Rengi",
      tab_stroke_style: "Çizgi Stili",
      tab_radius: "Köşe Yuvarlaklığı",
      tab_shadow: "Gölge",
      tab_text: "Metin Kutusu",
      fill_none: "Dolgu yok",
      fill_solid: "Düz renk",
      fill_gradient: "Renk geçişi",
      main_color: "Ana renk",
      second_color: "İkinci renk",
      angle: "Açı",
      color: "Renk",
      width: "Kalınlık",
      dash: "Tür",
      dash_solid: "Düz",
      dash_dashed: "Kesik",
      dash_dotted: "Noktalı",
      start_cap: "Başlangıç ucu",
      end_cap: "Bitiş ucu",
      cap_none: "Yok",
      cap_arrow: "Ok",
      cap_circle: "Daire",
      line_cap: "Uç şekli",
      line_cap_butt: "Düz",
      line_cap_round: "Yuvarlak",
      radius: "Yarıçap",
      radius_full: "Tam",
      shadow_soft: "Hafif",
      shadow_medium: "Orta",
      shadow_strong: "Belirgin",
      blur: "Bulanıklık",
      text_placeholder: "Şeklin içine yazı yazın…",
      font: "Yazı tipi",
      font_default: "Varsayılan",
      size: "Boyut",
      bold: "Kalın",
      italic: "İtalik",
      padding: "İç boşluk",
      shadow_none: "Yok",
      align: "Hizalama",
      align_left: "Sola",
      align_center: "Ortaya",
      align_right: "Sağa",
      valign: "Dikey hizalama",
      valign_top: "Üst",
      valign_middle: "Orta",
      valign_bottom: "Alt",
    },
    ShapesPanel: {
      count: "{{count}} şekil",
      empty: "Aramanla eşleşen şekil yok",
      back: "Geri",
    },
    sounds_all: "Tümü",
    sounds_sfx: "Ses Efektleri",
    sounds_music: "Müzik",
    sounds_jingles: "Cıngıllar",
    sounds_back: "Geri",
    sounds_dur_short: "Kısa",
    sounds_dur_medium: "Orta",
    sounds_dur_long: "Uzun",
    sound_add_cue: "Tıklama sesi olarak ekle",
    sound_add_scene: "Sahne sesi olarak ekle",
    sounds_my_effects: "Efektlerim",
    sound_fx_new: "Efekt Oluştur",
    sound_fx_prompt_ph: "Efekt açıklaması (ör. boş taş salonda kapanan ağır ahşap kapı)",
    sound_fx_enrich: "AI ile zenginleştir",
    sound_fx_system_ph: "System prompt (boş = varsayılan ses tasarımı yönergesi)",
    sound_fx_duration: "Süre (sn)",
    sound_fx_influence: "Prompt etkisi",
    sound_fx_low: "Düşük",
    sound_fx_mid: "Orta",
    sound_fx_high: "Yüksek",
    sound_fx_count: "Adet",
    sound_fx_loop: "Döngü",
    sound_fx_generate: "Efekt Oluştur",
    sound_fx_generating: "Oluşturuluyor…",
    sound_fx_error: "Efekt oluşturulamadı",
    sound_fx_empty: "Henüz efekt yok",
    sound_fx_empty_hint: "Yukarıdan ilk efektini oluştur",
    auto: "oto",
    other: "Diğer",
    SmartElements_Groups_Text: "Metin",
    SmartElements_Groups_Lists: "Listeler",
    SmartElements_Groups_Layout: "Düzen",
    SmartElements_Groups_DataMedia: "Veri ve Medya",
    SmartElements_Groups_UI: "UI Öğeleri",
    SmartElements_Types_heading: "Başlık",
    SmartElements_Types_eyebrow: "Üst Başlık",
    SmartElements_Types_footer: "Alt Bilgi",
    SmartElements_Types_quote: "Alıntı",
    SmartElements_Types_bullet_list: "Maddeleme",
    SmartElements_Types_card_grid: "Kartlar",
    SmartElements_Types_timeline: "Zaman Çizelgesi",
    SmartElements_Types_stat_group: "İstatistikler",
    SmartElements_Types_hero: "Ana başlık",
    SmartElements_Types_section: "Bölüm",
    SmartElements_Types_two_column: "İkili Sütun",
    SmartElements_Types_comparison: "Karşılaştırma",
    SmartElements_Types_chart: "Grafik",
    SmartElements_Types_image: "Görsel",
    SmartElements_Types_divider: "Ayraç",
    SmartElements_Types_badge: "Etiket",
    SmartElements_Types_cta_button: "Aksiyon Butonu",
    SmartElements_Types_icon_block: "İkon Bloğu",
    SmartElements_Types_flip: "Çevrilen Kart",
    SmartElements_Types_dragBuild: "Sürükle & Eşleştir",
    SmartElements_Types_reveal: "Açılır Panel",
    SE_sample_heading: "Başlık",
    SE_sample_eyebrow: "Üst Başlık Etiketi",
    SE_sample_footer: "Alt bilgi notu",
    SE_sample_bullet_title: "Önemli Noktalar",
    SE_sample_bullet_point: "Madde {{n}}",
    SE_sample_card_title: "Özellik Kartları",
    SE_sample_card_item_title: "Kart {{n}}",
    SE_sample_card_item_body: "Açıklama {{n}}",
    SE_sample_timeline_title: "Zaman Çizelgesi",
    SE_sample_timeline_step: "Adım {{n}}",
    SE_sample_timeline_step_body: "Açıklama",
    SE_sample_stat_label: "Metrik {{n}}",
    SE_sample_quote_text: "Alıntınız buraya gelir.",
    SE_sample_quote_author: "Yazar Adı",
    SE_sample_hero_heading: "Ana Başlık",
    SE_sample_hero_body: "Destekleyici alt başlık metni",
    SE_sample_2col_left_title: "Sol Sütun",
    SE_sample_2col_right_title: "Sağ Sütun",
    SE_sample_2col_body: "İçerik buraya",
    SE_sample_comp_option: "Seçenek {{letter}}",
    SE_sample_comp_feature: "Özellik {{n}}",
    SE_sample_section_heading: "Bölüm Başlığı",
    SE_sample_section_body: "Bölüm içeriği",
    SE_sample_badge: "Rozet",
    SE_sample_cta: "Başla",
    SE_sample_icon_title: "Özellik",
    SE_sample_icon_body: "Açıklama",
    SE_sample_flip_front_title: "Soru",
    SE_sample_flip_front: "Cevabı görmek için karta tıklayın.",
    SE_sample_flip_back_title: "Cevap",
    SE_sample_flip_back: "Açıklamayı buraya yazın.",
    SE_sample_drag_prompt: "Her öğeyi grubuyla eşleştirin.",
    SE_sample_drag_token: "Öğe {{n}}",
    SE_sample_drag_zone: "Grup {{n}}",
    SE_sample_reveal_title: "Doz etkileşimi",
    SE_sample_reveal_text: "Bu iki ilacı birlikte kullanmak riski artırır...",
    PluginNames_BasicText: "Zengin Metin",
    PluginNames_RichText: "Zengin Metin",
    PluginNames_DataTable: "Tablo",
    PluginNames_GraficaD3: "Grafik",
    PluginNames_EnrichedPlayer: "Video",
    PluginNames_HotspotImages: "Resim",
    PluginNames_AudioCue: "Ses İşareti",
    PluginNames_HtmlContent: "HTML İçerik",
    PluginNames_EnrichedAudio: "Ses Oynatıcı",
    PluginNames_EnrichedPDF: "PDF Gösterici",
    PluginNames_OneClick: "Tıklama",
    PluginNames_Characters: "Karakterler",
    PluginNames_ScormPackage: "SCORM Paketi",
    PluginNames_Shapes: "Şekiller",
    PluginNames_ShapeOverlay: "Şekil Kaplaması",
    PluginNames_VectorShape: "Şekil",
    PluginNames_VirtualTour: "Google Harita",
    PluginNames_Visor3D: "Visor 3D",
    PluginNames_Webpage: "Web İçeriği",
    PluginNames_MultipleChoice: "Çoktan Tek Seçim",
    PluginNames_MultipleAnswer: "Çoktan Çok Seçim",
    PluginNames_TrueFalse: "Doğru/Yanlış",
    PluginNames_FillInBlank: "Boşluk Doldur",
    PluginNames_FreeResponse: "Açık Uçlu",
    PluginNames_Matching: "Eşleştirme",
    PluginNames_Ordering: "Sıralama",
    PluginNames_Rating: "Sıralama",
    PluginNames_DragDrop: "Sürükle Bırak",
    PluginNames_InputText: "Kullanıcı Girişi",
    PluginNames_AtomicBoxPlugin: "AI İçerik Elementi",
    PluginNames_GuideMultiInput: "Ekran Eğitimi Çoklu Giriş",
    PluginNames_GuideTagDisplay: "Ekran Eğitimi Etiket Gösterimi",
    ai: "Yapay Zeka",
    ai_images: "Görsel",
    ai_sounds: "Ses",
    ai_avatars: "Avatar",
    basic: "Temel",
    data: "Veri",
    text: "Metin",
    multimedia: "Multimedya",
    objects: "Nesneler",
    assessments: "Sorular",
    components: "Bileşenler",
    library: "Kütüphane",
    upload_files: "Dosya Yükle",
    my_files: "Dosyalarım",
    org_files: "Ortak Dosyalar",
    brand_files: "Marka",
    BrandPanel: {
      font_pick: "Google fontu seç…",
      font_adding: "Ekleniyor…",
      kind_logo: "Logolar",
      kind_photo: "Fotoğraflar",
      kind_graphic: "Grafik bileşenler",
      kind_icon: "Simgeler",
      kind_chart: "Grafikler",
      kind_font: "Yazı tipleri",
      uploading: "Yükleniyor",
      no_results: "Sonuç bulunamadı",
      empty_kind: "Henüz yok",
      primary: "Ana",
      make_primary: "Ana logo yap",
      back: "Geri",
      no_brands: "Henüz marka yok",
      no_brands_hint: "Markalar konsoldaki Marka Şablonları sayfasından oluşturulur.",
      font_not_placeable: "Yazı tipleri şimdilik sahneye eklenemez",
      apply_position_all: "Tüm sahnelerde konumu güncelle",
      rightclick_hint:
        "Tıklayınca bu sahneye eklenir. Kanvasta sağ tıklayıp “Tüm sahnelerde konumu güncelle” derseniz tüm sahnelerde aynı konuma yerleşir.",
      new_category: "Yeni kategori",
      category_name_placeholder: "Kategori adı",
      rename: "Yeniden adlandır",
      delete_category: "Kategoriyi sil",
      delete_category_confirm: "ve içindeki {{count}} dosya silinecek.",
      colors: "Renkler",
      colors_unit: "renk",
      colors_hint:
        "Bir renge tıklayın: seçili metne ya da şekle uygulanır; hiçbir şey seçili değilse sahnenin arka planına.",
      colors_empty: "Henüz marka rengi yok",
      color_applied_text: "Metne uygulandı",
      color_applied_shape: "Şekle uygulandı",
      color_applied_background: "Sahne arka planına uygulandı",
      color_unsupported: "Bu öğeye renk uygulanamaz",
      color_pick: "Renk seç",
      color_hex: "Hex kodu",
      color_primary: "Birincil Renk",
      color_secondary: "İkincil Renk",
      color_accent: "Vurgu Rengi",
      color_apply: "Uygula",
      color_invalid: "#40cfde gibi bir hex renk girin",
      delete_color_set: "Renk setini sil",
      color_set_new: "Yeni renk seti",
      color_set_name: "Renk seti adı",
      color_set_default: "Renk seti {{n}}",
      color_sets_unit: "renk seti",
      color_clear: "Rengi kaldır",
      color_empty: "Boş",
    },
    BoxContextMenu: {
      apply_font_all_scenes: "Bu fontu tüm sahnelere uygula",
    },
    OrgFiles: "Ortak Dosyalar",
    ClonedVoices: "Klon Ses",
    CourseVideo: "Kurs Videoları",
    Transcription: "Transkripsiyon",
    AnimatedImage: "Hareketli Resim",
    TimelineAnimatedImage: "Video Görsel",
    icons: "İkonlar",
    animations: "Animasyonlar",
    characters: "Karakterler",
    search: "Ara",
    all: "Hepsi",
    image: "Resim",
    audio: "Ses",
    video: "Video",
    csv: "CSV",
    pdf: "PDF",
    delete: "Sil",
    files: "dosya",
    loading: "Yükleniyor...",
    no_files_found: "Dosya Bulunamadı",
    load_more: "Daha Fazla Yükle",
    no_trainings_found: "Eğitim bulunamadı",
    unassigned_files: "Atanmamış Dosyalar",
    show_list_view: "Liste Görünümü",
    show_grouped_view: "Gruplu Görünüm",
    files_load_error: "Dosyalar yüklenemedi",
    listen: "Dinle",
    download: "İndir",
    file: "Dosya",
    cancel: "İptal",
    close: "Kapat",
    more_filters: "Daha fazla filtre",
    collapse: "Daralt",
    try_other_search: "Farklı bir arama deneyin.",
    searching: "Aranıyor…",
    youtube_search: "YouTube'da ara",
    youtube_search_hint: "Yazıp Enter'a basın.",
    library_ai: "YZ",
    library_details: "Ayrıntılar",
    library_video_drafts: "Video taslakları",
    library_video_drafts_empty: "Henüz video taslağı yok",
    library_type: "Tür",
    library_date: "Tarih",
    library_duration: "Süre",
    library_provider: "Model",
    library_prompt: "İstem",
    library_copy_prompt: "İstemi kopyala",
    library_director: "Video Director",
    library_logline: "Özet",
    library_shot: "Çekim",
    library_more: "Daha fazla",
    library_less: "Daha az",
    library_open_in_director: "Director'da aç",
    library_project_unavailable: "Proje kullanılamıyor",
    delete_file_title: "Dosyayı sil",
    delete_file_confirm_prefix: "",
    delete_file_confirm_suffix:
      " dosyasını silmek istediğinize emin misiniz? Bu işlem geri alınamaz.",
    animation_fade: "Solma",
    animation_flip: "Çevirme",
    animation_pinwheel: "Çarkfelek",
    animation_roll: "Yuvarlanma",
    animation_rotate: "Döndürme",
    animation_stretch: "Uzatma",
    animation_zoom: "Yakınlaştırma",
    animation_pan: "Kaydırma",
    lipsync_title: "Dudak Uydurma",
    lipsync_select_narration: "Anlatım Sesi Seç",
    lipsync_choose_audio: "Videonuzla eşleştirmek için sahneden bir ses parçası seçin",
    lipsync_select_audio_video_error:
      "Lütfen bir ses seçin ve videonun mevcut olduğundan emin olun",
    lipsync_success_message:
      "Dudak uydurma başarıyla tamamlandı! Video yeni dudak uydurulmuş versiyonla güncellendi.",
    lipsync_background_removal: "Arka Plan Kaldırma",
    lipsync_generating: "Oluşturuluyor...",
    lipsync_generate: "Oluştur",
    error: "Hata",

    AudioPanel: {
      Audio: "Bilgi Bankası",
      SceneSounds: "Sahne Sesleri",
      DocumentSummary: "Özet",
      DocumentTitles: "Doküman Başlıkları",
      Outline: "Doküman Taslağı",
      Mindmap: "Zihin Haritası",
      NarrationTexts: "Anlatım Metinleri",
      Loading: "Yükleniyor...",
      NoSummaryAvailable: "Özet mevcut değil",
      NoOutlineAvailable: "Ders taslağı mevcut değil",
      NoNarrationTexts: "Bu eğitim için kayıtlı anlatım metni yok.",
      ErrorLoadingData: "Veri yüklenirken hata oluştu",
      ErrorPrefix: "Hata",
      AllocatedScenes: "sahne",
      CourseInfo: "Doküman Bilgisi",
      Sections: "Bölümler",
      CopyAll: "Tümünü Kopyala",
      SlideNotes: "Slayt notları",
      Copied: "Kopyalandı!",
    },

    Animation: {
      Animation: "Efekt",
      FirstPositionX: "İlk Pozisyon X",
      FirstPositionY: "İlk Pozisyon Y",
      LastPositionX: "Son Pozisyon X",
      LastPositionY: "Son Pozisyon Y",
      Firstwidth: "İlk Genişlik",
      FirstHeight: "İlk Yükseklik",
      Lastwidth: "Son Genişlik",
      LastHeight: "Son Yükseklik",
      FirstOpacity: "İlk Opaklık Değeri",
      LastOpacity: "Son Opaklık Değeri",
      FirstDuration: "İlk Süre(Sn)",
      LastDuration: "Son Süre(Sn)",
      add_animation: "Animasyon Ekleme",
      add_animation_shortcuts: "Animasyon Ekle",
      position_add: "Pozisyon Ekle",
      edit_animation: "Animasyonu Düzenle",
      First_Position: "İlk Pozisyon",
      Last_Position: "Son Pozisyon",
      PositionX: "Pozisyon X",
      PositionY: "Pozisyon Y",
      Opacity: "Opaklık",
      Width: "Genişlik",
      Height: "Yükseklik",
      Duration: "Süre(Saniye)",
      animation_reset: "Animasyonu Sıfırla",
      PositionNumber: "Pozisyon Sayısı",
      MiddlePositionX: "Ara Pozisyon X",
      MiddlePositionY: "Ara Pozisyon Y",
      Middlewidth: "Orta Genişlik",
      MiddleHeight: "Orta Yükseklik",
      MiddleOpacity: "Orta Opaklık Değeri",
      MiddleDuration: "Orta Süre(Sn)",
      Middle_Position: "Ara Pozisyon",
      ShowAnimation: "Animasyon Özellikleri",
    },
    "16/9": "16:9 Olarak Ayarla",
    "4/3": "4:3 Olarak Ayarla",
    Accept: "Onayla",
    Animations: "Animasyonlar",
    Alignment: "Hizalama",
    Advanced: "Gelişmiş",
    Aspect_ratio: "En Boy Oranı",
    Auto: "Otomatik",
    AddStartAnimation: "Animasyonu Başlat",
    AddEndAnimation: "Animasyonu Bitir",
    EditAnimation: "Animasyonu Düzenle",
    AddMiddleAnimation: "Ara Animasyon Ekle",

    background: {
      background: "Arka Plan",
      background_color: "Rengi Değiştir",
      background_image: "Arka Plan Resmi",
      background_zoom: "Arka Plan Yakınlaştırma ",
      reset_background: "Arka Plan Sıfırla",
      background_input_url: "Arka Plan Resim URL",
      cover: "Kapak Sayfası",
      repeat: "Resmi Tekrarla",
      centered: "Ortalanmış Resim",
      fit: "Resmi Sığdır",
      background_opacity: "Arka Plan Opaklığı",
    },
    Block: "Blok",
    Question: "Soru",
    Answer: "Cevap",
    Feedback: "Geri Bildirim",
    TrueFeedback: "Doğru Geri Bildirim",
    FalseFeedback: "Yanlış Geri Bildirim",
    Element: "Öğe",
    Option: "Seçenek",
    Breadcrumb: "Sayfa İçerik Yolu",
    Cancel: "İptal",
    save_as_modal: "Farklı Kaydet",
    save_as_modal_aspect_ratio: "En-boy oranı",
    save_as_modal_ratio_change_warning:
      "Aynı içerikler {{ratio}} en-boy oranında kaydedilecektir. En-boy oranı değişikliklerinde sahne elementleri tam yerleşemeyebilir.",
    TrainingName: "Eğitim Adı",
    TrainingDescription: "Açıklama",
    SoundLoading: "Ses Yükleniyor...",
    SoundLoaded: "Ses Yüklendi",
    AudioName: "Ses Adı: ",
    EnterAudioName: "Ses adını girin",
    upload_sound_record: "Sesi Kaydet",
    Upload: "Yükle",
    Cancel: "Vazgeç",
    clipboard: {
      copy: "Kopyala",
      copyPaste: "Kopyala / Yapıştır",
      cut: "Kes",
      paste: "Yapıştır",
      duplicate: "Yanına Kopyala",
      to: "-e",
      msg: "Bu işlevler için klavye kısayolu kullanın : ",
      zoomIn: "Yakınlaştır",
      zoomOut: "Uzaklaştır",
      zoomReset: "%100'e sıfırla",
    },
    configuration: "Konfigürasyon",
    confirm_changes: "Değişiklikleri Onayla",
    Container_: "İçerik Taşıyıcı",
    contained_view: "İşaret İçeriği",
    oneclick_view: "Tıklama İçeriği",
    CONTAINED_VIEWS: "İŞARET İÇERİĞİ",
    contained_view_popover: "Bu işaret içeriği linki buradan:",
    contained_view_nowhere: "Nowhere",
    col_dist: "Sütun Dağılımı",
    col_number: "Sütun Sayısı",
    content: "İçerik",
    COURSE: "DOKÜMAN",
    course: "Doküman",
    course_title: "Eğitim Başlığı",
    "create new document": "Yeni Sayfa Oluştur",
    "create new folder": "Yeni Bölüm Oluştur",
    "create new slide": "Yeni Sahne Oluştur",
    delete_contained_canvas: "İçerik Kanvası Sil",
    delete_container: "Bloğu Sil",
    delete_page: "Sahneyi Sil",
    delete_section: "Bölümü Sil",
    delete: "Sil",
    display: "Göster",
    display_page: "Sahneyi Gizle/Göster",
    dropbox_msg: "Dropbox dosyalarına göz atmak için buraya tıkla",
    dropbox_msg_alt: "Başka dosya seç",
    document: "Doküman",
    DuplicateNavItem: "Sahneyi Kopyala",
    edit_text: "Yazıyı Düzenle",
    fitToScreen: "Ekrana Sığdır",
    exitModal: {
      Body: "Aideapro Studio'dan çıkmak istiyor musunuz?",
      cancel: "İptal",
      leave_without_changes: "Değişiklikleri kaydetmeden çık",
      save_and_exit: "Kaydet ve Çık",
      Title: "Aideapro Studio'dan Çık",
    },
    unsavedChangesGuard: {
      title: "Kaydedilmemiş değişiklikler",
      body: "Kaydedilmemiş değişiklikleriniz var. Ayrılmadan önce ne yapmak istersiniz?",
      stay: "Sayfada Kal",
      leaveWithoutSaving: "Kaydetmeden Çık",
      saveAndLeave: "Kaydet ve Çık",
      saving: "Kaydediliyor…",
      saveError: "Değişiklikleriniz kaydedilemedi. Lütfen tekrar deneyin.",
    },
    staleTraining: {
      message:
        "Bu eğitim başka bir sekmede veya başka biri tarafından kaydedildi. Değişikliklerinin üzerine yazmamak için kaydetmeden önce sayfayı yenile.",
      reload: "Yenile",
    },
    saveConflict: {
      title: "Bu eğitim başka bir yerden değiştirildi",
      body: "Bu sekme eğitimi yükledikten sonra başka biri (veya bir sistem süreci) daha yeni bir sürüm kaydetti. Kendi sürümünüzle devam etmek mi, yoksa diğer sürümü yüklemek mi istediğinizi seçin.",
      currentUpdatedAt: "Diğer sürümün kayıt zamanı: {{when}}",
      cancel: "İptal",
      reload: "Değişikliklerimi yok say ve yeniden yükle",
      reloading: "Yeniden yükleniyor…",
      overwrite: "Kendi sürümümle üzerine yaz",
      overwriting: "Kaydediliyor…",
    },
    empty: {
      cv_empty: "Henüz işaret içeriği oluşturmadınız.",
    },
    EmptyPresentation: "Bu doküman boş",
    error: {
      exporting: "İşlem sırasında bir hata oluştu",
      generic: "Hata Oluştu",
      importing: "İşlem sırasında bir hata oluştu",
      reaching_server: "Servera ulaşılamıyor",
      searching: "Arama sırasında bir hata oluştu",
      deleting: "Silme sırasında bir hata oluştu",
      mandatory: "Bir sonraki sahneye geçebilmek için geçerli sahneyi tamamlamalısınız!",
      mandatorytwo: "Bu sahneye geçebilmeniz için önceki sahneleri tamamlamanız gerekmektedir!",
      mandatoryCompleted:
        "Zorunluluk kapatıldığında varsayılan izlendi olma süresi {{seconds}} saniyedir. Bu süre dolmadan geçilen sahneler izlendi olmayabilir.",
      warning: "Dikkat",
      networkError: "Ağ hatası. Lütfen tekrar deneyin.",
      organizationIdNotFound:
        "Token içinde organizasyon kimliği bulunamadı. Lütfen tekrar giriş yapın.",
      failedToCloneVoice: "Ses klonlanamadı.",
      failedToDeleteVoice: "Ses silinemedi.",
      failedToGenerateAudio: "Ses oluşturulamadı.",
      serviceError: "Servis Hatası",
      systemError: "Sistem Hatası",
      file_not_selected: "Dosya seçilmedi",
    },
    Evaluation: "Etkileşim",
    Exercises: "Sınavlar",
    TimeLine: "Zaman Çizelgesi",
    Library: "Kütüphane",
    Exporting: "Yayımlanıyor...",
    FileDialog: "Dosya",
    FileInput: {
      Message: "Sürükleyin veya bir dosya seçin",
      MessageMulti: "Dosyaları buraya sürükleyip bırakın",
      ClickHint: "veya seçmek için tıklayın — birden çok dosya seçebilirsiniz",
      Drag: "Sürükle",
      Drag_2: " bir dosya veya ",
      Click: "Tıkla",
      Click_2: " Ara ",
    },
    FileModal: {
      APIProviders: {
        MyFiles: "Dosyalarım",
        Animations: "Animasyonlar",
        Shapes: "Şekiller",
        Characters: "Karakterler",
        AIAvatarsText: "AI Avatarlar",
        MyFilesTitle: "Bu dokümana eklenen dosyalar",
        UploadFiles: "Dosya Yükle",
        UploadFilesTitle: "Bilgisayardan dosya yükle...",
        UploadNewFile: "Yeni Dosya Yükle",
        no_files: "Bu arama kriterine uygun dosya bulunamadı",
        results: "Sonuçlar",
        searching: "Aranıyor...",
        error: "Dosyanız yüklenemedi",
        errorHint:
          "Lütfen tekrar deneyin. Sorun devam ederse, ayrıntıları Aidea ekibine göndermek için bilgi simgesine tıklayın.",
        errorDetailsTitle: "Teknik ayrıntıları göster",
        errorReportTitle: "Teknik ayrıntılar",
        errorReportIntro:
          "Yaşanan sorun için özür dileriz. Aşağıdaki metni kopyalayıp Aidea ekibine gönderin, size yardımcı olalım.",
        copyReport: "Ayrıntıları kopyala",
        copied: "Kopyalandı!",
        warning_allowed: "Bu dosya düzenlediğiniz dosya ile uyumlu değil",
        warning_forbidden: "Bu dosyaya Aideapro Studio izin vermiyor",
        warning_too_large: "Dosya {{max}}MB'den büyük olamaz",
        uploaded: "Dosya kütüphaneye başarıyla yüklendi",
        addToScene: "Sahneye Ekle",
        addAllToScene: "Tümünü Sahneye Ekle",
        addingToScene: "Sahneye ekleniyor…",
        upload: "Yükle",
        clear: "Temizle",
        search: "Ara",
        confirm_delete: "Bu dosyayı silmek istediğinize emin misiniz?",
        confirm_delete_all: "Bu dosyaları silmek istediğinize emin misiniz?",
        delete_all: "Hepsini Sil",
        library: "Simgeler",
        AIAvatars: {
          Description:
            "Yapay zeka destekli avatar videoları oluşturun - metin-konuşma ve dudak senkronizasyonu teknolojisi ile",
          SelectAvatar: "Avatar Seç",
          SelectAvatarForEditing: "Düzenlemek için Avatar Seç",
          SelectedAvatar: "Seçilen Avatar",
          PreviewVideo: "Ön izleme",
          EditExisting: "Mevcut Avatar Videolarını Düzenle",
          EditDescription:
            "Düzenleme modunda, daha önce oluşturulan avatar videolarını değiştirebilirsiniz. Parametrelerini düzenlemek ve yeniden oluşturmak için aşağıdan bir video seçin.",
          NoExistingVideos: "Düzenlenecek video yok",
          CreateSomeVideosFirst: "Önce birkaç avatar videosu oluşturun",
          ScriptText: "Metin Senaryosu",
          ScriptPlaceholder: "Avatarınızın konuşmasını istediğiniz metni girin...",
          ScriptHint: "Maksimum 4096 karakter. Duraklamalar için <break time='500ms'/> kullanın.",
          VoiceService: "Ses Servisi",
          Language: "Dil",
          Voice: "Ses",
          Create: "Oluştur",
          CreateMode: "Oluşturma Modu",
          EditMode: "Düzenleme Modu",
          Processing: "İşleniyor...",
          Regenerate: "Yeniden Oluştur",
          PleaseWait: "Lütfen bekleyin...",
          JobStatus: "Avatar videosu işleniyor...",
          VideoGenerated: "Oluşturulan avatar videosu dosyalarınıza eklenmiştir.",
          AccessPrevious:
            "Daha önce oluşturulmuş avatarlara 'Dosyalarım' bölümünden erişebilirsiniz.",
          ErrorNoText: "Avatar için metin girmelisiniz",
          ErrorTextTooShort: "Tavus için metin en az 45 karakter olmalıdır.",
          ErrorNoAvatar: "Bir avatar seçmelisiniz",
          LoadingAvatars: "Avatarlar yükleniyor...",
          NoAvatarsAvailable: "Kullanılabilir avatar yok",
          FailedToLoadAvatars: "Avatarlar yüklenemedi",
          ErrorLoadingAvatars: "Avatarlar yüklenirken hata oluştu",
          ProviderType: "Sağlayıcı",
          Gender: "Cinsiyet",
          AllGenders: "Tüm Cinsiyetler",
          Male: "Erkek",
          Female: "Kadın",
          ProviderTypes: {
            AI: "Yapay Zeka",
            Human: "İnsan",
          },
          Avatars: "avatar",
          NoAvatarsMatch: "Seçilen filtrelere uygun avatar bulunamadı",
          NoVoicesAvailable: "Mevcut ses yok",
          EnableTransparentBackground: "Şeffaf arka planı etkinleştir",
          VideoNotSupported: "Tarayıcınız video oynatmayı desteklemiyor.",
          NoPreviewVideo: "Ön izleme videosu yok",
          PlayVoiceSample: "Ses örneğini çal",
          Step1SelectAvatar: "Avatar Seç",
          Step2Settings: "Avatar Ayarları",
          Next: "Devam",
          Back: "Geri",
          // Aidea özel
          SourceType: "Kaynak Türü",
          SelectSourceType: "Kaynak Türü Seçin",
          StockAvatar: "Hazır Avatar",
          UploadVideo: "Videodan Klonla",
          ImageToVideo: "Görselden Klonla",
          ImageProvider: "Görsel Sağlayıcı",
          SelectProvider: "Sağlayıcı Seçin",
          ClickToUploadVideo: "Video yüklemek için tıklayın",
          ChangeVideo: "Videoyu Değiştir",
          SupportedFormats: "Desteklenen: MP4, MOV, AVI",
          UploadingVideo: "Video yükleniyor...",
          ClickToUploadImage: "Görsel yüklemek için tıklayın",
          ChangeImage: "Görseli Değiştir",
          SupportedImageFormats: "Desteklenen: JPG, PNG",
          UploadingImage: "Görsel yükleniyor...",
          AudioSource: "Ses Kaynağı",
          SelectAudioSource: "Ses Kaynağı Seçin",
          UploadAudio: "Ses Yükle",
          TextToSpeech: "Metinden Sese",
          ClickToUploadAudio: "Ses dosyası yüklemek için tıklayın",
          ChangeAudio: "Değiştir",
          UploadingAudio: "Ses yükleniyor...",
          SelectedSource: "Seçilen Kaynak",
          UploadedVideo: "Yüklenen Video",
          ErrorNoSourceType: "Lütfen bir kaynak türü seçin",
          ErrorNoVideo: "Lütfen bir video yükleyin",
          ErrorNoProvider: "Lütfen bir sağlayıcı seçin",
          ErrorNoImage: "Lütfen bir görsel yükleyin",
          ErrorNoAudioSource: "Lütfen ses kaynağı seçin",
          ErrorNoAudio: "Lütfen ses yükleyin",
          // TTS specific
          TTSProvider: "TTS Sağlayıcı",
          SelectTTSProvider: "TTS Sağlayıcı Seçin",
          LoadingVoices: "Sesler yükleniyor...",
          VoiceGender: "Ses Cinsiyeti",
          VoiceLanguage: "Ses Dili",
          AllLanguages: "Tüm Diller",
          SelectVoice: "Ses Seçin",
          TransparentBackground: "Şeffaf Arka Plan",
          ErrorNoTTSProvider: "Lütfen TTS sağlayıcı seçin",
          ErrorNoVoice: "Lütfen bir ses seçin",
          // Sahne sesi ve ön izleme
          SelectedAudio: "Seçili Ses:",
          SceneAudio: "Sahne Sesi",
          Preview: "Ön izleme:",
          NoAudioFoundInScene: "Bu sahnede ses bulunamadı.",
          CreateFromText: "Metinden Oluştur",
          CreateFromSceneAudio: "Sahne Sesinden Oluştur",
          AvatarVideoCreated: "Avatar Video Oluşturuldu",
          AddToScene: "Sahneye Ekle",
          Provider: "Sağlayıcı",
          // Custom Avatar
          SourceVideo: "Kaynak Video",
          Uploading: "Yükleniyor...",
          VideoFormats: "MP4, MOV · 10s–60s",
          RecordVideo: "Video Kaydet",
          UseYourWebcam: "Webcam'inizi Kullanın",
          SaveAndUseAvatar: "Avatar'ı Oluştur ve Kullan",
          AvatarCreationHint:
            "Yüz iyi aydınlatma ile net görülmelidir. Kaydedilen avatarlar tüm projelerde kullanılabilir.",
          // Hata mesajları
          PleaseSelectSceneAudio: "Lütfen sahne sesini seçin.",
          VoiceProfileNotFound:
            "Ses profili bulunamadı. Lütfen eğitim ayarlarından ses ayarlarını yapılandırın.",
          FailedToUploadVideo: "Video yüklenemedi",
          FailedToUploadVideoRetry: "Video yüklenemedi. Lütfen tekrar deneyin.",
          FailedToFetchVoices: "Sesler getirilemedi",
          FailedToLoadVoicesRetry: "Sesler yüklenemedi. Lütfen tekrar deneyin.",
          // Görselden Video Yönergeleri
          ImageGuidelinesTitle: "Örnek Yönergeler",
          ExamplePhoto: "Örnek Fotoğraf",
          GuidelinesTitle: "Fotoğraf Gereksinimleri",
          Guideline1: "Yüz tam ön açıdan ve net görünüyor",
          Guideline2: "Dikkati dağıtmayan düz arka plan",
          Guideline3: "İyi aydınlatma ile çekilmiş",
          Guideline4: "Yüz yakın plan çekim",
          Guideline5: "Gözler açık ve kameraya bakıyor",
          Guideline6: "Doğal ifade ve duruş",
          Guideline7: "Yüksek çözünürlüklü fotoğraf",
        },
        ImageStyles: {
          Title: "AI Görsel Stil Kütüphanesi",
          Description:
            "Önceden tasarlanmış stiller veya kendi özel ipuçlarınızla çarpıcı görseller oluşturun",
          StyleTemplates: "Stil Şablonları",
          CustomizePrompt: "İpucu Metnini Özelleştirin",
          PromptPlaceholder: "Yukarıdan bir stil seçin veya özel ipucunuzu girin...",
          PromptHint: "En iyi sonuçlar için oluşturmak istediğiniz görseli detaylıca açıklayın.",
          AIProvider: "AI Sağlayıcısı",
          AutoProvider: "Otomatik",
          CustomProvider: "Özel",
          AnimateAndAdd: "Aidea Wizard",
          ImagesGenerating: "görsel üretiliyor",
          Orientation: "Yönelim",
          Quality: "Kalite",
          Square: "Kare",
          Landscape: "Yatay",
          Portrait: "Dikey",
          HDQuality: "HD Kalite",
          Standard: "Standart",
          GenerateImage: "Görsel Oluştur",
          Generating: "Oluşturuluyor...",
          GeneratedImage: "Oluşturulan Görseliniz",
          AddToCanvas: "Tuvale Ekle",
          Regenerate: "Yeniden Oluştur",
          LoadingStyles: "Stil kütüphanesi yükleniyor...",
          NoStylesAvailable: "Kullanılabilir stil yok",
          FailedToLoadStyles: "Stil kütüphanesi yüklenemedi",
          ErrorLoadingStyles: "Stiller yüklenirken hata oluştu",
          PleaseEnterPrompt: "Lütfen bir prompt girin.",
          PromptRequired: "Lütfen bir prompt girin.",
          PromptRequiredTitle: "Prompt Gerekli",
          StyleRequiredTitle: "Stil Gerekli",
          PleaseSelectStyle: "Lütfen bir stil seçin veya referans görsel ekleyin.",
          CustomStyleRequiredTitle: "Stil Açıklaması Gerekli",
          CustomStyleDescRequired: "Lütfen özel stil için bir açıklama girin.",
          NarrationRequiredTitle: "Anlatı Metni Gerekli",
          PromptEnrichEmpty: "Zenginleştirmek için lütfen bir prompt girin.",
          PromptEnrichFailed: "Prompt zenginleştirilemedi",
          FailedToGenerate: "Görsel oluşturulamadı",
          ContentPolicyViolation:
            "İçerik politikası ihlali: AI sağlayıcısı bu isteği engelledi. Yönlendirme kısıtlı içerik barındırıyor olabilir. Lütfen yönlendirmenizi değiştirip tekrar deneyin.",
          ImageAdded: "Görsel tuvalinize eklendi",
          StyleTemplate: "Stil Şablonu",
          NoDescription: "Açıklama yok",
          MoreStyles: "Daha Fazla Stil",
          ShowLess: "Daha az göster",
          GeneratingImage: "Görsel oluşturuluyor...",
          AIGeneratedImage: "AI ile oluşturulan görsel",
          StyleLabel: "Stil",
          StyleTemplateFallback: "Stil {{index}}",
          CustomCardLabel: "Özel",
          CustomStyleDescription: "Özel Stil Açıklaması",
          CustomStylePlaceholder:
            "İstediğiniz görsel stili tanımlayın, örn. suluboya illüstrasyon, karanlık sinematik, düz vektör art...",
          StyleSelectionDisabled: "Referans görsel kullanıldığında stil seçimi devre dışıdır.",
          LessStyles: "Daha Az Stil",
          TextOverlayHeader: "Metin {{index}}",
          TextOverlayPlaceholder: "Gösterilecek metni girin...",
          TextOverlayLocationLabel: "Konum",
          TextOverlayLocationCustomOption: "Özel...",
          TextOverlayLocationCustomPlaceholder: "örn: alt üçte bir orta",
          TextOverlayStyleLabel: "Stil",
          TextOverlayCustomStylePlaceholder: "örn: kalın kırmızı konturlu",
          AddTextOverlay: "+ Metin Ekle",
          ReferenceImageLabel: "Referans Görsel",
          RemoveImage: "Kaldır",
          ReferenceImageNote:
            "AI bu görseli stil referansı olarak kullanacak · {{aspectRatio}} · {{provider}}",
          PromptBadgePrefix: "Kullanır",
          DescribeImage: "Bu sahne için oluşturmak istediğiniz görseli tanımlayın...",
          UsesBadge: "Kullanır",
          AdvancedSettings: "Gelişmiş Ayarlar",
          NegativePrompt: "Negatif Prompt",
          NegativePromptPlaceholder: "Hariç tutulacaklar...",
          Resolution: "Çözünürlük",
          NarrationTextRequired: "Anlatı metni gereklidir.",
          PromptGenerationFailed: "Anlatıdan ipucu oluşturulamadı",
        },
        VideoGeneration: {
          AddedFromTray: "Sahneye eklendi",
          AddAgain: "Tekrar ekle",
          Director: {
            Tab: "Video Yönetmeni",
            Loading: "Yükleniyor…",
            Start: "Yeni video başlat",
            Prefilling: "Sahneniz okunuyor…",
            Treating: "Senaryo yazılıyor, karakter ve mekan sayfaları oluşturuluyor…",
            Rendering: "Final video oluşturuluyor…",
            RenderingTitle: "Videonuz oluşturuluyor…",
            RenderNote:
              "Bu pencereyi kapatabilirsiniz; oluşturma devam eder. Daha sonra Taslaklar'da bulun.",
            ClipsReady: "{{ready}} / {{total}} klip hazır",
            EstimateMin: "yaklaşık {{min}} dk",
            GenerateNote:
              "Bu pencereyi kapatabilirsiniz; üretim devam eder. Daha sonra Taslaklar'da bulun.",
            ClipsGenerating: "{{count}} klip üretiliyor…",
            ClipsGenerating_plural: "{{count}} klip üretiliyor…",
            ChipReady: "Hazır",
            NextNeedsApproval: "Devam etmek için tüm ana kareleri onaylayın",
            StepCount: "Adım {{n}} / 5",
            Steps: {
              Brief: "Brief",
              Treatment: "Senaryo",
              Storyboard: "Storyboard",
              Edit: "Üret ve düzenle",
              Finish: "Bitir",
            },
            Fields: {
              scenario: "Senaryo",
              voiceOver: "Seslendirme (isteğe bağlı)",
              learningGoal: "Öğrenme hedefi",
              audience: "Hedef kitle",
              narration: "Anlatım",
              language: "Dil",
              targetSec: "Hedef süre (saniye)",
              customStyle: "Özel stil",
              cast: "Karakterler",
              locations: "Mekânlar",
              criticalActions: "Kritik eylemler",
              brandPolicy: "Marka kuralları",
              logline: "Logline",
              look: "Görünüm",
              name: "Ad",
              description: "Açıklama",
              durationSec: "Süre (saniye)",
              camera: "Kamera",
              prompt: "Hareket prompt'u",
              keyframePrompt: "Anahtar kare prompt'u",
            },
            StartFrom: "Başlangıç",
            StartScene: "Bu sahne",
            StartPrompt: "Kendi fikrim",
            Characters: "Karakterler",
            CastAi: "Yapay zeka oluştursun",
            CastPhotos: "Fotoğraflarımdan",
            CastNone: "Karakter yok",
            ScenarioPlaceholder: "Tüm videonuzu anlatın — hikâye, sahneler, neler olduğu…",
            WordsCount: "{{words}} kelime",
            LikenessConsent: "Bu fotoğraflardaki kişilerin görünümünü kullanma iznim var.",
            PhotoName: "Ad",
            PhotoRole: "Videodaki rolü",
            PhotoRemove: "Fotoğrafı kaldır",
            AddPhoto: "Fotoğraf ekle",
            PhotosRequired: "En az bir fotoğraf ekleyin ve her kişiye ad verin.",
            FromPhoto: "Fotoğraftan",
            Words: "{{words}} / 300 kelime",
            Required: "Zorunlu",
            NarrationTooLong: "Anlatım 300 kelimeyi aşıyor — devam etmek için kısaltın.",
            Next: "İleri",
            Confirm: "Onayla ve anahtar kareleri çiz",
            Summary: "{{count}} çekim · {{seconds}} sn",
            Summary_plural: "{{count}} çekim · {{seconds}} sn",
            TargetRange: "10–120 sn",
            Shot: "Çekim {{n}}",
            RemoveShot: "Çekimi kaldır",
            Approve: "Onayla",
            Approved: "Onaylandı",
            ApproveAll: "Tümünü onayla",
            Regenerate: "Yeniden üret",
            Take: "Deneme {{n}}",
            InsertShotHere: "Buraya çekim ekle",
            Generated: "Üretildi",
            Play: "Oynat",
            Pause: "Duraklat",
            Fit: "Zaman çizelgesini görünüme sığdır",
            WhatNext: "Sonra ne oluyor? (isteğe bağlı)",
            WhatNextRequired: "Sonra ne oluyor?",
            Generate: "Üret",
            MarkIn: "Aralık başlangıcını işaretle",
            RemoveRange: "Seçimi sil",
            CutAfter: "Playhead'den sonrasını kes",
            RangeHint: "Aralık: {{from}} → {{to}}",
            SplitHere: "Buradan böl",
            Zoom_none: "Yakınlaştır: Yok",
            Zoom_in: "Yakınlaştır: Yavaş yakınlaş",
            Zoom_out: "Yakınlaştır: Yavaş uzaklaş",
            TransitionChip: "Geçiş",
            Transition_none: "Geçiş: Yok",
            Transition_crossfade: "Geçiş: Çapraz geçiş",
            Transition_fade: "Geçiş: Siyaha geçiş",
            TransitionFallback:
              "Çapraz geçiş için yeterli ek görüntü yok — siyaha geçiş kullanılacak",
            TransitionSkipped: "Klip geçiş için çok kısa — atlanacak",
            CutStart: "Başlangıçtan playhead'e kadar kes",
            DeleteClip: "Klibi sil",
            Close: "Kapat",
            EditShot: "Çekimi düzenle",
            PlaySound: "Sesli oynat",
            ClipSound: "Klip sesi",
            Mute: "Sessiz",
            NoClipSound: "Bu kliplerde ses yok",
            NoNarration: "Bu sahnede anlatım sesi yok",
            ShotActions: "Çekim işlemleri",
            Inspector: "Çekim paneli",
            BackToEdit: "Düzenlemeye dön",
            ReplaceVideo: "Videoyu değiştir",
            OpenLibrary: "Kütüphanede aç",
            RenderAgain: "Yeniden oluştur",
            RenderStale: "Kurgu bu çıktıdan sonra değişmiş olabilir — yeniden oluştur",
            Clips: "{{count}} klip",
            Clips_plural: "{{count}} klip",
            FinishExplain:
              "Oluşturma, {{count}} klibi tek bir MP4 dosyasında birleştirir ({{duration}}, {{aspect}}, 720p, sessiz). Sahne anlatımı ayrı kalır ve onunla birlikte oynatılır. Oluşturma ücretsizdir ve yaklaşık bir dakika sürer.",
            FinishWarnEmpty: "Oluşturulacak bir şey yok: kurguda klip bulunmuyor.",
            FinishWarnPending: "{{count}} çekim hâlâ üretiliyor ve kurguda yer almıyor.",
            FinishWarnPending_plural: "{{count}} çekim hâlâ üretiliyor ve kurguda yer almıyor.",
            FinishWarnFailed: "Başarısız {{count}} çekim kurguda yer almıyor.",
            FinishWarnFailed_plural: "Başarısız {{count}} çekim kurguda yer almıyor.",
            CutPreview: "Tüm kurgunun önizlemesi",
            StartFrame: "Başlangıç karesi",
            EndFrame: "Bitiş karesi",
            EndAuto: "Yapay zeka karar versin",
            EndNext: "Sonraki klibin ilk karesi",
            EndPick: "Kare seç",
            PickTake: "Çekim",
            PickFrame: "Kare",
            EndMarker: "→ bitiş karesi",
            Retry: "Tekrar dene",
            Render: "Videoyu oluştur",
            AddToScene: "Sahneye ekle",
            VideoName: "Yönetmen videosu",
            Drafts: "Taslaklar",
            DraftsEmpty:
              "Henüz taslak yok. Yeni bir video başlatın veya mevcut bir videoyu Yönetmen'de düzenleyin.",
            Untitled: "Adsız",
            Imported: "İçe aktarıldı",
            PolicyAdjusted: "Güvenlik için düzenlendi",
            PolicyOriginal: "İsteminiz",
            PolicySent: "Gönderilen istem",
            UseSaferPrompt: "Daha güvenli istemi kullan",
            OriginDirector: "Yönetmen",
            Rendered: "Oluşturuldu",
            DraftStatus: {
              prefilling: "Hazırlanıyor",
              brief: "Özet",
              treating: "Taslak yazılıyor",
              treatment: "Taslak",
              storyboard: "Storyboard",
              editing: "Düzenleniyor",
            },
            DraftSeconds: "{{n}} sn",
            DraftShots: "{{count}} çekim",
            DraftShots_plural: "{{count}} çekim",
            ImportAudioWarning: "Orijinal ses düzenlenen videoda korunmayacak.",
            EditInDirector: "Yönetmen'de düzenle",
            Selection: "Seçim",
            SelectionStart: "Seçim başlangıcı",
            SelectionEnd: "Seçim sonu",
            RefSetName: "Referans seti",
            RefSet: "Referans seti ({{n}}/{{max}})",
            RefSetEmpty: "İstemlerde ve üretimlerde yeniden kullanmak için videodan kareler alın.",
            AddCurrentFrame: "Geçerli kareyi ekle",
            AddToRefs: "Referans setine ekle",
            Preview: "Önizleme",
            PreviewClose: "Önizlemeyi kapat",
            PreviewPrev: "Önceki görsel",
            PreviewNext: "Sonraki görsel",
            PreviewOf: "{{n}} / {{total}}",
            UseTake: "Bu çekimi kullan",
            Upload: "Yükle",
            UploadImage: "Görsel dosyası seç",
            RefMenu: "Referans işlemleri",
            RefN: "Referans {{n}}",
            UseAsEnd: "Bitiş karesi olarak kullan",
            UseAsKeyframe: "Seçili çekimin anahtar karesi olarak kullan",
            GenerateFinal: "Son kare üret…",
            UseFrameFinal: "Bu kareyle son kare üret…",
            DeleteRef: "Sil",
            FinalTitle: "Son kare üret",
            FinalPrompt: "Son kareyi tarif edin",
            ImagesUsed: "Bu çekimde kullanılan görseller",
            KeyframeImage: "Anahtar kare",
            RegenRefs: "Yeniden üretim için referanslar ({{n}}/{{max}})",
            RegenRefsEmpty: "Burada kullanmak için referans setine kare ekleyin.",
            DeselectRef: "Referans seçimini kaldır",
            DeleteFromRefs: "Referans setinden sil",
            ConfirmDeleteRef: "Bu referans setten silinsin mi? Kalıcı olarak kaldırılır.",
            ShotInProgress: "Çekim hazırlanıyor…",
            FrameAgent: {
              Direct: "Buradan yönet…",
              Title: "Buradan yönet",
              MarkCaption: "İsteğe bağlı: öğeyi işaretle",
              ClearMark: "İşareti kaldır",
              IntentPlaceholder: "Buradan sonra ne olsun? Örn: karakter kapıdan çıksın",
              Plan: "Planla",
              Planning: "Planlanıyor…",
              Change: "Değiştir",
              S_continue: "Bu klibi buradan devam ettireceğim.",
              S_bridge_next:
                "Bu klibi buradan devam ettirip sonraki klibin ilk karesine bağlayacağım.",
              S_endframe_then_continue:
                "Önce hedef kareyi oluşturacağım, sonra ona ulaşan hareketi üreteceğim.",
              S_replace_range: "Seçili bölümü değiştireceğim.",
              CostVideo: "Video",
              CostFrame: "Hedef kare",
              CostTotal: "Toplam",
              CreateFrame: "Hedef kareyi oluştur",
              StillFailed: "Hedef kare oluşturulamadı. Tekrar deneyin.",
              FramePrompt: "Kare istemi",
              Update: "Güncelle",
              FrameAt: "Kare {{time}}",
              RangeFromStart: "Değiştirme ilk kareden başlayamaz — seçim yerine devam üretilecek",
            },
            ShotFailed: "Üretim başarısız",
            FromRef: "Referanstan",
            RemoveRefKeyframe: "Referans anahtar karesini kaldır",
            ConfirmRemoveRefKeyframe:
              "Referans anahtar karesi kaldırılsın mı? Çekim önceki anahtar karesine döner.",
            RefCancel: "İptal",
            RegenKeyframe: "Anahtar kareyi yeniden üret",
            InsertNeedsPlayhead:
              "İlk kareden önce bir şey yok, bu yüzden buraya plan eklenemez. Bunun yerine başa bir plan ekleyin.",
            StoryAssets: "Hikaye ve görseller",
            StoryAssetsHelper:
              "Hikayeyi, kadroyu, mekanları ve anahtar kareleri görün; herhangi bir görseli yeni bir planda yeniden kullanın.",
            Tabs: {
              Story: "Hikaye",
              Cast: "Kadro",
              Locations: "Mekanlar",
              Keyframes: "Anahtar kareler",
              Refs: "Referans seti",
            },
            Aspect: "En boy oranı",
            ShotList: "Plan listesi",
            NothingHere: "Henüz bir şey yok.",
            Cookbook: {
              Title: "Bu kurstan",
              Badge: "Kurstan",
              Exclude: "Bu videoda kullanma",
              Use: "Bu videoda kullan",
              NotUsed: "Bu videoda kullanılmıyor",
              Rename: "Yeniden adlandır",
              Save: "Kaydet",
              Cancel: "Vazgeç",
              Remove: "Kurstan kaldır",
              ConfirmRemove: "Kurstan kaldırılsın mı? Mevcut videolar kendi kopyalarını korur.",
              ConfirmYes: "Kaldır",
              StyleMismatch:
                "Bu kursun karakterleri mevcut görünümünü korur; seçilen stil yeni olanlara uygulanır.",
              UseLabel: "Kurs karakterleri ve mekanları",
              UseAll: "Hepsini kullan",
              UsePick: "Seç",
              UseOff: "Kullanma",
              SaveNew: "Yeni karakter ve mekanları kursa kaydet",
            },
            SrcLibrary: "Kütüphaneden",
            LibrarySearch: "Kütüphanende ara",
            LibraryLoadFailed: "Kütüphanen yüklenemedi.",
            UseLibraryImage: "Kütüphaneden görsel kullan",
            OpenInDirector: "Video Yönetmen'de aç",
            MakeVideoInDirector: "Yönetmen'de video yap",
            VideoEditor: "Video editörü",
            EmptyTitle: "Videonu başlat",
            EmptyHint: "Nasıl başlayacağını seç ya da bir çekim ekle veya kendi medyanı getir.",
            NewVideo: "Yeni video",
            StartCinematic: "Sahne Metninden Sinematik Video Kurgu",
            StartOwnPrompt: "Kendi Promptun ile Oluştur",
            NeedsNarration: "Bu sahnede anlatım metni yok",
            FlowSwitch: "Video türü",
            FlowCinematic: "Sinematik",
            AnalysisCost: "0,5 kr",
            AnalysisCostTip: "Yeni analiz 0,5 kredi",
            Reused:
              "Bu sahne için önceki videonuz açıldı — metin değişmediği için yeniden analiz edilmedi.",
            Ld: {
              StartLd: "Sahne Metninden L&D Video Kurgu",
              FlowLd: "L&D",
              Objective: "Bu video neyi göstermeli?",
              ObjectivePlaceholder:
                "örn. Ağır bir kutunun doğru kaldırılışı ve yanlış kaldırıldığında olanlar",
              UseCase: "Video türü",
              Audience: "Hedef kitle (isteğe bağlı)",
              Length: "Süre: {{sec}} sn",
              Look: "Görünüm",
              LookBrand: "Marka varsayılanı",
              LookDefault: "{{style}} (bu tür için varsayılan)",
              LookChange: "Değiştir",
              LookHide: "Gizle",
              Estimate: "Yaklaşık {{low}}–{{high}} kredi",
              EstimateDetail: "{{shots}} çekim, en fazla {{stills}} görsel",
              EstimateLoading: "Hesaplanıyor…",
              DraftFirst: "Önce taslak",
              DraftHint: "Önce ucuz bir önizleme; tuttuğunuz çekimleri son hale getirin.",
              Draft: "Taslak",
              FinalNotPlaced: "Son sürüm (yerleştirilmedi)",
              Finalize: "Son hale getir",
              FinalizeShot: "Bu çekimi son hale getir",
              FinalizeStrip: "{{n}} taslak çekim",
              FinalizeModel: "Son model",
              FinalizeAll: "{{n}} çekimi son hale getir · {{price}}",
              UseCases: {
                safety: "Güvenlik gösterimi",
                safety_hint: "Yanlış yol, sonuç, doğru yol",
                process: "Süreç anlatımı",
                process_hint: "Adım adım, el ve araçlara yakın plan",
                scenario: "Senaryo",
                scenario_hint: "Kısa bir iş yeri durumu",
                concept: "Kavram anlatımı",
                concept_hint: "Animasyonlu, insansız",
                product: "Ürün tanıtımı",
                product_hint: "Ürün planları, sonra kullanımda",
              },
            },
            StartingPoint: "Başlangıç noktası",
            EmptyAddShot: "Sahne ekle",
            EmptyImportVideo: "Kütüphaneden video içe aktar",
            EmptyImportHint: "O videoyla yeni bir proje açar; bu boş proje taslaklarında kalır.",
            EmptyAddImage: "Kütüphaneden görsel ekle",
            OriginBlank: "Boş",
            InRefSet: "Referans setinde",
            UseKeyframeFor: "{{n}}. planın anahtar karesi olarak kullan",
            NewShotWith: "Bununla yeni plan",
            AddShot: "Plan ekle",
            AddShotHelper:
              "Bir açıklamadan, karakterlerden veya mevcut bir anahtar kareden yeni plan oluşturun.",
            AddShotPrompt: "Bu planda ne oluyor?",
            AddShotAtStart: "Başa plan ekle",
            EditVideoTitle: "Videoyu Düzenle",
            AdvancedEditor: "Gelişmiş düzenleyici",
            PickCast: "Karakterler (en fazla {{max}})",
            PickLocation: "Mekan",
            KeyframeSource: "Başlangıç karesi",
            KeyframeNew: "Açıklamadan üret",
            KeyframeExisting: "Referans setinden",
            KeyframeFree: "Anahtar kareyi yeniden kullanmak ücretsizdir.",
            StartNone: "Yok (metinden videoya)",
            EndFrameOptional: "Bitiş karesi (isteğe bağlı)",
            EndNone: "Yok",
            EndRefSet: "Referans görseli",
            EndNeedsStart: "Bitiş karesi için bir başlangıç karesi gerekir",
            GenerateKeyframe: "Anahtar kare üret",
            AddShotNoGen: "Üretmeden ekle",
            TextOnly: "Yalnızca metin",
            Bridge: "Köprü",
            PickKeyframe: "Bir anahtar kare seçin",
            Placement: "Nereye gitsin?",
            PlaceHere: "Oynatma başlığında",
            PlaceStart: "Başta",
            PlaceEnd: "Sonda",
            AddStartFrame: "Başlangıç karesi ekle",
            AddEndFrame: "Bitiş karesi ekle",
            StartEmptyHint: "İsteğe bağlı — metinden videoya için boş bırakın",
            EndEmptyHint: "İsteğe bağlı",
            EndEmptyHintAI: "İsteğe bağlı — boş bırakın, yapay zekâ karar versin",
            NoEndFrame: "Bu model son kare almıyor",
            NeedsStart: "Başlangıç karesi gerekir",
            FrameChange: "Değiştir",
            FrameRemove: "Kaldır",
            SrcRefSet: "Referans seti",
            SrcKeyframes: "Anahtar kareler",
            SrcUpload: "Görsel yükle",
            KeyframeOf: "Anahtar kare · {{label}}",
            BridgeLabel: "Köprü → sonraki klip",
            GeneratedLabel: "Açıklamadan üretilir",
            GeneratedPending: "Görsel, çekimi eklediğinizde oluşturulur",
            PlayheadFrame: "Oynatma kafası karesi",
            GuideImages: "Yönlendirici görseller ({{n}}/{{max}})",
            VideoRefs: "Referans görseller ({{n}}/{{max}})",
            CastLocation: "Karakterler ve mekân",
            NoneSelected: "Seçili yok",
            PickerDone: "Tamam",
            ChooseSource: "Bir kaynak seçin",
            FrameOf: "{{label}} · {{time}}",
            InsertTitle: "Araya plan ekle",
            InsertHelper: "Bu kareden başlayan ve buraya yerleştirilen yeni bir klip üretin.",
            FinalHelper:
              "Bu kareden yeni bir referans görseli oluşturun, örneğin bir planın nasıl bitmesi gerektiği.",
            EditHelper:
              "Planın hareket istemini değiştirin veya anahtar karesini referanslarla yeniden çizin.",
            DiscardDraft: "Taslağı sil",
            NewShots: "Yeni planlar",
            NewShotsWaiting: "{{count}} yeni plan bekliyor",
            NewShotsWaiting_plural: "{{count}} yeni plan bekliyor",
            NewShot: "Yeni",
            GenerateClip: "Klip üret",
            BridgeNext: "Sonraki klibe bağla",
            ShotDetails: "Plan ayrıntıları",
            PrevFrame: "Önceki kare",
            NextFrame: "Sonraki kare",
            EndRef: "Referans setinden",
            EndUpload: "Görsel yükle",
            RefPending: "Görselin işlenmesi bekleniyor…",
            PreparingImage: "Görsel hazırlanıyor…",
            WhatHappens: "Sonra ne olur:",
            EndHelp: {
              auto: "Yapay zeka başlangıç karesinden devam eder ve çekimin nasıl biteceğine kendisi karar verir.",
              next: "Yeni çekim bir sonraki klibin ilk karesinde biter, böylece kesime akıcı bağlanır.",
              ref: "Yeni çekim seçtiğiniz referans görselde biter.",
              pick: "Yeni çekim, kliplerinizden birinde seçtiğiniz karede biter.",
            },
            Models: {
              video: "Video modeli",
              image: "Görsel modeli",
              "veo-fast": "Omni",
              veo: "Omni",
              grok: "Grok",
              seedance: "Seedance",
              ltx: "LTX",
              "gemini-nano": "Nano",
              "gemini-pro-nano": "Nano Pro",
              Price: "{{n}} kredi",
              PriceShort: "{{n}} kr",
              BriefRow: "AI modeli",
              Recommended: "Önerilen",
              HintEnd: "son kare alır",
              HintRefs: "referans görselleri",
            },
            Credit: {
              Stills: "Karakter ve mekân görselleri (en fazla)",
              Keyframes: "Anahtar kareler",
              Takes: "Video denemeleri",
              Take: "Bir video denemesi",
            },
            Errors: {
              content_filtered:
                "Bu çekim içerik filtresine takıldı. Prompt'u düzenleyip tekrar deneyin.",
              generic: "Bir şeyler ters gitti. Lütfen tekrar deneyin.",
              busy: "Önceki istek hâlâ işleniyor — birazdan tekrar deneyin.",
              conflict:
                "Proje bu arada değişti. Son sürüm gösteriliyor — lütfen son değişikliğinizi tekrarlayın.",
              stale: "Bu video projesi artık mevcut değil.",
              flow_switch: "Video türü değiştirilemedi — sunucu güncellemesi gerekebilir.",
              next_required:
                "Bu çekimin henüz prompt'u yok. Sonra ne olduğunu anlatın veya önce çekimi düzenleyin.",
              end_frame_none:
                "Bitirilecek bir sonraki klip yok. Başka bir bitiş karesi seçeneği seçin.",
              end_frame_invalid: "Bu bitiş karesi kullanılamıyor. Başka birini seçin.",
              end_frame_requires_start:
                "Bu bitiş karesi için bir başlangıç karesi gerekir. Önce başlangıç karesi seçin.",
              end_frame_unsupported:
                "Bu model seçilen karede bitemez — 'Yapay zeka karar versin' seçeneğini deneyin",
              edl_full:
                "Video dolu: üretilen bir çekim daha için yer yok. Önce bir şeyi kısaltın veya silin.",
              project_limit:
                "Bu proje sınırına ulaştı (içe aktarma, çekim veya take). Bir şeyi silin veya yeni bir video başlatın.",
              continue_source_gone: "Bu çekimin devam ettiği kesim kaldırıldı.",
              import_source_invalid:
                "Bu video içe aktarılamıyor. Aidea'ya yüklenmiş bir video seçin.",
              import_too_large: "Bu video içe aktarmak için çok büyük.",
              import_too_long: "Bu video içe aktarmak için çok uzun.",
              not_regenerable: "Bu çekim yeniden üretilemez.",
              finalize_no_draft: "Bu çekimin son hale getirilecek bir taslak klibi yok.",
              refs_full: "Referans seti dolu (24). Önce birini silin.",
              refs_source_invalid: "Bu kare veya görsel kaynak olarak kullanılamaz.",
              refs_source_required: "Önce bir kaynak kare veya görsel seçin.",
              refs_invalid: "Bu referans artık mevcut değil.",
              cast_photos_consent_required:
                "Fotoğraflardaki kişileri kullanma izniniz olduğunu onaylayın.",
              cast_photos_invalid: "Fotoğraflardan biri artık mevcut değil — yeniden ekleyin.",
              keyframe_not_from_ref: "Bu anahtar kare artık bir referanstan gelmiyor.",
              refs_too_large: "Bu görsel referans olarak kullanılamayacak kadar büyük.",
              shot_invalid_cast: "Seçilen karakterlerden biri artık yok. Yeniden seçin.",
              shot_invalid_location: "Seçilen mekan artık yok. Yeniden seçin.",
            },
          },
          Title: "Video Oluştur",
          NarrationText: "Anlatı Metni",
          NarrationTextPlaceholder: "Video için anlatı metnini girin...",
          NarrationTextRequired: "Anlatı metni gereklidir.",
          NoVideo: "Henüz video yok",
          UploadPrompt: "Başlamak için kendi videonu yükleyebilirsin.",
          UploadNow: "Hemen yükle",
          UploadDropTitle: "Yüklemek için tıkla veya sürükleyip bırak",
          UploadDropSubtitle: "MP4, MOV veya WEBM (maks 500MB)",
          ErrorTooLarge: "Dosya çok büyük. Maksimum boyut 500MB olmalıdır.",
          ErrorInvalidType: "Yalnızca MP4, MOV veya WEBM dosyaları yüklenebilir.",
          ConvertNote: ".{{ext}} dosyanız yükleme sırasında .mp4 formatına dönüştürülecek.",
          StyleNames: {
            photo: "Fotogerçekçi",
            "3d": "3D Animasyon",
            cinema: "Sinematik",
            motion: "Hareketli Grafik",
            anime: "Anime",
            watercolor: "Sulu boya",
            illustration: "İllüstrasyon",
            stopmotion: "Stop-motion",
            animation: "Animasyon",
            realistic: "Gerçekçi",
            cartoon: "Çizgi Film",
            artistic: "Artistik",
            documentary: "Belgesel",
            educational_explainer: "Eğitici Anlatım",
            whiteboard_animation: "Beyaz Tahta Animasyonu",
            futuristic_sci_fi: "Fütüristik Bilim Kurgu",
          },
          ContentLanguage: "İçerik Dili",
          VideoProvider: "Video Sağlayıcı",
          VideoStyle: "Video Stili",
          VideoStylePlaceholder: "Stil seçin",
          VideoDuration: "Video Süresi",
          VideoDurationPlaceholder: "Saniye cinsinden",
          Generate: "Storyboard Oluştur",
          Generating: "Storyboard oluşturuluyor...",
          Submitting: "Gönderiliyor...",
          VideoReady: "Video hazır!",
          AddToEditor: "Editöre Ekle",
          Download: "İndir",
          Close: "Kapat",
          Processing: "Video oluşturuluyor...",
          BackgroundNote: "Modalı kapatsanız bile işlem arka planda devam eder.",
          Failed: "Video oluşturulamadı.",
          Optional: "(opsiyonel)",

          // AI Generate Tab
          AIModel: "AI Model",
          AspectRatio: "En Boy Oranı",
          Duration: "Süre",
          Auto: "Otomatik",
          AIDecides: "AI Karar Verir",
          Custom: "Özel",
          SetTotal: "Toplam Belirle",
          Seconds: "san",
          Style: "Stil",
          StyleDisabledNote: "(Devre dışı - stil referans görseli kullanılıyor)",
          CustomCardLabel: "Özel",
          ChangeImage: "Görseli Değiştir",
          MoreStyles: "Daha Fazla Stil",
          LessStyles: "Daha Az Stil",
          OptionalEnhancements: "Opsiyonel İyileştirmeler",
          OverlayText: "Metin Bindirme",
          StartingImage: "Başlangıç Görseli",
          FirstFrame: "İlk Kare",
          Browse: "Gözat",
          StyleReference: "Stil Referansı",
          VisualGuide: "Görsel Kılavuz",
          TextAndImageOverlays: "Metin ve Görsel Bindirmeleri",
          Text: "Metin",
          Image: "Görsel",
          NoOverlaysYet:
            "Henüz bindirme yok. Videoda göstermek için metin veya görsel bindirme ekleyin.",
          Position: "Konum",
          TopLeft: "Üst Sol",
          TopCenter: "Üst Orta",
          TopRight: "Üst Sağ",
          BottomLeft: "Alt Sol",
          BottomCenter: "Alt Orta",
          BottomRight: "Alt Sağ",
          Center: "Orta",
          EnterTextToDisplay: "Gösterilecek metni girin",
          FontFamily: "Font Ailesi",
          FontStyle: "Font Stili",
          Normal: "Normal",
          Bold: "Kalın",
          Italic: "İtalik",
          BoldItalic: "Kalın İtalik",
          FontSize: "Font Boyutu",
          FontColor: "Font Rengi",
          BGColor: "Arka Plan Rengi",
          BGOpacity: "Arka Plan Opaklığı",
          ImageURLOrUpload: "Görsel URL veya Yükle",
          Upload: "Yükle",
          File: "Dosya",
          WidthPx: "Genişlik (px)",
          HeightPx: "Yükseklik (px)",
          Opacity: "Opaklık",
          Preview: "Ön izleme",
          SampleText: "Örnek Metin",
          WritePrompt: "Prompt Yaz",
          FromNarration: "Anlatımdan",
          AIWillDecide: "Sahne sayısına ve süreye yapay zeka karar verecek",
          EnrichTexts: "AI ile Zenginleştir",
          DescribeVideo: "Bu sahne için oluşturmak istediğiniz videoyu tanımlayın...",
          SceneNarration: "Sahne Anlatımı",
          EachSentenceOneScene: "Her cümle = bir sahne",
          DescribeSceneNarration: "Sahne anlatımını tanımlayın...",
          EachSentenceBecomesScene:
            "Her cümle bir sahne olur. Görsel desteğe ihtiyaç duymayanları kaldırın.",
          DefaultStyles: {
            photo: "Fotogerçekçi",
            "3d": "3D Animasyon",
            cinema: "Sinematik",
            motion: "Hareketli Grafik",
            anime: "Anime",
            watercolor: "Sulu boya",
            illustration: "İllüstrasyon",
            stopmotion: "Stop Motion",
          },
          Model: {
            grok: {
              Label: "Grok",
            },
            "veo-fast": {
              Label: "Omni (720p)",
            },
            "veo-lite": {
              Label: "Omni (720p)",
            },
            veo: {
              Label: "Omni",
            },
          },
          AdvancedSettings: "Gelişmiş Ayarlar",
          ImageUrlPlaceholder: "https://...",
          StartingImagePreviewAlt: "Başlangıç görseli ön izleme",
          StyleReferencePreviewAlt: "Stil referansı ön izleme",

          // Storyboard Panel
          StoryboardCreating: "Storyboard yükleniyor...",
          Back: "Geri",
          Storyboard: "Storyboard",
          ScenesCount: "sahne",
          Clear: "Temizle",
          Scene: "Sahne",
          Narration: "Anlatım",
          VideoPrompt: "Video Prompt",
          Edit: "Düzenle",
          Save: "Kaydet",
          Saving: "Kaydediliyor...",
          Cancel: "İptal",
          Cancelling: "İptal ediliyor...",
          VideoPreview: "Video Ön izleme",
          AddToScene: "Sahneye Ekle",
          Regenerate: "Yeniden Oluştur",
          NextScene: "Sahneyi Üret",
          PreviewImage: "Görsel Ön izleme",
          GeneratePreviewImage: "Önizleme Görseli Üret",
          RegeneratePreviewImage: "Tekrar Üret",
          GeneratingPreview: "Oluşturuluyor...",
          GenerateAllScenes: "Tüm Sahneleri Oluştur",

          // Add scene
          AddScene: "Sahne Ekle",
          AddSceneTitle: "Yeni Sahne Ekle",
          AddSceneNarrationLabel: "Anlatım Metni",
          AddSceneNarrationPlaceholder: "Bu sahnede ne anlatılsın? (en az 20 karakter)",
          AddSceneDurationLabel: "Süre (saniye)",
          AddScenePromptLabel: "Video Prompt",
          AddScenePromptPlaceholder: "Bu sahnenin görsellerini tarif edin (en az 20 karakter)",
          AddScenePromptHint: "Anlatım metni bu prompt'tan türetilir; süreyi sağlayıcı belirler.",
          AddScenePromptTooShort: "Video prompt en az 20 karakter olmalı",
          AddScenePositionLabel: "Konum",
          AddScenePositionAppend: "Sona ekle",
          AddScenePositionBefore: "{{n}}. Sahnenin önüne",
          AddSceneAfterScene: "{{n}}. Sahneden sonra",
          AddSceneAdding: "Ekleniyor...",
          AddSceneTextTooShort: "Anlatım metni en az 20 karakter olmalı",

          // Reference image (image-to-video)
          ReferenceImageAdd: "Referans görsel",
          ReferenceImageUploading: "Yükleniyor...",
          ReferenceImageSet: "Referans görsel hazır",
          ReferenceImageRemove: "Kaldır",
          StartingImageAsReference: "Başlangıç görseli",

          // Scene images (select as reference)
          SceneImages: "Sahne görselleri",
          SceneImagesHint:
            "Videonun başlangıç görseli olarak kullanmak için bu sahnedeki bir görseli seçin.",
          SceneImageSelect: "Referans olarak seç",

          // Status labels
          StatusPending: "Beklemede",
          StatusGenerating: "Oluşturuluyor",
          StatusProcessing: "İşleniyor",
          StatusCompleted: "Tamamlandı",
          StatusFailed: "Başarısız",
          StatusError: "Hata",

          // Error messages
          SceneError: "Sahne Hatası",
          ContentNotSuitable: "İçerik üretilmeye uygun değil",
          ErrorOccurred: "Video oluşturma sırasında bir hata oluştu",
          EditSaveError: "Değişiklikler kaydedilemedi. Lütfen tekrar deneyin.",
          GenerationError: "Oluşturma Hatası",
          ValidationError: "Doğrulama Hatası",
          SceneTextTooShort: "Anlamlı bir anlatım için sahne metni en az 20 karakter olmalıdır",
          VideoPromptTooShort:
            "Anlamlı bir video üretimi için video prompt'u en az 20 karakter olmalıdır",

          // Modal tabs
          AIGenerate: "AI İle Oluştur",
          UploadMyVideo: "Video Yükle",
          BackToForm: "Geri Dön",
          CustomStyleDescription: "Özel Stil Açıklaması",
          CustomStylePlaceholder:
            "İstediğiniz görsel stili tanımlayın, örn. sinematik noir, retro 80'ler animasyonu, stop-motion kil...",

          // Existing storyboard warning
          ExistingStoryboardTitle: "Mevcut Storyboard",
          ExistingStoryboardMessage:
            "Zaten devam eden bir storyboard var. Yeni bir video oluşturmak mevcut storyboard'u siler. Devam etmek istiyor musunuz?",
          ProceedAnyway: "Yine de Devam Et",

          // Storyboard status messages
          OngoingStoryboard: "Devam Eden Storyboard",
          ContinueFromWhere: "Kaldığınız yerden devam edebilirsiniz",
          ViewStoryboard: "Görüntüle",
          SearchLibrary: "Ara",
          LibraryLoadError: "Videolar yüklenemedi",

          // Language names
          Languages: {
            "tr-TR": "Türkçe (tr-TR)",
            "en-US": "İngilizce (en-US)",
            "es-ES": "İspanyolca (es-ES)",
            "fr-FR": "Fransızca (fr-FR)",
            "de-DE": "Almanca (de-DE)",
            "ar-SA": "Arapça (ar-SA)",
            "ja-JP": "Japonca (ja-JP)",
            "pt-BR": "Portekizce (pt-BR)",
            "az-AZ": "Azerice (az-AZ)",
          },

          // Provider names
          Providers: {
            grok: "Grok",
            "veo-fast": "Omni (720p)",
            "veo-lite": "Omni (720p)",
            veo: "Omni",
          },
        },
      },
      FileHandlers: {
        downloadAsFile: "Dosyayı indir",
        insert: "Ekle",
        import: "İçeri Al",
        embed: "Gömülü",
        replace: "Ekle",
        replace_bckg: "Arka planı değiştir",
        table: "Tablo",
        graph: "Grafik",
        video: "Video",
        audio: "Ses",
        image: "Resim",
        Animations: "Animasyonlar",
        cancel: "İptal",
        Object3D: "Object 3D",
        custom: "Özel Dosya",
        selectAll: "Hepsini Seç",
        selected: "Seçilen",
        question: "Soru",
        type: "Tür",
        filter_questions: "Soruyu Filtrele",
        no_matches: "Eşleşen Yok",
        feedback0: "Sınav Eklenmeyecek",
        feedback1s: "1 Sınav Eklenecek",
        feedback1p: "",
        feedback2p: "Sınav Eklenecek",
      },
      Title: "Kaynağı İçeriye Aktar...",
    },
    global_config: {
      Accept: "Değişiklikleri Kaydet",
      cancel: "İptal",
      aspect_ratio: "En Boy Oranı",
      timeline_visible: "Zaman Çizelgesi",
      jobWidgetVisible: "İş Kuyruğu",
      chatbotEnabled: "Sohbet Botu",
      anonymous: "Anonim",
      author: "Yazar",
      avatar: "Avatar",
      avatar_delete_img: "Resmi Sil",
      avatar_screenshot: "Ekran görüntüsü kullan",
      avatar_import: "İçeri resim aktar",
      context: "Durum",
      context_list: {
        school: "Okul",
        primary_school: "İlkokul",
        secondary_school: "Ortaokul",
        bach_school: "Lise",
        high_education: "Yüksek öğrenim",
        training: "Staj",
        other: "Diğer",
      },
      course_title: "Eğitim Başlığı",
      course_font: "Eğitim Fontu",
      course_font_none: "Seçilmedi",
      course_font_scope_scene: "Sadece bu sahne",
      course_font_scope_course: "Tüm eğitim",
      course_font_note:
        "Seçilen font, eğitimdeki tüm Basit Metin ve Zengin Metin kutularına uygulanır ve kutu bazında yapılmış font ayarlarının yerini alır. Kaydettiğinizde geçerli olur.",
      default_score: "Varsayılan Sahne Puanı",
      total_score: "Toplam Puan",
      total_questions: "Toplam Soru Sayısı",
      required_correct_answers: "Tamamlanması Gereken Doğru Soru Sayısı",
      require_question_evaluation: "Zorunlu Değerlendirme Sorusu",
      require_question_evaluation_info:
        'Bu özelliğin doğru çalışabilmesi için "cevabı gör" seçeneği otomatik açılacaktır.',
      description: "Tanım",
      description_placeholder: "Dokümanın ne hakkında olduğunu kısaca tanımla",
      dif: {
        null: "Tanımsız",
        undefined: "Tanımsız",
        "very easy": "çok kolay",
        easy: "kolay",
        medium: "orta",
        difficult: "zor",
        "very difficult": "çok zor",
      },
      difficulty: "Zorluk",
      Discard: "İptal",
      hideGlobalScore: "Sahne Puanlaması",
      keylist: {
        Art: "Sanat",
        Biology: "Biyoloji",
        Chemistry: "Kimya",
        Citizenship: "Vatandaşlık",
        Computerscience: "Bilgisayar Bilimleri",
        Economics: "Ekonomi",
        Education: "Eğitim",
        Engineering: "Mühendislik",
        Foreignlanguages: "Yabancı Dil",
        Generalculture: "Genel Kültür",
        Geography: "Coğrafya",
        Geology: "Jeoloji",
        History: "Tarih",
        Humanities: "Beşeri Bilimler",
        Literature: "Edebiyat",
        Maths: "Matematik",
        Music: "Müzik",
        Naturalscience: "Doğa Bilimleri",
        Physics: "Fizik",
        Technology: "Teknoloji",
      },
      keywords: "Keywords",
      keyw: {
        Add_tag: "Anahtar Kelime Ekle",
      },
      language: "Dil",
      minTimeProgress: "Her bir sayfa için minimum süre",
      mode: "Eğitim Modu",
      content_language: "Eğitim Dili",
      content_language_hint:
        "Soru metinleri ile üretilen ses, avatar ve videolar varsayılan olarak bu dilde oluşturulur. Editör arayüzünün dilini etkilemez.",
      mode_list: {
        clm: "CLM",
        infographic: "İnfografik",
        html_artifact: "Etkileşimli HTML",
        presentation: "Sunum",
        atomic_presentation: "Atomik Sunum",
        mixed: "Karışık",
      },
      no_lang: "Belirtilmedi",
      permissions: {
        title: "İzinler",
        allow_clone: "Kopyalamaya İzin Ver",
        allow_comments: "Yoruma İzin Ver",
        allow_download: "İndirmeye İzin Ver",
      },
      prompt: "Değişiklikleri kaydetmek istiyor musunuz?",
      public_domain: "Public domain",
      recom_age: "Tavsiye edilen yaş aralığı",
      rights: "Lisans",
      rights_short_txt:
        "Creative Commons telif hakkı lisansları, kreatif çalışmalara telif hakkı izinleri vermenin kolay ve standart bir yoludur. ",
      status: "Durum",
      status_list: {
        draft: "Taslak",
        public: "Halka açık",
        final: "Son",
        revised: "Revize dilmiş",
        unavailable: "Kullanılamaz",
      },
      title: "Genel Konfigürasyon",
      title_advanced: "Gelişmiş",
      title_general: "Genel Bilgi",
      typicalLearningTime: "Standart Öğrenme Zamanı",
      version: "Version",
      visor_nav: {
        keybindings: "Klavye Ok Tuşları",
        player: "Düğme Çubuğu",
        sidebar: "Yan gezinti çubuğu",
        title: "Gezinimi Ön izleme Yap",
        fixedPlayer: "Sabit Oynatıcı  ",
        timeBar: "Süre çubuğu",
      },
      group: {
        general: "Genel Bilgiler",
        geometry: "Sahne Geometrisi",
        scene_defaults: "Sahne Varsayılanları",
        progress_access: "İlerleme & Erişim",
        visor_navigation: "Visor Gezintisi",
        theme: "Tema",
      },
      scene_defaults_override_warning:
        "Kaydettiğinizde buradaki ayarlar mevcut tüm sahnelere yazılır ve sahnelerdeki zorunluluk ayarlarını ezer.",
      default_scene_duration_hint:
        "Zorunlu olmayan sahnenin tamamlandı sayılması için gereken süredir. Boş bırakılırsa sayfa başına minimum süre ({{seconds}} sn) uygulanır.",
      wait_for_time_hint: "Sahne Süresini Bekle, timeline'daki sahne sonu süresini bekler.",
      default_scene_duration: "Varsayılan sahne süresi (sn)",
      default_scene_duration_placeholder: "Belirtilmedi",
      default_mandatory_label: "Zorunlu",
      auto_next: "Otomatik sonraki sahne",
      scene_duration_placeholder: "Sahnenin kendi süresi",
      scene_group: {
        standard: "Sahneler",
        standard_hint: "Soru içermeyen sahneler. Zorunluysa süre dolmadan ilerlenemez.",
        question: "Soru sahneleri",
        question_hint: "Soru içeren sahneler. Bu ayarlar soru içermeyen sahnelere uygulanmaz.",
        transition: "Sahne geçişi",
        transition_hint: "Tüm sahneler için geçerlidir. Soru sahneleri otomatik ilerlemez.",
      },
    },
    ratio_style: {
      standard: "Standart / Dijital",
      classic: "Klasik",
      square: "Kare / Sosyal",
      reels: "Reels / Shorts",
      ig_portrait: "Instagram Portre",
    },
    ratio_reproduce: {
      menu_label: "Farklı Oranda Üret",
      title: "Farklı Oranda Üret",
      question:
        "{{title}} ({{ratio}}) Bu eğitimi farklı bir ekran oranında yeniden üretmek istiyor musunuz?",
      pick_ratio: "Hedef Oran Seçin",
      desc: {
        "16_9": "Standart geniş ekran formatı",
        "4_3": "Klasik TV formatı",
        "1_1": "Instagram feed ve sosyal medya",
        "9_16": "Instagram Reels, YouTube Shorts",
        "4_5": "Instagram portre gönderi formatı",
      },
      resolution: "Çözünürlük",
      res_1k: "1K",
      res_1k_desc: "Düşük maliyet, hızlı",
      res_2k: "2K (Varsayılan)",
      res_2k_desc: "Dengeli kalite ve maliyet",
      res_4k: "4K",
      res_4k_desc: "Maksimum kalite",
      new_name: "Yeni Eğitim Adı",
      note: "Not: Bu işlem yeni bir eğitim oluşturacak ve birkaç dakika sürebilir. Fotoğraflar tamamen aynı kalmayabilir.",
      create: "Oluştur",
      creating: "Oluşturuluyor…",
      error: "İşlem başlatılamadı. Lütfen tekrar deneyin.",
      errors: {
        not_owner: "Bu eğitim size ait değil.",
        forbidden: "Bu işlem için yetkiniz yok.",
      },
      timeout: "İşlem zaman aşımına uğradı.",
      toast_started_title: "Farklı oranda üretim başlatıldı",
      toast_done_title: "Farklı Oranda Üret",
      toast_progress: "Üretiliyor... %{{progress}}",
      toast_done: "Eğitim oluşturuldu. Eğitimleriniz sayfasından yeni eğitime ulaşabilirsiniz.",
      toast_failed: "Üretim başarısız oldu.",
    },
    nav_dropdown: {
      new_training: "Yeni Oluştur",
      subtitles: "Altyazılar",
    },
    fullscreen: "Tam Ekran",
    Header: "Başlık",
    Height: "Yükseklik",
    Height_auto: "Otomatik Yükseklik",
    Height_auto_message:
      "Kapsayıcı alanın otomatik dışında bir yüksekliği olmadığı sürece bu çalışmayacak ",
    Height_percentage: "Yükseklik (%)",
    Height_pixels: "Yükseklik (px)",
    hide: "Gizle",
    atLeastOneSceneVisible: "En az bir sahne görünür kalmalı",
    sceneMultiSelect: {
      title: "Sahneleri Sil",
      selected: "{{count}} sahne seçildi",
      confirm: "{{count}} sahne silinsin mi?",
    },
    horizontal: "Yatay Alt Başlık",
    Images: "Görseller",
    importData: "Veri dosyasını içeri aktar...",
    importFile: {
      title: "Arka Plan Ekle",
      pages: {
        from: "-den",
        title: "Sayfalar",
        to: "-e/a",
        whole_file: "Tüm Dosya",
      },
      importAs: {
        title: "İçeri Al",
        slideBackground: "Sahne Arka Planı",
        images: "Görseller",
        customSize: "Dosya Boyutu",
        PDFViewer: "PDF Gösterici",
      },
      footer: {
        ok: "Tamam",
        cancel: "İptal",
      },
    },
    ZipImport: {
      drop_zip: "Ekran kaydı ZIP dosyasını buraya bırakın",
      hint: "Kaydedici eklentisinden dışa aktarılan ekran kaydı ZIP'i",
      starting: "Başlatılıyor…",
      success: "İçe aktarma tamamlandı!",
      failed: "İçe aktarma başarısız oldu",
      invalid_file: "Geçerli bir ZIP dosyası değil",
      try_again: "Tekrar dene",
      tab_upload: "Dosya Yükle",
      tab_screen: "Ekran Eğitimi",
      select_scene: "Hangi sahneden sonra eklensin?",
      at_end: "En sona ekle",
    },
    Importing: "Açılıyor...",
    INDEX: "SAHNELER",
    index_total_duration: "Toplam süre",
    Indice: "Index",
    insert_plugin: "İçerik Ekle",
    joyride: {
      back: "Geri",
      carrousel:
        "E-Eğitiminize daha fazla sayfa, sahne ve konu ekleyerek düzenleyebilir, silebilir ve tamamlayabilirsiniz. ",
      canvas:
        'Burası "sahne" adını verdiğimiz eğitim düzenleme alanınızdır. Eğitiminizi sahne sahne düzenleyebilirsiniz.',
      close: "Kapat",
      drag: "Gerekli Ögeyi seçip sürükleyebilir ya da çift tıklayarak sahneye ekleyebilirsiniz.",
      idealStudio_description: "e-Eğitim hazırlama aracı Aideapro Studio'ya hoşgeldiniz.",
      index:
        "Bu alanda sahne, sayfa ve etiketlerinizi yönetebilirsiniz. (Etiket içeriği, etiket eklediğiniz zaman görülür.)",
      last: "Bitir",
      manual:
        "Yardıma ihtiyacınız varsa yardım menüsünü kullanabilirsiniz. Bu gezintiyi çalıştırın ve bize danışın",
      manual2: " Kullanıcı kılavuzu ",
      menu: " Menüden PDF ve bütün kaynak dosyalarını içeri akatarbilirsiniz. Ayrıca dokümanı standart formatlarda yayımlayabilirsiniz ve genel ayarları değiştirebilirsiniz.",
      need_help: "İçerik ekleme konusunda yardıma ihtiyacınız var mı?",
      next: "İleri",
      preview: "e-Eğitiminizin nasıl olduğunu görmek için buradan ön izleme yapabilirsiniz.",
      skip: "Atla",
      start: "Gezintiye Başla",
      toolbar:
        "Sahneye eklediğiniz ögeler üzerinde değişiklikleri ve ayarları buradan yapabilirsiniz.",
      welcome: "e-Eğitimde ",
      why: "Neden içerik eklemeyi denemiyorsun?",
    },
    currentLang: "tr",
    marks: {
      add_mark: "İşaretçi Ekle",
      add_mark_to: "İşaretçi Ekle ",
      create_mark: "Yeni bir işaretçi ekliyorsunuz. Onu nasıl isimlendirmek istersiniz?",
      edit_mark_to: "İşaretçi Düzenle",
      existing_content: "Mevcut içerik",
      existing_content_label: "Bağlantı hedefi",
      external_url: "Harici içerik",
      external_url_label: "URL",
      hover_message: "Bağlantılar ",
      link_to: "Bağlantı",
      mark_color: "İşaretçi rengi",
      mark_name: "İşaretçi ismi",
      marks_list: "İşaretçi Listesi",
      new_content: "Yeni içerik",
      nothing: "Hiçbir şey yapma",
      pause_until_clicked: "Tıklanana kadar zaman çizelgesini duraklat",
      click_action: "Tıklama eylemi",
      when_clicked: "Tıklanınca",
      opt_nothing: "Devam et",
      opt_nothing_hint: "Hiçbir şey olmaz, sahne devam eder",
      opt_sub: "Alt ekranı aç",
      opt_sub_hint: "Bu ekranın üstünde bir ekran göster",
      opt_back: "Ana ekrana dön",
      opt_back_hint: "Alt ekranı kapat ve devam et",
      opt_next: "Sonraki sahne",
      opt_next_hint: "Bu sahneden sonrakine geç",
      opt_goto: "Sahneye git...",
      opt_goto_hint: "Herhangi bir sahne veya alt ekran seç",
      opt_external: "Harici bağlantı",
      opt_external_hint: "Web adresini yeni sekmede aç",
      opt_popup: "Yazı göster",
      opt_popup_hint: "Bir yazı balonu göster",
      sub_new: "Yeni oluştur",
      sub_existing: "Mevcut olanı kullan",
      pause_hint: "Bu tıklama göründüğünde sahne durur, tıklanınca devam eder.",
      err_dest: "Bir hedef seçin.",
      err_url: "Bir URL girin.",
      err_url_scheme: "Yalnızca http(s) bağlantılarına izin verilir.",
      dest_missing: "Kayıtlı hedef artık yok — yeni bir hedef seçin.",
      dest_missing_option: "(hedef yok)",
      err_text: "Gösterilecek yazıyı girin.",
      img_click_action: "Tıklama eylemi ekle",
      img_before: "Tıklamadan önce",
      img_after: "Tıklamadan sonra",
      img_after_empty: "Henüz seçilmedi",
      upload_video_hint: "Video yükleyin veya sürükleyip bırakın (MP4, WEBM)",
      err_video_file: "Lütfen bir video dosyası yükleyin (MP4, WEBM).",
      type_image: "Görsel",
      type_video: "Video",
      pause_hint_video: "Bu tıklama göründüğünde sahne durur, video bitince devam eder.",
      img_remove: "Tıklama eylemini kaldır",
      next_view: "Sonraki sahneye geç",
      prev_view: "Önceki sahneye geç",
      go_to_section: "Bölüme git",
      go_to_section_label: "Bölüm",
      add_click_zone: "Tıklama alanı ekle",
      new_content_label: "Bağlantı hedefi",
      new_document: "Sayfa",
      new_slide: "Sahne",
      new_mark: "Yeni İşaretçi",
      popup: "Açılan Kutu Göster",
      popup_label: "Tıklama Yazısı",
      popup_placeholder: "İşaretçinin üstüne tıklandığında gösterilecek yazıyı yaz",
      value: "Değer",
      wrong_value: "Yanlış Değer",
      save_changes: "Değişiklikleri Kaydet",

      applyAllScenes: "Taslak Olarak Kaydet",
      applyAllScenesNote:
        "Bu sahneyi taslak olarak kaydeder; daha sonra yeniden kullanabilirsiniz.",
      upload_template: "Sahneyi Kaydet",
      TemplateName: "Tema Adı:",
      template_uploaded_slide: "Kayıtlı Taslaklarım",
    },
    boxPaste: {
      assetsWarning:
        "Öğenin dosyaları bu eğitime kopyalanamadı; öğe orijinal bağlantılarla yapıştırıldı ve izleyicilerde görüntülenmeyebilir: ",
    },
    messages: {
      add_new_mark: "Yeni İşaretçi Ekle",
      add_answer: "Cevap Ekle",
      AddBox: "Yeni Kutu EKle",
      adjust_to_document: "Dokümanı Ayarla",
      alert: "Uyarı",
      align_bottom: "Seviyesi en düşük öğeyle aynı hizaya getirilir ",
      align_center: "Ortala",
      align_left: "Sola yasla",
      align_middle: "Ana öğenin ortasına hizalanır",
      align_right: "Sağa yasla",
      align_top: "Seviyesi en yüksek öğeyle aynı hizaya getirilir",
      all_fields: "Dosyayı yüklemek için tüm alanları doldurmalısınız",
      Cancel: "İptal",
      Change: "Değiştir",
      Change_source: "Kaynağı değiştir",
      columns_distribution: "Sütun dağılımı",
      confirm_delete_cv: "Silmeyi Onayla",
      confirm_delete_CV_also_1: 'Tek işaretçi budur "',
      confirm_delete_CV_also_2: '". Görünümü de silmek istiyor musunuz?',
      confirm_delete_cv_as_well: "İşaretçi içeriğini de sil",
      confirm_delete_cv_not: "Sadece işaretçiyi sil",
      draw_borders: "Dokümana sınır belirle",
      delete_busy_cv: "Bu görünüme bağlantı veren tüm işaretçiler silinecek",
      delete_container: "Bu eylem bu bloktaki tüm içeriği silecek",
      delete_contained_canvas: "Bu eylem bu işaretçi içeriğini silecek",
      delete_idealStudio_document: "Aideapro Studio dokümanını sil",
      delete_idealStudio_document_message:
        "Bu dokümanı silmek istediğinize emin misiniz? Tüm içerik kaybolacak",
      delete_page: "Bu eylem bu sayfayı ve bu sayfadaki tüm işaretçi içeriğini silecek.",
      cant_delete_last_page: "Son sahne silinemez. En az bir sahne bulunmalıdır.",
      delete_section: "Bu eylem tüm konuyu ve içindeki herşeyi silecek.",
      docs: "Dokümanı oku",
      drag_content: "İçeriği buraya sürükle",
      edit_text: "Yazıyı düzenle",
      double_click_to_edit: "Düzenlemek için çift tıklayın",
      change_icon: "İkonu değiştir",
      erase_plugin: "Sil",
      increase_text_size: "Metin boyutunu büyüt",
      decrease_text_size: "Metin boyutunu küçült",
      align_left: "Sola hizala",
      align_center: "Ortala",
      align_right: "Sağa hizala",
      align_up: "Yukarı Hizala",
      align_right: "Sağa Hizala",
      align_left: "Sola Hizala",
      align_center: "Ortaya Hizala",
      align_down: "Aşağı Hizala",
      align_arrows: "Hizala",
      erase_container: "Kapsayıcı Alanı Sil",
      error: "Hata",
      exit: "Çıkış",
      exit_page: "Bu sayfadan çıkmak istediğinize emin misiniz?",
      export: "Yayımla...",
      export_course: "Eğitimi Yayımla",
      export_to_lms: "LMS'e Aktarılıyor...",
      lms_overwrite_message: "Bu eğitim daha önce {{date}} tarihinde LMS'e aktarılmış.",
      lms_overwrite_message_second: "Nasıl devam etmek istersiniz?",
      lms_overwrite_title: "LMS'e Aktarım",
      lms_save_as: "Yeni Oluştur",
      lms_overwrite: "Üzerine Yaz",
      export_to_HTML: "HTML olarak aktar",
      export_to_label: "Eğitimi nasıl yayımlayacağını seç",
      export_to_SCORM: "SCORM\'a aktar",
      export_to: "Yayımla ",
      forbidden: "Yayımlanmış içeriğin lisansını değiştiremezsiniz",
      force_page_break: "Her içeri alınan dokümandan önce bir sayfa arası eklemek istiyorum",
      fullscreen: "Tam ekran modu aktif et",
      global_config: "Genel Konfigürasyon",
      go_back: "Geriye git",
      go_back_to: "Geriye git ",
      help: "Yardım",
      language: "Dil",
      language_english: "İngilizce",
      language_spanish: "İspanyolca",
      language_turkish: "Türkçe",
      help_modal_text: "Aideapro Studio\'yu çözebilirsiniz.",
      import: "İçeri yükle... ",
      import_file: "Dosyayı içeri al ",
      instance_limit: "Bu araç her bir sayfa için sadece bir kez kullanılabilir",
      clm_plugin_blocked: "Bu öğe türü CLM sunumlarında kullanılamaz.",
      depth_limit: "Bu türdeki bir içeriği buraya ekleyemezsiniz",
      height_auto_warning:
        "The boxes inside can only have a relative height if you fix the container height",
      mark_input: "Yanlış giriş",
      no_internet: "Internet bağlantısına ihtiyaç var",
      OK: "Onayla",
      okay: "Tamam",
      only_slides: "Sadece sahneler",
      only_pages: "Sadece sayfalar",
      operation_in_progress: "İşlem devam ediyor...",
      pointer_events: "İçeriğe elle müdahale edilmesine izin ver",
      popoverUrlTitle: "Bu URL\'yi değiştir",
      preview: "Ön izleme yap",
      publish_tooltip: "Herkes için bu eğitimi görünür yap",
      publish_alert_title: "Bu dokümanı yayımla",
      publish_alert_text:
        "Bu eylem dokümanını herkese açık yapacak. Bu herkesin dokümanını yeniden kullanacağı anlamına geliyor.",
      publish_not_allowed:
        "Yayımlamadan önce bir başlık ve resim ekle. Erişim yolu, Menü > Genel Konfigürasyon",
      redo: "İşlemi İleri Al",
      RemoveBox: "Bir kutuyu sil",
      remove_answer: "Cevabı Sil",
      move_up: "Yukarı taşı",
      move_down: "Aşağı taşı",
      save_changes: "Değişiklikleri kaydet",
      saving: "Kaydediliyor...",
      save_as_changes: "Değişiklikleri farklı kaydet",
      selfContained:
        "Yayımladığım pakete,internet yokken kullanmak için yüklediğim dosyaları dahil etmek istiyorum. ",
      subtitlesOnByDefault: "Eğitim açıldığında alt yazıyı otomatik olarak göster.",
      slides_and_pages: "Sahneler ve sayfalar",
      slides_per_page: "Sayfadaki sahneler: ",
      undo: "Son İşlemi Geri Al",
      unpublish: "Bu dokümanı herkese açık yap",
      GoogleFontsModal: {
        title: "Google Fonts Kullanım Onayı",
        fontsNotFound: "Aşağıdaki font'lar sisteminizde bulunamadı:",
        needGoogleFonts:
          "Bu font'ları kullanmak için Google Fonts servisini kullanmamız gerekiyor.",
        importantInfo: "Önemli Bilgiler:",
        connectsToGoogle: "Google Fonts, font'ları yüklemek için Google'ın sunucularına bağlanır",
        ipAddressVisible: "Google, kullanıcı IP adresinizi görebilir",
        secureLoading: "Font'lar güvenli bir şekilde yüklenir",
        safeForViewing: "Font'lar sadece görüntüleme amaçlıdır, zararlı kod içermez",
        editorAndExport:
          "Editörde font'lar link ile yüklenecek, export'larda ise font dosyaları indirilip ek pakete dahil edilecektir",
        permissionQuestion: "Google Fonts kullanımına izin veriyor musunuz?",
        cancel: "İptal",
        approve: "Evet, İzin Veriyorum",
        success: "Font başarıyla eklendi.",
        error: "Seçilen fontlar Google Fonts servisinden indirilemedi.",
        connectionError: "Bağlantı hatası oluştu.",
        loading: "Lütfen bekleyin...",
      },

      help_welcome:
        "e-Eğitim hazırlama aracı Aideapro Studio'ya hoşgeldiniz. İsterseniz bir tanıtım gezisi yapabiliriz.",
      help_guide:
        "Tanıtım gezisinden sonra herhangi bir sorunuz varsa, buradan kullanım kılavuzumuza bakabilirsiniz. (Bu seçenek geliştirme aşamasındadır.)",
      help_documentation:
        "Bir geliştiriciyseniz, buradaki belgelere bir göz atabilirsiniz. (Bu seçenek geliştirme aşamasındadır.)",
      Success: "Kaydetme Başarılı",
      SuccessMessage: "E-eğitiminiz başarıyla kaydedilmiştir.",
      LmsExportSuccess: "Eğitim LMS'e aktarıldı ve İçerik Havuzuna eklendi.",
      RotateLeft: "Sola Döndür",
      RotateRight: "Sağa Döndür",
      Copied: "Kopyalandı!",
      syncScene: {
        buttonLabel: "Sahneyi Senkronize Et",
        buttonTitle: "Aktif sahneyi senkronize et",
        syncing: "Sahne senkronize ediliyor...",
        successTitle: "Senkronizasyon",
        successMessage: "Sahne başarıyla senkronize edildi.",
        errorTitle: "Hata",
        errorMessage: "Sahne senkronize edilemedi.",
        saveFirst: {
          title: "Kaydedilmemiş değişiklikler",
          body: "Kaydedilmemiş değişiklikler var. Sahneyi senkronize etmek için eğitimi kaydetmeniz gerekiyor. Şimdi kaydedip senkronize etmek ister misiniz?",
          confirm: "Kaydet ve senkronize et",
          cancel: "İptal",
          saving: "Kaydediliyor…",
          saveError: "Eğitim kaydedilemedi. Lütfen tekrar deneyin.",
        },
        aiButton: "AI ile Senkronize Et",
        modal: {
          title: "AI ile Senkronize Et",
          desc: "Yapay zeka, sahnedeki görsel ve metin elementlerini ses dosyanızla otomatik olarak senkronize eder.",
          step1: "Ses dosyası analiz edilir",
          step2: "Görsel elementlerin zamanlaması ses ile hizalanır",
          step3: "Metin elementleri sese göre konumlandırılır",
          extractTexts: "Görsellerdeki metinleri çıkar",
          extractTextsPrice: "10 kredi",
          busy: {
            motion: "Sahne zenginleştiriliyor ve hareketlendiriliyor…",
            extract: "Görsellerdeki metinler çıkarılıyor…",
          },
          toast: {
            synced: "Sahne senkronizasyonu tamamlandı",
            extracted: "Sahne senkronizasyonu tamamlandı — görsellerdeki metinler eklendi",
            motion: "Sahne zenginleştirildi ve hareketlendirildi",
          },
          jobFailed: "İşlem tamamlanamadı. Kredi düşülmedi; tekrar deneyin.",
          howItWorks: "Nasıl çalışır?",
          howItWorksSoon: "Video yakında",
          howItWorksSync:
            "Öğeler anlatıma göre yeniden zamanlanır: her biri kendi kelimeleri söylenirken girer, sonraki görsel geldiğinde çıkar. “Görsellerdeki metinleri çıkar” açıksa görsellerdeki yazılar düzenlenebilir, hareketli metin olarak çıkarılır ve sahneye kendiliğinden uygulanır.",
          howItWorksMotion:
            "Sahne önce senkronize edilir, ardından görsellerdeki yazılar çıkarılır ve anlatıma göre hareketli grafikler tasarlanır. Sonuç sahneye kendiliğinden uygulanır; iş tepsisi her adımı gösterir.",
          cancel: "İptal",
          confirm: "Senkronizasyonu Başlat",
          modeSync: "Mevcut öğeleri senkronize et",
          modeSyncDesc: "Sahnedeki öğelerin zamanlamasını anlatıma göre yeniden ayarlar",
          modeMotion: "Zenginleştir ve Hareketlendir",
          modeMotionDesc:
            "Senkronize eder, görsellerdeki metinleri çıkarır, hareketli grafikler ekler ve sahneye uygular — onay adımı yok",
          motionConfirm: "Hareket tasarımını başlat",
          motionPaidNote: "Ücretli: Motion Director fiyatı uygulanır.",
          motionErrors: {
            "scene-missing": "Sahne bulunamadı.",
            "no-images": "Bu sahnede canlandırılacak görsel yok.",
            "no-training": "Bu eğitimi kendi sayfasından açıp tekrar deneyin.",
            "no-extractable":
              "Metni çıkarılabilecek görsel yok (kırpılmış veya yakınlaştırılmış görseller atlanır).",
            failed: "Hareket tasarımı başlatılamadı. Tekrar deneyin.",
          },
        },
      },
      previewSpeed: {
        title: "Önizleme hızı",
        buttonTitle: "Önizleme hızı",
        cycleTitle: "Sonraki hız",
        normal: "normal",
        note: "Sadece timeline önizlemesi içindir, yayınlanan eğitime etki etmez.",
        youtubeLimit: "YouTube en fazla 2× hızı destekliyor.",
      },
      animationNames: {
        Pan: "Pan Giriş",
        Fade: "Aydınlatma",
        "Fade In": "Aydınlatma",
        "Scale In": "Yakınlaştır",
        "Slide In Right": "Sağa Kaydır",
        "Slide In Left": "Soldan Gir",
        "Slide In Up": "Yukarı Kaydır",
        "Slide In Down": "Aşağı Kaydır",
        Rotate: "Döndür",
        Bounce: "Zıpla",
        "Bounce In": "Zıplayarak Gir",
        "Rotate In": "Dönerek Gir",
        "Type Writer": "Daktilo",
        "Wavy Text": "Dalgalı Metin",
        Flip: "Çevir",
        Pinwheel: "Fırıldak",
        Roll: "Yuvarlan",
        Stretch: "Esne",
        "Pan Out": "Pan Çıkış",
        "Fade Out": "Karart",
        "Scale Out": "Uzaklaştır",
        "Slide Out Right": "Sağa Çık",
        "Slide Out Left": "Sola Çık",
        "Slide Out Up": "Yukarı Çık",
        "Slide Out Down": "Aşağı Çık",
        "Rotate Out": "Dönerek Çık",
        "Bounce Out": "Zıplayarak Çık",
        "Type Writer Out": "Daktilo (Çıkış)",
        "Wavy Text Out": "Dalgalı Metin (Çıkış)",
      },
      animationPanel: {
        panEntryName: "Pan Giriş",
        panExitName: "Pan Çıkış",
        direction: "Yön",
        zoomOut: "Uzaklaştır",
        zoomIn: "Yakınlaştır",
        zoomAmount: "Zoom Miktarı",
        startPoint: "Başlangıç Noktası",
      },
      trackClip: {
        repeatForScene: "Sahne Boyunca Tekrarla",
      },
    },
    ThemePalette: {
      Title: "Tema & Palet Seçimi",
      Select: "Seç",
      Theme: "Tema",
      SelectTheme: "Tema seçin",
      LoadingThemes: "Temalar yükleniyor...",
      Palette: "Palet",
      LoadingPalettes: "Paletler yükleniyor...",
      NoPalettes: "Bu tema için palet bulunamadı.",
      ErrorSelectBoth: "Lütfen bir tema ve palet seçin.",
      UnknownError: "Bilinmeyen bir hata oluştu.",
      Apply: "Uygula",
      Applying: "Uygulanıyor...",
      NoThemesError: "Temalar yüklenemedi.",
      ThemeStyleFetchError: "Tema stili yüklenemedi.",
      RemoveTheme: "Temayı Kaldır",
      ApplyToAll: "Tüm sahnelere uygula",
      Custom: "Özel",
      Mode: "Mod",
      ModeImage: "Görsel",
      ModeHtml: "HTML / CSS",
      ModeColor: "Renk",
      HtmlPlaceholder:
        '<div style="position:absolute;inset:0;background:linear-gradient(135deg,#1a1a2e,#16213e);"></div>',
      Edit: "Düzenle",
      Preview: "Ön izleme",
    },
    EditButton: {
      edit_selected: "Seçili elemanı düzenle",
      no_selection: "Düzenlemek için bir eleman seçin",
      multi_selection: "Düzenlemek için tek bir eleman seçin",
      container_selected: "Containerlar doğrudan düzenlenemez",
      unsupported_plugin: "Bu eleman türünün düzenleme eylemi yok",
      artifact_ref: "Etkileşimli sahneler, elemandaki sohbet düğmesinden yapay zekâ ile düzenlenir",
      html_modal_title: "HTML içeriği düzenle",
      html_placeholder: '<div style="padding:16px;background:#fff">Merhaba</div>',
    },
    MoodleXML: {
      are_you_sure: "Moodle XML format için emin misin?",
      parse_error: "Dosya işlenirken hata oluştu",
      unrecognized: "Tanımlanamayan Sınav Türü",
      not_supported: "Henüz Desteklenmiyor",
    },
    Multimedia: "Medya",
    NavItem_name: "Sayfa İsmi",
    General_name: "Genel",
    NavItem_title: "Sayfa Başlığı",
    no_results: "Sonuç yok",
    Objects: "Nesneler",
    OK: "Tamam",
    Open: "Aç",
    Open_Catalog: "Yüklenmiş Resimleri Göster",
    open_conf: "Ayarlar",
    minTime: "Sahne Süresi",
    slideDuration: "Sahne Süresi",
    isMandatory: "Zorunluluk",
    autoNext: "Otomatik İlerle",
    autoNextNote: "Otomatik geçiş, sahnenin tamamı bittikten sonra gerçekleşir.",
    autoNextShowCta: "Geçmeden önce geri sayım göster",
    autoNextShowCtaNote:
      "Sonraki sahne kartını 5 saniyelik geri sayımla gösterir. Kapalıyken geçiş doğrudan yapılır.",
    sceneEndCta: "Sahne sonunda geçiş ekranı göster",
    sceneEndCtaNote:
      "Açıkken, sahne bittiğinde ve varsa zorunluluk tamamlandığında öğrenciyi sonraki sahneye davet eden bir geçiş ekranı görünür. Kapalıyken (varsayılan) sahne ekranda kalır; geçiş İleri butonuyla yapılır.",
    mandatoryType: "Sahne Geçiş Seçenekleri",
    waitForAction: "Cevabı Bekle",
    waitForCorrectAction: "Doğru Cevabı Bekle",
    waitForOneClick: "Tıklamayı Bekle",
    waitForTime: "Sahne Süresini Bekle",
    // TODO: deprecated — labels below only serve retired mandatory types shown
    // disabled on legacy trainings; remove once no trainings still use them.
    waitForAnimation: "Animasyonu Bekle",
    waitForSound: "Sesi Bekle",
    waitForVideo: "Videoyu Bekle",

    Sound: {
      Sound: "Anlatım Sesi",
      uploadSound: "Sesi içeri aktar",
      soundRecorder: "Ses Kaydet",
      addSound: "Sahneye Ses Ekle",
      demoSound: "Örnek Sesler",
      slaytSounds: "Sahnedeki Sesler",
      soundList: "Ses Listesi",
      add_sound: "Ses Ekle",
      sound_name: "Ses Adı",
      sound_name_holder: "Ses Adı...",
      Sounds: "Sesler",
      Add: "Ekle",
      select_sound: "Ses Seçimi",
      AddNewSoundFromList: "Listeden Yeni Ses Ekle",
      AddNewSoundFromLocal: "Yerelden Yeni Ses Ekle",
      AddAISound: "Yapay Zeka ile Ses Ekle",
      NoFileChosen: "Ses Seçiniz...",
      VolumeLevel: "Ses Seviyesi",
      DemoSound: "Ses Ön izleme",
      Start_Time: "Süre: ",
      End_Time: "Bitiş Süresi: ",
      Volume: "Ses Seviyesi: ",
      Edit: "Düzenle",
      Delete: "Sil",
      Play: "Oynat",
      Pause: "Durdur",
      listenSounds: "Sesi/Sesleri Dinle",
      FileAdded: "Ses başarıyla eklendi.",
    },
    Recorder: "Kayıt Süresi",

    order: {
      Ahead: "Öne",
      Behind: "Arkaya",
      BringtoFront: "En Öne",
      SendtoBack: "En Arkaya",
    },
    page: "Sayfa",
    pages: "Sayfalar",
    pagenumber: "Numarası",
    Pixels: "Pikseller",
    Percentage: "Yüzde",
    player: {
      First: "İlk",
      Previous: "Önceki",
      Next: "Sonraki",
      Last: "En Son",
      Export: "Yayımla",
    },
    plugin_config: "Konfigürasyon",
    Position: "Konumlandırma",
    Preview: "Ön izleme",
    Properties: "Özellikler",
    Publish: "Yayımla",
    Read_more: "Daha Fazla",
    Redo: "İleri",
    Reorder: "Yeniden Düzenle",
    Rotate: "Döndür (Derece)",
    HorizontalFlip: "Yatay Yansıt",
    VerticalFlip: "Dikey Yansıt",
    repeatedItemCopied: "(kopya)",
    row_number: "Sütundaki Satır Sayısı",
    Save: "Kaydet",
    SaveAs: "Farklı Kaydet",
    Score: "Puan",
    Score_feedback: "Puanın: ",
    "SCORM Explanation":
      "Bir SCORM paketi, öğrenme nesneleri için kararlaştırılan bir standarda göre paketlenmiş bir dosya koleksiyonudur. SCORM paketleri, standardı (Moodle, Blackboard,...) destekleyen herhangi bir LMS'e (Öğrenme Yönetim Sistemi) entegre edilebilen ve multimedya içeriği sunmak ve değerlendirme araçları olarak kullanılabilen zip dosyalarıdır. Böylece, bu belgeyi SCORM olarak indirerek Moodle veya diğer LMS sistemlerine entegre edebilirsiniz.",
    "HTML Explanation":
      "Bu seçenek, iki klasör içeren bir .zip paketini dışa aktarır: ilk belge herhangi bir tarayıcıda açabileceğiniz index.html dosyasıdır. Diğeri ise ön izleme dosyasının doğru açılabilmesi için gerekli kaynakları içeren belgedir.",
    "URL Explanation":
      "Bu seçenek, hazırladığınız eğitimin bir kopyasını alarak link (url) üretir. <b>Link oluşturulmadan önce eğitim otomatik olarak kaydedilir</b>, böylece en son değişiklikleriniz linke yansır. Üretilen linki diğer ortamlarda paylaşabilir ve yayınlayabilirsiniz.",
    "EDI Explanation":
      "This option exports a .edi file with the content of your document which you will be able to import in other Aideapro Studio documents, even if they are hosted in different platforms.",
    "PDF Explanation": "Bu işlem bir PDF dosya üretir.",
    Search_in_ViSH: "ViSH'de Ara",
    Searching: "Aranıyor...",
    section: "Bölüm",
    show: "Göster",
    show_subtitle: "Alt Yazı Göster",
    slide: "Sahne",
    step_next: "Sonraki Adım",
    step_previous: "Önceki Adım",
    Submit: "Gönder",
    subtitle: "Alt Başlık",
    subtitle_hide: "Alt Yazıyı Gizle",
    Replay: "Tekrar Oynat",
    visor: {
      subtitles: "Altyazılar",
      playbackSpeed: "Oynatma hızı",
      normalSpeed: "normal",
      off: "Kapalı",
      previous: "Önceki",
      play: "Oynat",
      pause: "Durdur",
      replay: "Tekrar Oynat",
      reset: "Yeniden Başlat",
      next: "Sonraki",
      fullscreen: "Tam ekran",
      exit_fullscreen: "Tam ekrandan çık",
      remaining: "kaldı",
      more: "Diğer seçenekler",
      volume: "Ses",
      mute: "Sesi kapat",
      unmute: "Sesi aç",
      close: "Kapat",
      seek_back: "10 saniye geri",
      seek_forward: "10 saniye ileri",
      show_controls: "Kontrolleri göster",
      hide_controls: "Kontrolleri gizle",
    },
    // Visor chrome scene-end CTA (visor-ui redesign, Task 3).
    VisorCtaNextScene: "Sonraki sahne · {{n}}/{{total}}",
    VisorCtaFinish: "Eğitimi tamamla",
    VisorCtaFinishInfo: "Eğitim tamamlandı",
    VisorCtaFinishEyebrow: "Tüm sahneler tamamlandı",
    VisorCtaSingleEyebrow: "Tek sahnelik eğitim",
    VisorCtaReplay: "Bu sahneyi tekrar izle",
    VisorCtaAnnounce: "Sahne {{n}} tamamlandı. Sonraki: {{next}}.",
    VisorCtaPreparing: "Sahne {{n}} hazırlanıyor…",
    VisorCtaIncompleteEyebrow: "İzlenmemiş sahne · {{n}} adet",
    VisorCtaAnnounceIncomplete: "İzlenmemiş sahneler var. Devam et: {{next}}.",
    VisorCtaReplayTraining: "Eğitimi baştan izle",
    // Visor chrome scene row / scene panel / header pill (visor-ui redesign, Task 7).
    VisorRowScene: "SAHNE",
    VisorRowVideo: "VİDEO",
    VisorRowQuiz: "SORU",
    VisorRowPage: "SAYFA",
    VisorRowLockedTitle: "Sahne {{n}} henüz açılmadı",
    VisorRowLockedBody: "Devam etmek için önceki sahneleri tamamlaman gerekiyor.",
    VisorNoScenes: "Bu eğitimde henüz sahne yok.",
    VisorPanelScenes: "Sahneler",
    VisorPillScene: "Sahne {{n}}/{{total}}",
    VisorPillProgress: "Eğitim ilerlemesi: %{{pct}}",
    // Visor chrome stage seek zones (visor-ui redesign, Task 8).
    VisorSeekFwd: "+10 SANİYE",
    VisorSeekBack: "−10 SANİYE",
    // Visor SCORM offline queue notice (visor-ui redesign, Task 10).
    VisorOfflineSaved:
      "Bağlantı yok — ilerlemen cihazında saklandı, bağlantı gelince gönderilecek.",
    VisorVideoFailedTitle: "Bu sahnedeki bir video yüklenemedi",
    VisorVideoFailedBody: "Sahne video olmadan devam ediyor.",
    VisorMediaFailedTitle: "Medya yüklenemedi",
    VisorMediaFailedBody: "Bu içerik şu an yüklenemiyor; sahne onsuz devam ediyor.",
    // Visor chrome edge/empty states + resume card (visor-ui redesign, Task 11).
    VisorErrTitle: "Sahne {{n}} yüklenemedi",
    VisorErrBody: "Video dosyasına ulaşılamıyor. Bağlantını kontrol edip tekrar dene.",
    VisorErrRetry: "Tekrar dene",
    VisorErrSkip: "Sahne {{n}}'e atla",
    VisorNoScenesTitle: "Bu eğitimde henüz sahne yok",
    VisorNoScenesBody:
      "İçerik hazırlandığında burada görünecek. Eğitim yöneticine haber verebilirsin.",
    VisorResumeEyebrow: "SON KALDIĞIN YER",
    VisorResumeContinue: "Devam et",
    VisorResumeRestart: "Baştan başla",
    // Fix (Task 11): the generating-kind CTA announce previously stitched the
    // full "preparing" sentence into VisorCtaAnnounce's {{next}} slot.
    VisorCtaAnnouncePreparing: "Sahne {{n}} hazırlanıyor.",
    success_transaction: "İşlem Başarılı",
    Structure: "Yapı",
    Style: "Stil",
    StyleDisabledNote: "(Devre dışı - stil referans görseli kullanılıyor)",
    CustomCardLabel: "Özel",
    ChangeImage: "Görseli Değiştir",
    MoreStyles: "Daha fazla stil",
    styles: {
      background_color: "Arka Plan Rengi",
      border_color: "Çerçeve Rengi",
      border_size: "Çerçeve Genişliği",
      border_style: "Çerçeve Stili",
      border_style_options: {
        none: "Yok",
        hidden: "Gizli",
        dotted: "Noktalı",
        dashed: "Kesikli",
        solid: "Düz",
        double: "Çift",
        groove: "Oymalı",
        ridge: "Kabartmalı",
        inset: "İçe",
        outset: "Dışa",
        initial: "Varsayılan",
        inherit: "Miras al",
      },
      font_weight: {
        normal: "Normal",
        bold: "Kalın",
        100: "100",
        200: "200",
        300: "300",
        400: "400",
        500: "500",
        600: "600",
        700: "700",
        800: "800",
        900: "900",
      },
      box_style: "Kutu Stili",
      opacity: "Opaklık",
      padding: "Alan",
      absolute: "Mutlak",
      relative: "Göreceli",
    },
    templates: {
      scene_header_placeholder: "Sahne Başlığı",
      add_text: "Buraya metin ekleyin",
      elements_list: "Öğe Listesi",
      ex_unique_response: "Çoktan Tek Seçimli Soru Etkileşimi",
      ex_multiple_response: "Çoktan Çok Seçimli Soru Etkileşimi",
      ex_free_response: "Açık Uçlu Soru Etkileşimi",
      ex_true_false: "Doğru/Yanlış Soru Etkileşimi",
      ex_background_sound: "Arka Plan Sesi",
      ex_matching: "Eşleştirme Soru Etkileşimi",
      "ex_fill-in-the-blank": "Boşluk Doldurma Soru Etkileşimi",
      template0: "Boş Sahne",
      first_element: "İlk Öğe",
      second_element: "İkinci Öğe",
      third_element: "Üçüncü öğe",
      text_images: "Metin ve Resim",
      map: "İnteraktif Harita",
      video: "İnteraktif Video",
      web: "Web Sayfası",
      template1: "Resim & Metin",
      template2: "Metin Blokları",
      template3: "Resim Blokları",
      template4: "Video",
      template5: "Harita",
      template6: "Web Sayfası",
      template7: "Resim & Liste",
      template8: "Çoktan Tek Seçmeli",
      template9: "Çoktan Çok Seçmeli",
      template10: "Açık Uçlu",
      template11: "Doğru / Yalnış",
      template12: "Arka Plan Sesi",
      template13: "Eşleştirme ",
      template14: "Boşluk Doldurma",
      templatechose: "Şablon Seçimi",
      tab_template: "Şablondan",
      tab_zip: "Ekran Eğitimi",
    },
    export: {
      full_sli_doc: "Yatay yönlendirme. Sayfa başına bir slayt. Sayfa öğeleri dahil edilecektir.",
      two_sli_doc: "Dikey yönlendirme. Sayfa başına iki slayt. Sayfa öğeleri dahil edilecektir.",
      full_sli: "Yatay yönlendirme. Sayfa başına bir slayt. Sayfa öğeleri dahil edilmecektir.",
      two_sli: "Dikey yönlendirme. Sayfa başına iki slayt. Sayfa öğeleri dahil edilmeyecektir.",
      sli_comments:
        "Dikey yönlendirme. Sayfa başına bir slayt. Her slaydın altına yorumlar için bir alan eklenecektir. Sayfa öğeleri dahil edilmeyecektir.",
      four_sli: "Yatay yönlendirme. Sayfa başına dört slayt. Sayfa öğeleri dahil edilmeyecektir.",
      full_doc: "Dikey yönlendirme. Sayfa başına bir sayfa. Slaytlar dahil edilmeyecektir.",
      two_doc: "Yatay yönlendirme. Sayfa başına iki sayfa. Slaytlar dahil edilmeyecektir.",
      safari_landscape:
        " Safari kullanıyorsunuz. Belgeyi düzgün bir şekilde dışa aktarmak için, yazdırma modelinde yatay yönlendirmeyi seçmeyi unutmayın. Arka Planları Yazdır seçeneği etkinleştirilmelidir.",
      firefox_landscape:
        " Firefox kullanıyorsunuz. Belgeyi düzgün bir şekilde dışa aktarmak için, yazdırma modelinde yatay yönlendirmeyi seçmeyi unutmayın. Arka Plan Renklerini Yazdır ve Arka Plan Resimlerini Yazdır seçenekleri etkinleştirilmelidir. Üstbilgi veya altbilgi kullanmamanız önerilir.",
      safari_portrait:
        " Safari kullanıyorsunuz. Belgeyi düzgün bir şekilde dışa aktarmak için, yazdırma modelinde dikey yönlendirmeyi seçmeyi unutmayın. Arka Planları Yazdır seçeneği etkinleştirilmelidir.",
      firefox_portrait:
        "Firefox kullanıyorsunuz. Belgeyi düzgün bir şekilde dışa aktarmak için, yazdırma modelinde dikey yönlendirmeyi seçmeyi unutmayın. Arka Plan Renkleri ve Görüntüleri Yazdır seçenekleri etkinleştirilmelidir. Üstbilgi veya altbilgi kullanmamanız önerilir.",
      print_title: "Yazdırma Seçenekleri",
      warning_title: "Uyarı",
      null_print:
        "Dışarıya aktarılacak bir şey yok. Lütfen belgenizin en az bir öğesini içeren bir yazdırma ayarı seçin.",
      download_failed: "İndirme tamamlanamadı. Lütfen daha sonra tekrar deneyin.",
      sli_doc: "Slaytlar ve Sayfalar",
      sli: "Sadece Slaytlar",
      doc: "Sadece Sayfalar",
      sli_doc_explanation: "Bu ayarlar belgenin hem slaytlarını, hem de sayfalarını içerir.",
      sli_explanation: "Bu ayarlar slaytları içerir, ancak belgenin sayfalarını içermez.",
      doc_explanation: "Bu ayarlar sayfaları içerir, ancak belgenin slaytlarını içermez.",
      clm_desc: "CLM paketi",
      scorm_scenes: "Her sahne ayrı SCORM",
      scorm_scenes_desc: "Her sahneyi ayrı SCORM paketi olarak dışa aktar",
      scene_progress: "Sahne {{k}}/{{n}}",
      scorm_scene_pick: "Dışa aktarılacak sahne",
      scorm_scene_all: "Tüm sahneler (her biri ayrı paket)",
      scorm_scenes_failed: "Başarısız sahneler: ",
      assets_skipped: "Paket oluşturuldu, ancak şu görseller indirilemedi ve pakete eklenmedi: ",
      clm_explanation:
        "Bu sunumu statik bir CLM paketi olarak dışa aktarır: index.html, clm-config/config.json ve her sayfa için bir görsel. Tüm gezinme tıklama alanlarınız üzerinden yapılır.",
      clm_zip_name: "Paket dosya adı",
      clm_export_done: "Dışa aktarma {{count}} uyarıyla tamamlandı.",
      clm_close: "Kapat",
      clm_check_again: "Yeniden kontrol et",
      clm_not_checked: "Sunum henüz kontrol edilmedi.",
      clm_no_problems: "Dışa aktarmaya hazır — sorun bulunamadı.",
      clm_errors_title: "Dışa aktarmadan önce düzeltin",
      clm_warnings_title: "Uyarılar (dışa aktarma yapılabilir)",
      clm_problem_no_pages: "Sunumda görünür sahne yok.",
      clm_problem_document_scene: "{{scene}}: belge tipi sahneler CLM'e aktarılamaz.",
      clm_problem_missing_target:
        "{{scene}}: bir tıklama alanı artık var olmayan bir hedefe işaret ediyor.",
      clm_problem_multi_nav:
        "{{scene}}: bir tıklama alanı birden fazla sayfaya gidiyor (bir tık = bir gezinme).",
      clm_problem_unsupported_plugin: "{{scene}}: {{plugin}} dışa aktarılamaz, atlanacak.",
      clm_problem_boundary_nav:
        "{{scene}}: ileri/geri tıklama alanının bu sayfada gidecek yeri yok (pasif kalacak).",
      clm_problem_unsupported_connect_mode:
        '{{scene}}: bir tıklama alanı statik pakette bağlanamayan "{{connectMode}}" moduna ayarlı (pasif kalacak).',
      clm_problem_empty_click_zone: "{{scene}}: bir tıklama alanının hedefi yok (pasif kalacak).",
      clm_problem_small_touch_target:
        "{{scene}}: bir tıklama alanı 48px'den küçük (dokunması zor).",
      clm_problem_furniture_occlusion:
        "{{scene}}: bir tıklama alanı alt şeritte — sayfadaki referans/kodların üzerini kapatmadığından emin olun.",
      clm_problem_background_not_exported:
        "{{scene}}: arka plan görselleri aktarılmaz; yalnızca arka plan rengi kullanılır.",
      clm_problem_approx_geometry:
        "{{scene}}: bir öğe px boyut kullanıyor; konumu 1920×1080 sahnede yaklaşık hesaplandı.",
      clm_problem_external_html:
        "{{scene}}: harici URL gömen bir HTML öğesi çevrimdışı aktarılamaz, atlanacak.",
      clm_problem_unsafe_external_url:
        "{{scene}}: bir tıklama alanının harici bağlantısı güvenli bir web adresi değil (yalnızca http(s)/mailto/tel aktarılır), atlanacak.",
      clm_problem_theme_not_exported:
        "{{scene}}: bu sahne bir tema arka planı kullanıyor, bu aktarılmaz; yerine siyah bir sayfa kullanılacak.",
      clm_problem_missing_asset: "{{scene}}: {{plugin}} görseli eksik, atlanacak.",
      clm_problem_download_failed: "{{scene}}: görsel indirilemedi ({{url}}).",
      clm_problem_artifact_failed:
        "Bir animasyonlu HTML öğesi alınamadı ({{detail}}). Kaydedip tekrar deneyin.",
      clm_problem_parity: "İç hata: sayfa sayısı uyuşmuyor ({{detail}}).",
      clm_problem_invalid_state: "İç hata: sunum kontrol edilemedi ({{detail}}).",
    },
    video_export: {
      translate_confirm_title: "Bu dilde üretilsin mi?",
      translate_confirm_replace_title: "Bu dil zaten var — yeniden üretilsin mi?",
      translate_confirm_text:
        "Birleştirilmiş video bu dilde yeniden seslendirilecek. İşlem videonun uzunluğuna göre birkaç dakika sürebilir ve kredi harcar.",
      translate_confirm_start: "Üret",
      languages_show_more: "+{{n}} dil daha",
      languages_show_less: "Daha az göster",
      title: "Video Dışa Aktar",
      sync_scenes: "Sahneleri Güncelle",
      sync_scenes_tooltip:
        "Eğitimin güncel sahne listesini çek ve render edilmemiş veya başarısız sahneleri kuyruğa al. Tamamlanmış videolara dokunulmaz.",
      sync_scenes_confirm:
        "Eğitimdeki güncel sahne listesi çekilecek; henüz render edilmemiş veya başarısız olan sahneler kuyruğa alınacak. Tamamlanmış sahne videolarına dokunulmayacak. Devam edilsin mi?",
      recovering: "Kurtarılıyor…",
      recover: "Eski Videoları Kurtar",
      stop: "Tümünü Durdur",
      stop_confirm:
        "Devam eden render/birleştirme işlemi iptal edilecek. Tamamlanmış sahne videoları silinmeyecek. Devam edilsin mi?",
      clear_tooltip: "Bu eğitime ait tüm dışa aktarma kayıtlarını siler ve baştan başlar",
      clear_confirm: "Bu export'a ait tüm kayıtlar kalıcı olarak silinecek. Devam edilsin mi?",
      clearing: "Yeniden başlatılıyor…",
      clear: "Yeniden Başla",
      start_modal_title: "Video Üretimini Başlat",
      regenerate_modal_title: "Sahneyi Yeniden Üret",
      regenerate_modal_hint:
        "Bu sahne yeniden oluşturulacak. Mevcut video, işlem tamamlanana kadar yerinde kalır.",
      save_reminder:
        "Eğitimi kaydetmeyi unutmayın. Kaydedilmemiş değişiklikler video üretimine dahil edilmez.",
      cancel: "İptal",
      subtitle_lang_label: "Altyazı dili (opsiyonel)",
      subtitle_none: "— Altyazısız —",
      subtitle_scene_count: "({{count}} sahne)",
      duration_tooltip: "Toplam süre",
      history_tooltip: "Önceki birleştirilmiş videolar",
      history: "Geçmiş",
      merge_reselect_tooltip: "Yeni seçim ile yeniden birleştir",
      merge_disabled_tooltip: "Tüm sahneler hazır olduğunda etkinleşir",
      merge: "Birleştir",
      re_merge: "Yeniden Birleştir",
      checking: "Mevcut iş kontrol ediliyor…",
      start_hint:
        "Sahneleri tek tek üret, kontrol et, beğenmediklerini yeniden ürettir. Hazır olduğunda manuel birleştir butonuna basarak nihai videoyu oluştur.",
      start: "Başla",
      merged_label: "Birleştirilmiş video",
      download: "İndir",
      regenerate_scene: "Bu Sahneyi Yeniden Üret",
      idle_hint: 'Başlamak için sağ üstteki "Başla" butonuna tıklayın.',
      starting: "İş başlatılıyor…",
      select_scene: "Bir sahne seçin",
      merging_placeholder: "Birleştiriliyor…",
      merging_progress: "Birleştiriliyor… %{{pct}}",
      render_percent: "Render %{{pct}}",
      error_prefix: "Hata: ",
      retry: "Yeniden Dene",
      dont_merge_overlay: "Birleştirilmeyecek",
      dont_merge_tooltip_include: "Birleştirmeye dahil et",
      dont_merge_tooltip_exclude: "Birleştirmeye dahil etme",
      dont_generate_overlay: "Oluşturulmayacak",
      dont_generate_tooltip_include: "Üretime dahil et",
      dont_generate_tooltip_exclude: "Üretime dahil etme",
      cancel_scene_tooltip: "İptal",
      regenerate_scene_tooltip: "Yeniden üret",
      history_title: "Önceki birleştirmeler",
      history_loading: "Yükleniyor…",
      history_empty: "Henüz birleştirilmiş video yok.",
      preparing_scenes: "Sahneler hazırlanıyor…",
      rendering_of_total: "{{total}} sahneden {{count}} tanesi render ediliyor",
      queued_of_total: "{{total}} sahneden {{count}} tanesi sırada bekliyor",
      rendering_count: "{{count}} sahne render ediliyor",
      queued_count: "{{count}} sahne sırada bekliyor",
      job_on_way: "İş yolda",
      status_queued: "Sırada",
      status_rendering: "Render ediliyor",
      status_uploading: "Yükleniyor",
      status_completed: "Tamamlandı",
      status_failed: "Başarısız",
      status_cancelled: "İptal edildi",
      status_merged: "Birleştirildi",
      status_merge_pending: "Birleştirme bekliyor",
      merge_cancel_confirm:
        "Bir birleştirme işlemi zaten devam ediyor. Bu sahneyi hariç tutmak için mevcut birleştirmeyi iptal etmemiz gerekiyor — video yeniden birleştirilmesi gerekecek. Devam edilsin mi?",
      training_id_missing: "Training ID bulunamadı.",
      no_scenes: "Bu eğitimin sahnesi yok. Lütfen düzenleyiciye dönün ve sahne ekleyin.",
      state_read_error: "Kayıtlı durum okunamadı",
      checking_save: "Kayıt kontrol ediliyor…",
      save_required_title: "Önce kaydetmeniz gerekiyor",
      save_required_body:
        'Video üretmeden önce mevcut çalışmanızın sunucuda kayıtlı olması gerekiyor. Sahne, ses, animasyon ve metin değişikliklerinizin tümünün doğru render edilmesi için lütfen önce "Kaydet" deyin, sonra tekrar deneyin.',
      save_failed: "Kayıt başarısız",
      saving: "Kaydediliyor…",
      save_now: "Şimdi Kaydet",
      recheck: "Yeniden Kontrol Et",
      error_title: "Bir hata oluştu",
      menu_label: "Video Dışa Aktarma",
      translate_starting: "Başlatılıyor…",
      translate_failed: "Çeviri başlatılamadı.",
      recover_tooltip:
        "Veritabanında kaydı olmayan, daha önce render edilmiş sahne videolarını Azure Blob'da ara.",
      languages_tooltip: "Videoyu başka dillerde üret ve izle",
      languages: "Diller",
      watch: "İzle",
      languages_title: "Diller",
      languages_hint:
        "Birleştirilmiş videoyu başka bir dilde seslendirin. Sahneler değişmez, yalnızca ses değişir.",
      dismiss: "Kapat",
      languages_available: "Hazır videolar",
      languages_needs_merge:
        "Önce videoyu birleştirin — çeviri birleştirilmiş video üzerinden yapılır.",
      variant_original: "Orijinal",
      languages_add: "Yeni dil ekle",
      translate_no_languages: "Seslendirme için kayıtlı dil yok.",
      translate_regenerate: "Bu dil zaten var — yeniden üretilecek",
      translate_start: "Bu dilde üret",
      translate_busy: "Bir çeviri sürüyor",
      translate_disabled_tooltip: "Önce videoyu birleştirin",
      translate_exists: "mevcut",
      close: "Kapat",
    },
    subtitles: {
      title: "Altyazılar",
      available_languages: "Mevcut Diller",
      refresh: "Yenile",
      no_subtitles: "Henüz altyazı üretilmedi. Altyazı üretmek için aşağıdaki formu kullanın.",
      delete_language: "Bu dildeki altyazıları sil",
      set_default: "Varsayılan altyazı yap",
      unset_default: "Varsayılan altyazı — kaldırmak için tıklayın",
      default_hint: "Yıldızlı dil, önizlemede altyazı butonuna basıldığında açılır.",
      default_failed: "Varsayılan altyazı kaydedilemedi.",
      subtitles_for: "Şu dilin altyazıları",
      not_found: "Bu sahne için altyazı bulunamadı",
      no_subtitle_for_scene: "Bu sahne için altyazı yok",
      generate_title: "Altyazı Üret",
      select_language: "Dil seçin...",
      force_regenerate: "Zorla yeniden üret",
      generating: "Üretiliyor...",
      generate_btn: "Üret",
      generating_subtitles: "Altyazılar üretiliyor...",
      confirm_delete_title: "Altyazıları Sil",
      confirm_delete_message:
        "Bu dildeki tüm altyazıları silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.",
      cancel: "İptal",
      delete_confirm: "Sil",
    },
    Text: "Veri",
    text_here: "Buraya istediğiniz yazıyı yazabilirsiniz.",
    Title: " Başlığı",
    Title_document: "Eğitim Başlığı",
    Filter: "Filtrele",
    SelectAFolder: "Klasör Seçiniz...",
    Slide_document: "Sahne Başlığı",
    Page_document: "Sayfa Dokümanı",
    Undo: "Geri",
    Units: "Bölümler",
    Unpublish: "Yayımlama",
    Uploading: "Yükleniyor...",
    Upload_to_ViSH: "ViSH\'e yükle",
    Uploaded_Images: "YÜKLENEN RESİMLER",
    Uploaded_Images_No: "Yüklenmiş resim yok",
    vertical: "Dikey Alt Başlık",
    Vertical_align: "Dikey Yerleşim",
    vish_search: "VISH Arama",
    vish_search_terms: "Arama Terimi",
    vish_search_button: "Arama",
    vish_search_by: "ile ara ",
    vish_search_by_type: "Tür ile ara",
    vish_search_filters: {
      ranking: "Sıralama",
      popularity: "Popülerlik",
      modification: "Değişim",
      creation: "Yaratım",
      visits: "Ziyaretler",
      favorites: "Beğeniler",
      quality: "Kalite",
    },
    vish_search_types: {
      Picture: "Resim",
      Resource: "Hepsi",
      Audio: "Ses",
      Embed: "Gömülü",
      Excursion: "Gezinti",
      Swf: "Flash Object",
      Link: "Link",
      Officedoc: "PDF",
      // "Scormfile": "SCORM Paketi",
      Video: "Video",
      Webapp: "Web Uygulama",
      Workshop: "Workshop",
      Writing: "Yazı",
      XML: "XML",
      JSON: "JSON",
      CSV: "CSV",
      OBJ: "OBJ",
      All: "Hepsi",
      Zipfile: "ZIP Dosya",
      IdealStudioDocument: "Aideapro Studio Doküman",
      Arrows: "Oklar",
      Education: "Eğitim",
    },
    vish_upload: "Yükle",
    vish_upload_desc: "Tanım",
    vish_upload_other: "Resim, video ve başka kaynaklar yükle",
    vish_upload_title: "Başlık",
    "Want some help?": "Yardım?",
    Weight: "Ağırlık",
    Width: "Genişlik",
    Width_percentage: "Genişlik (%)",
    Width_pixels: "Genişlik (px)",
    languages: {
      Afrikanns: "Afrikanca",
      Albanian: "Arnavutça",
      Arabic: "Arapça",
      Armenian: "Ermenice",
      Basque: "Baskça",
      Bengali: "Bengalce",
      Bulgarian: "Bulgarca",
      Catalan: "Katalanca",
      Cambodian: "Kamboçyaca",
      Chinese: "Çince",
      Azerbaijani: "Azerice",
      Croation: "Hırvatça",
      Czech: "Çekçe",
      Danish: "Danca",
      Dutch: "Felemenkçe",
      English: "İngilizce",
      Estonian: "Estonca",
      Fiji: "Fijice",
      Finnish: "Fince",
      French: "Fransızca",
      Georgian: "Gürcüce",
      German: "Almanca",
      Greek: "Yunanca",
      Gujarati: "Guceratça",
      Hebrew: "İbranice",
      Hindi: "Hintçe",
      Hungarian: "Macarca",
      Icelandic: "İzlandaca",
      Indonesian: "Endonezce",
      Irish: "İrlandaca",
      Italian: "İtalyanca",
      Japanese: "Japonca",
      Javanese: "Cava Dili",
      Korean: "Korece",
      Latin: "Latince",
      Latvian: "Letonca",
      Lithuanian: "Litvanca",
      Macedonian: "Makedonca",
      Malay: "Malayca",
      Malayalam: "Malayalam",
      Maltese: "Maltaca",
      Maori: "Maori Dili",
      Marathi: "Marathi Dili",
      Mongolian: "Moğolca",
      Nepali: "Nepalce",
      Norwegian: "Norveççe",
      other: "Diğerleri",
      Persian: "Farsça",
      Polish: "Lehçe",
      Portuguese: "Portekizce",
      Punjabi: "Pencapça",
      Quechua: "Keçuva Dili",
      Romanian: "Rumence",
      Russian: "Rusça",
      Samoan: "Samoaca",
      Serbian: "Sırpça",
      Slovak: "Slovakça",
      Slovenian: "Slovence",
      Spanish: "İspanyolca",
      Swahili: "Svahili",
      Swedish: "İsveççe",
      Tamil: "Tamilce",
      Tatar: "Tatarca",
      Telugu: "Telugu Dili",
      Thai: "Tayca",
      Tibetan: "Tibetçe",
      Tonga: "Tonga Dili",
      Turkish: "Türkçe",
      Ukranian: "Ukraynaca",
      Urdu: "Urduca",
      Uzbek: "Özbekçe",
      Vietnamese: "Vietnamca",
      Welsh: "Galce",
      Xhosa: "Xhosa Dili",
    },
    TextAnimations: {
      title: "Metin Animasyonları",
      chooseAnimation: "Animasyon Seç",
      preview: "Ön izleme",
      settings: "Ayarlar",
      duration: "Süre (Saniye)",
      delay: "Gecikme (Saniye)",
      delayDescription: "Animasyon bu gecikme sonrasında başlayacak",
      replay: "Tekrar Oynat",
      applyAnimation: "Animasyonu Uygula",
      deleteAnimation: "Animasyonu Sil",
      sampleText: "Örnek Metin Animasyonu",
      animations: {
        fadeIn: "Soluklaş",
        slideInRight: "Sağdan Kaydır",
        slideInLeft: "Soldan Kaydır",
        slideInUp: "Aşağıdan Kaydır",
        slideInDown: "Yukarıdan Kaydır",
        scaleIn: "Büyüt",
        rotateIn: "Döndür",
        bounceIn: "Sıçra",
        typeWriter: "Daktilo",
        wavyText: "Dalgalı Metin",
      },
    },
    BoxAnimations: {
      title: "Kutu Animasyonları",
      chooseAnimation: "Animasyon Seç",
      preview: "Ön izleme",
      settings: "Ayarlar",
      duration: "Süre (Saniye)",
      delay: "Gecikme (Saniye)",
      delayDescription: "Animasyon başlamadan önceki gecikme",
      replay: "Tekrar Oynat",
      applyAnimation: "Animasyonu Uygula",
      deleteAnimation: "Animasyonu Sil",
      sampleText: "Örnek Kutu",
    },
    AssessmentMenu: {
      nAnswers: "Cevap sayısı",
      nStatements: "İfade sayısı",
      nItems: "Öğe sayısı",
      nPairs: "Eşleşme sayısı",
      nBlanks: "Boşluk sayısı",
      labels: "Etiketler",
      shuffleAnswers: "Cevapları karıştır",
      shuffle: "Karıştır",
      showFeedback: "Geri bildirim göster",
      partialCredit: "Kısmi puan",
      points: "Puan",
      minLength: "Min uzunluk",
      maxLength: "Maks uzunluk",
      countCharacters: "Karakterleri say",
      buttons: "Düğmeler",
      addAnswer: "Cevap ekle",
      removeAnswer: "Cevap çıkar",
      addOne: "Bir ekle",
      removeOne: "Bir çıkar",
      editQuestion: "Soruyu düzenle",
      fitToScreen: "Ekrana sığdır",
      duplicate: "Çoğalt",
      preview: "Ön izleme",
      previewThisQuestion: "Bu soruyu ön izle",
      moreOptions: "Daha fazla seçenek",
      styleAndColors: "Stil ve renkler…",
      delete: "Sil",
      deleteQuestion: "Soruyu sil",
      assessmentOptions: "Değerlendirme seçenekleri",
      questionOptions: "Soru seçenekleri",
      richTextEditor: "Zengin metin düzenleyici",
      setBlankAnswers: "Her boşluk için doğru cevabı belirleyin",
      correctAnswers: "Doğru cevaplar",
      noBlanksYet: "Henüz boşluk yok — “+ boşluk ekle” ile ekleyin.",
      blank: "Boşluk",
      correctValue: "doğru değer",
      correctAnswerPlaceholder: "doğru cevap",
      addFillBlank: "Boşluk ekle",
      addDragArea: "Sürükleme alanı ekle",
    },
    pages: "Sayfalar",
    doc_name: "Doküman Adı",
    edit: "Düzenle",
    "Image Animator": "Görüntü Animatörü",
    "Current Image": "Mevcut Görüntü",
    "No image selected": "Görüntü seçilmedi",
    NoPreviewImage: "Önizleme görseli yok",
    "View fullscreen": "Tam ekran görüntüle",
    "Animate your static image using AI": "Durağan görselinizi yapay zeka ile hareketlendirin",
    "Remove background from the image": "Görselin arka planını kaldırın",
    "Remove specific objects from the image": "Görseldeki belirli nesneleri kaldırın",
    "Remove text from the image": "Görseldeki metinleri kaldırın",
    "Translate text within the image": "Görseldeki metinleri çevirin",
    "Generate similar variations of the image": "Görselin benzer varyasyonlarını üretin",
    "Edit your image using AI": "Görselinizi yapay zeka ile düzenleyin",
    "Change text content within the image": "Görseldeki metin içeriğini değiştirin",
    "Change the aspect ratio of the image using AI":
      "Görselin en-boy oranını yapay zeka ile değiştirin",
    "Increase image resolution using AI": "Görsel çözünürlüğünü yapay zeka ile artırın",
    "Generate a similar infographic based on this image":
      "Bu görsele dayalı benzer bir infografik üretin",
    "Replace a garment or product using a reference image":
      "Referans görsel ile bir kıyafeti veya ürünü değiştirin",
    "Decompose this image into editable layers": "Bu görseli düzenlenebilir katmanlara ayırın",
    "Separate the baked-in text into editable text boxes":
      "Gömülü metni düzenlenebilir metin kutularına ayırın",
    "Animated Result": "Animasyon Sonucu",
    Duration: "Süre",
    Size: "Boyut",
    "Animation Prompt (Optional)": "Animasyon İsteği (Opsiyonel)",
    "Animation Prompt Placeholder":
      "Görüntüyü nasıl canlandırmak istediğinizi açıklayın (örn., 'Yumuşak kamera yakınlaştırması ve nazik hareket ekle', 'Yüzen öğelerle ince bir paralaks efekti oluştur')",
    "AI Provider": "AI Sağlayıcısı",
    "Coming Soon": "Yakında",
    Reject: "Reddet",
    "Starting Animation...": "Animasyon Başlatılıyor...",
    "Start Animation": "Animasyonu Başlat",
    "Please enter an animation prompt": "Lütfen bir animasyon isteği girin",
    "Animation generation failed. Please try again.":
      "Animasyon oluşturma başarısız oldu. Lütfen tekrar deneyin.",
    "Failed to check job status": "İş durumu kontrol edilemedi",
    "Failed to start animation": "Animasyon başlatılamadı",
    "Failed to submit animation job": "Animasyon işi gönderilemedi",
    "Failed to fetch job status": "İş durumu alınamadı",
    Error: "Hata",
    training: {
      completed_exit: "Eğitimi tamamladınız çıkmak istiyor musunuz?",
      completed: "Eğitimi tamamladınız.",
      failed: "Eğitim Başarısız",
      failed_message:
        "Değerlendirme sorularında hedeflenen başarı oranına ulaşılamadığı için ({{correct}} / {{required}}) eğitim otomatik olarak yeniden başlayacaktır.",
      yes: "Evet",
      no: "Hayır",
      ok: "Tamam",
      close: "Kapat",
      previously_started: "Bu eğitime daha önce çalışmışsınız...",
      continue_from_bookmark: "Kaldığım yerden devam et",
      restart_from_beginning: "Eğitimin Başına Dön",
    },

    "Image Animator": "Görsel Animatörü",
    "Merlin Image Animator": "Aidea Wizard Görsel Animatörü",
    "Image Edit": "Görsel Düzenleme",
    "Resize the Image": "Görseli Yeniden Boyutlandır",
    "Resize the image": "Görseli Yeniden Boyutlandır",
    "Replace Text": "Metni Değiştir",
    "Generate Image with Text": "Metin ile Görsel Oluştur",
    "Generate with Style Reference": "Stil Referansı ile Oluştur",
    "Select Feature": "Özellik Seç",
    Yakında: "Yakında",
    "Animate Image": "Görseli Canlandır",
    AnimateImageNoReference: "Görseli Canlandır — referans görsel bulunamadı",
    ExtractText: "Metni Ayır",
    "Remove Background": "Arka Planı Kaldır",
    "Remove Object": "Nesne Kaldır",
    "Add Object": "Obje Ekle",
    "Add Logo": "Logo Ekle",
    "Edit Region": "Prompt ile Düzelt",
    "Remove Text": "Metin Kaldır",
    "Translate Text": "Metin Çevir",
    "Generate Similar": "Benzer Oluştur",
    "Change Object": "Nesne Değiştir",
    "Edit Image": "Görseli Düzenle",
    "Change Image Text": "Metni Değiştir",
    "No image selected": "Görsel seçilmedi",
    NoPreviewImage: "Önizleme görseli yok",
    Prompt: "Prompt",
    EnterDescriptionPlaceholder: "Açıklama girin...",
    EditImagePromptPlaceholder:
      "Değişiklikleri açıklayın (örn. 'Arka planı tropikal bir sahile çevir')",
    RemoveObjectPromptPlaceholder: "Ne kaldırılsın? (örn. 'at')",
    RemoveObjectSelectAreaLabel: "Silinecek Alan (İsteğe Bağlı)",
    RemoveObjectSelectAreaButton: "Alanı Seç",
    RemoveObjectAreaReselect: "Alanı Yeniden Seç",
    RemoveObjectAreaSelected: "Alan seçildi",
    RemoveObjectSelectAreaHint:
      "Silinecek objenin üzerine bir kutu çizin. Alan seçerseniz prompt yazmak zorunlu değildir.",
    ChangeObjectPromptPlaceholder:
      "Değiştirmek istediğiniz nesneyi ve ne ile değiştireceğinizi detaylıca açıklayın (örn. 'Kırmızı arabayı mavi bisikletle değiştir')",
    "Text Changes": "Metin Değişiklikleri",
    Add: "Ekle",
    OriginalTextPlaceholder: "Orijinal metin (örn. Merhaba Dünya)",
    NewTextPlaceholder: "Yeni metin (örn. Hello World)",
    SelectText: "Metni Seç",
    DragOverTextToExtract: "Çıkarmak istediğiniz metnin üzerine sürükleyin",
    ExtractingText: "Metin çıkarılıyor…",
    NoTextDetected: "Seçilen alanda metin bulunamadı",
    TextExtractionFailed: "Metin çıkarılamadı",
    EnterCustomLocationPlaceholder: "Özel konum girin...",
    SelectLocation: "Konum seçin",
    "Top Left": "Sol Üst",
    "Top Center": "Orta Üst",
    "Top Right": "Sağ Üst",
    "Middle Left": "Sol Orta",
    Center: "Merkez",
    "Middle Right": "Sağ Orta",
    "Bottom Left": "Sol Alt",
    "Bottom Center": "Orta Alt",
    "Bottom Right": "Sağ Alt",
    Custom: "Özel",
    "Target Language": "Hedef Dil",
    Count: "Adet",
    "AI Provider": "Yapay Zeka Sağlayıcı",
    "Advanced Settings": "Gelişmiş Ayarlar",
    "Output Format": "Çıktı Formatı",
    "Optimized size, good quality": "Optimize boyut, iyi kalite",
    "Full quality, larger size": "Tam kalite, büyük boyut",
    DurationSecondsShort: "{{count}} sn",
    Loop: "Döngü",
    "Play Once": "Bir Kez Oynat",
    "Transparent Background": "Şeffaf Arka Plan (Ek Maliyet)",
    ExtendAnimation: "Uzat (+8 sn)",
    ExtendToSceneDuration: "Sahne süresine uydur (~{{sec}} sn)",
    Extended: "Uzatma",
    "Failed to extend animation": "Animasyon uzatılamadı",
    ConvertToLoop: "Döngüye Çevir",
    ConvertToPlayOnce: "Bir Kez Oynat'a Çevir",
    PreviewAndEdit: "Önizle ve Düzenle",
    AnimEdit: {
      ActionsTitle: "Aksiyonlar",
      AddAsMp4: "Sahneye MP4 olarak ekle",
      AddAsWebp: "Sahneye WebP olarak ekle",
      ExtendTitle: "Uzat",
      Model: "Model",
      AddPrompt: "Prompt ekle",
      ContinuationPromptPlaceholder:
        "Boş bırakın: otomatik mod — yapay zekâ bir sonraki hareketi son kareden kendisi türetir.",
      ExtendUnavailableProvider:
        "Uzatma yalnızca Gemini animasyonlarında kullanılabilir. Bu animasyon {{provider}} ile üretildi; döngü çevirme yine de kullanılabilir.",
      NoSourceVideo:
        "Bu versiyonun kaynak videosu yok; uzatılamaz veya çevrilemez. Yine de uygulayabilirsiniz.",
      MaxDurationHint: "maks. 45 sn",
      ReferenceImageLabel: "Devam görseli (isteğe bağlı)",
      Upload: "Yükle",
      PickFromScene: "Sahneden",
      PickFromLibrary: "Kütüphaneden",
      Applied: "Uygulandı",
      UseFrameAsContinuation: "Bu kareyi devam görseli yap",
      FrameTimeReadout: "{{t}} / {{d}} sn",
      FrameExtractFailed: "Bu kare alınamadı.",
      SummaryDuration: "Animasyon: {{sec}} sn",
      SummarySceneWindow: "Sahnede: {{start}}–{{end}} sn",
      InfoShownWindow: "Sahnede {{start}}–{{end}} sn arasında gösteriliyor",
      InfoNeeded: "Gerekli süre: {{sec}} sn",
      Advanced: "Gelişmiş",
      SimpleView: "Basit görünüm",
      SummaryPrompt: "Prompt: {{prompt}}",
      NoPromptGiven: "Prompt verilmedi",
      TabDuration: "Süre",
      TabFormat: "Biçim",
      TabContinuation: "Devam görseli",
      SceneFitRequired: "Gerekli {{sec}} sn",
      SceneFitProduced: "{{sec}} sn üretildi",
      SceneFitShortfall: "{{sec}} sn eksik",
      SceneFitCapNote: "Toplam en fazla {{sec}} sn",
      RangeSummary: "{{from}} sn → {{to}} sn · maks. {{cap}} sn",
      ExtendSettingsLabel: "Uzatma şu ayarlarla",
      NoContinuationImage: "Devam görseli yok",
      Change: "Değiştir",
      ModelGeminiOnlyHint: "Uzatma yalnızca Gemini animasyonlarında kullanılabilir",
      StepSetup: "Ayarla",
      StepGenerate: "Üret",
      StepEdit: "Düzenle",
      SourceImageLabel: "Kaynak görsel",
      RegenerateFromSourceHint:
        "Aynı görselden, bu ayarlarla (değiştirebilirsiniz) yeni bir animasyon üretin",
      EditSourceImageHint:
        "Son statik görseli düzenleyin (ör. metni düzeltin), sonra yeniden canlandırın",
      MotionDescriptionLabel: "Hareket açıklaması",
      OptionalLabel: "isteğe bağlı",
      PlaybackLabel: "Oynatma",
      PlaybackHint: "Sahnede sürekli tekrar etsin mi",
      SetupSceneFitBanner:
        "Bu öğe sahnede {{start}}–{{end}} sn arasında görünüyor. {{sec}} sn'lik bir animasyon aralığı tam dolduruyor.",
      GeneratingTitle: "Animasyon üretiliyor",
      GeneratingHint: "Genellikle 40–90 sn sürer",
      ElapsedTime: "{{time}} geçti",
      ContinueInBackground: "Arka planda sürdür",
      CancelJob: "İptal et",
      ResultReadyTitle: "Animasyon hazır",
      ResultReadySummary:
        "{{sec}} sn · {{playback}} · {{provider}} — sahnedeki {{windowSec}} sn'lik aralığı karşılıyor",
      ResultReadySummaryNoWindow: "{{sec}} sn · {{playback}} · {{provider}}",
      Regenerate: "Yeniden üret",
      Retry: "Yeniden dene",
      BackToSetup: "Ayarlara dön",
      BackToResult: "Sonuca dön",
      ApplyToScene: "Sahneye uygula",
      HistoryTitle: "Sürüm geçmişi",
      HistoryFilterAll: "Tümü",
      HistoryFilterAnimations: "Animasyonlar",
      HistoryFilterEdits: "Düzenlemeler",
      HistoryFilterEmpty: "Bu filtrede sürüm yok",
      HistoryOnScene: "Sahnede",
      HistoryConfirmHint: "seçildi — onaylarsanız sahnedeki öğe bu sürümle değişir.",
      BackButton: "Geri Dön",
      ActivityLogTitle: "Etkinlik Günlüğü",
      HistoryHeader: "Geçmiş",
      HistoryCollapse: "Geçmişi kapat",
      HistoryExpand: "Geçmişi aç",
      SendToPopup: "Popup'a getir",
    },
    Processing: "İşleniyor...",
    "Processing Failed": "İşlem Başarısız",
    "Job failed": "İşlem başarısız oldu",
    "Failed to check job status": "İşlem durumu kontrol edilemedi",
    "API URL not configured": "API URL yapılandırılmamış",
    "The operation could not be completed. Please try again.":
      "İşlem tamamlanamadı. Lütfen tekrar deneyin.",
    ImageAnimationFailedGenericMessage: "İşlem tamamlanamadı. Lütfen tekrar deneyin.",
    AnimationCopyrightBlocked:
      "Görsel, telif hakkı veya marka/ünlü kişi içerdiği için Google tarafından hareketlendirilemedi. Lütfen telifsiz farklı bir görsel deneyin.",
    AnimationSafetyBlocked:
      "Görsel, AI servisinin (Google) güvenlik politikası izin vermediği için hareketlendirilemedi (ör. gerçekçi çocuk görüntüsü, şiddet veya hassas içerik). Lütfen farklı bir görsel deneyin.",
    AiProviderSafetyBlocked:
      "AI servisi bu isteği güvenlik politikası gereği işlemedi. Girdi (görsel veya metin) kısıtlı içerik barındırıyor olabilir; ör. gerçekçi çocuk görüntüsü, şiddet veya uygunsuz ifade. Lütfen farklı bir içerikle tekrar deneyin.",
    AiProviderCopyrightBlocked:
      "AI servisi bu isteği işlemedi; girdi telif hakkı, marka veya ünlü kişi içeriyor olabilir. Lütfen telifsiz, farklı bir içerikle tekrar deneyin.",
    Dismiss: "Kapat",
    "Dismiss All": "Tümünü Kapat",
    "Result Ready": "Sonuç Hazır",
    Option: "Seçenek",
    "Use This": "Bunu Kullan",
    "Accept & Replace": "Kabul Et & Değiştir",
    "Animation Result": "Animasyon Sonucu",
    Start: "Başlat",
    "Unknown error": "Bilinmeyen hata",
    "Resize Image": "Görseli Yeniden Boyutlandır",
    "Upscale Image": "Çözünürlüğü Artır",
    "Generate Similar Infographic": "Benzer İnfografik Oluştur",
    GenerateFromReferencePromptPlaceholder:
      "Bu görsele dayanarak oluşturmak istediğiniz görseli açıklayın...",
    "Replace Product": "Objeyi Referansla Değiştir",
    Optional: "opsiyonel",
    Remove: "Kaldır",
    "Failed to upload image": "Görsel yüklenemedi",
    ReplaceProduct: {
      SelectObjectLabel: "Değiştirilecek objeyi seç",
      SelectObjectButton: "Görselden obje seç",
      SelectObjectHint: "Görsel üzerinde değiştirmek istediğiniz objenin etrafına bir kutu çizin.",
      OptionalBadge: "isteğe bağlı",
      TargetObjectTitle: "Ek açıklama",
      TargetObjectLabel: "Ek açıklama (opsiyonel)",
      TargetObjectPlaceholder: "örn. 'ceket', 'kupa'",
      TargetObjectHint:
        "Seçtiğiniz kutuda birden fazla şey varsa hangisini kastettiğinizi yazın. Boş bırakırsanız kutudaki obje değiştirilir.",
      AdaptStyleLabel: "Objeyi görselin stiline uyarla",
      AdaptStyleHint:
        "Açıkken, referans obje eklenmeden önce kaynak görselin stiline uyacak şekilde yeniden üretilir. Kapalıyken olduğu gibi eklenir.",
      RegionSelected: "Alan seçildi",
      RegionSelectedReselect: "Alanı yeniden seç",
      DragOverObject: "Değiştirilecek objenin üzerine sürükleyin",
      ReferenceImageLabel: "Referans görsel (yeni obje)",
      ReferenceSelected: "Referans görsel seçildi",
      ChangeUpload: "Değiştir",
      ChooseFromHistory: "Geçmişten seç",
      PickFromLibrary: "Kütüphaneden seç",
      PickFromLibraryTitle: "Kütüphaneden referans görsel seç",
      UploadHint: "Görsel yükle veya sürükle-bırak (PNG, JPG, JPEG)",
      InvalidFileType: "Bu dosya türü kabul edilmiyor. Sadece görsel yükleyin (PNG, JPG, JPEG).",
      PromptLabel: "Ek yönerge",
      PromptPlaceholder: "İsteğe bağlı: örn. 'sadece ceketi değiştir, arka planı ve pozu koru'",
      PickReferenceTitle: "Referans görsel seç",
    },
    LogoIntro: {
      templates: "Kalıp",
      logo: "Logo",
      upload: "Logo yükle",
      remove: "Logoyu kaldır",
      from_library: "Marka kütüphanesindeki logolar",
      title: "Başlık",
      title_ph: "Örn. Bilgi Güvenliği Farkındalığı",
      subtitle: "Alt başlık",
      subtitle_ph: "Örn. Eğitime hoş geldiniz",
      primary: "Ana renk",
      accent: "Vurgu rengi",
      theme: "Zemin",
      light: "Açık",
      dark: "Koyu",
      dark_hint: "Koyu yazılı logolar açık zeminde daha iyi okunur.",
      preview: "Önizle",
      previewing: "Hazırlanıyor…",
      preview_empty: "Önizlemek için bir kalıp seçin",
      add: "Ekle",
      adding: "Ekleniyor…",
      seconds: "{{n}} sn",
      error: "Logo intro oluşturulamadı",
      upload_failed: "Logo yüklenemedi",
      load_failed: "Kalıplar yüklenemedi",
      scene_name: "Giriş",
      text_section: "Yazı",
      font: "Yazı tipi",
      font_default: "Varsayılan",
      size: "Yazı boyutu",
      text_color: "Yazı rengi",
      text_color_auto: "Otomatik",
      style: "Stil",
      bold: "Kalın",
      uppercase: "BÜYÜK HARF",
      sec_template: "Kalıp",
      sec_logo: "Logo",
      sec_text: "Yazı",
      sec_look: "Görünüm",
      sec_output: "Çıktı",
      sec_preview: "Önizleme",
      text_style: "Yazı stili",
      look_hint: "Renkler marka kitinizden geliyor",
      output_motion: "Motion",
      output_mp4: "MP4",
      output_webp: "WebP",
      output_motion_desc: "Canlı animasyon sahnesi, editörde düzenlenebilir.",
      output_mp4_desc: "Video dosyasına çevrilir ve video olarak eklenir.",
      output_webp_desc: "Döngülü hareketli görsele çevrilir.",
      place: "Nereye",
      place_start: "Eğitimin başına",
      place_after: "Şu sahneden sonra…",
      place_scene: "Hangi sahneden sonra",
      rendering: "Video hazırlanıyor…",
      rendering_webp: "Görsel hazırlanıyor…",
      render_wait_hint: "Bu işlem bir iki dakika sürebilir.",
    },
    AreaOps: {
      Title: "Görseli Düzenle",
      TabEdit: "Düzenle",
      TabArea: "Alan İşlemleri",
      Intro:
        "Bir özellik seç, görselde alan işaretle, uygula. İşlemler arka planda sırayla çalışır; sen çalışmaya devam edebilirsin.",
      DrawRegionHint: "Görsel üzerinde bir alan çiz",
      ClickPointHint: "Görsel üzerinde bir nokta seç",
      Empty: "Henüz işlem yok. Yukarıdan bir özellik seç.",
      Apply: "Uygula",
      RemoveLast: "Son Pini Kaldır",
      RevertOriginal: "Orijinale Dön",
      RevertToVersion: "Bu sürüme dön",
      Working: "İşleniyor…",
      ReferenceImage: "Referans görsel",
      UploadReference: "Referans görsel yükle",
      RemoveReference: "Kaldır",
      Remove: "Kaldır",
      TargetObjectPlaceholder: "örn. 'ceket', 'kupa' (opsiyonel)",
      PromptOptional: "Ek yönerge (opsiyonel)",
      RemoveObjectPromptPlaceholder: "Ne kaldırılsın? (opsiyonel)",
      OriginalTextPlaceholder: "Eski metin",
      NewTextPlaceholder: "Yeni metin",
      EditRegionPromptPlaceholder: "Bu alanı nasıl düzenleyeyim?",
      TargetLanguage: "Hedef dil",
      SelectLanguage: "Dil seç",
      StatusDraft: "taslak",
      StatusQueued: "sırada",
      StatusRunning: "çalışıyor",
      StatusDone: "tamam",
      StatusFailed: "hata",
      History: "Geçmiş",
      OriginalVersion: "Orijinal",
      EditRegionPromptPlaceholder:
        "Bu alan nasıl düzeltilsin? (örn. 'mavi yap', 'lekeyi temizle', 'sağa kaydır')",
      AddObjectPromptPlaceholder: "Bu alana ne ekleyeyim? (ör. kırmızı elma)",
      LogoImage: "Logo",
      UploadLogo: "Logo yükle",
      PickFromLibrary: "Kütüphaneden seç",
      LibraryNoLogos: "Marka kütüphanesinde henüz logo yok",
      LibraryLoadFailed: "Marka kütüphanesi yüklenemedi",
      ApplyLogoToAllImages: "Eğitimdeki tüm görsellere uygula",
      // Toplu Alan İşlemleri (area-ops-batch)
      AddToList: "Listeye Ekle",
      BatchLabel: "Toplu Düzenleme",
      MaxOpsReached: "En fazla {{max}} işlem eklenebilir",
      StatusStaged: "listede",
      BatchUnsupported: "Toplu işlem desteklenmiyor, işlemler sırayla uygulanıyor",
      InsufficientBalance: "Yetersiz bakiye",
      OpUnchanged: "Bu alanda değişiklik algılanmadı. Tekrar uygulamadan önce sonucu kontrol edin.",
      OpMarkerInk: "Model bu alana işaret çizdi. Tekrar uygulamadan önce sonucu kontrol edin.",
      OpLogoFailed: "Logo eklenemedi. Farklı bir logo dosyası deneyin.",
      // Tüm görsel modu + AI Wizard'dan taşınan özellikler
      ApplyToWholeImage: "Tüm görsele uygula",
      WholeImage: "Tüm görsel",
      ResizeImage: "Yeniden Boyutlandır",
      SimilarInfographic: "Benzer İnfografik",
      ReplaceProductCard: "Referansla Değiştir",
      RemoveObjectWholePromptPlaceholder: "Ne kaldırılsın? (örn. 'arkadaki sandalye')",
      ResizeBlockedByStaged: "Listede bekleyen alan işlemleri varken oran değiştirilemez",
    },
    ReplaceBackground: {
      ReferenceImageLabel: "Arka plan mekânı (referans görsel)",
      ReferenceSelected: "Referans mekân seçildi",
      ChangeUpload: "Değiştir",
      UploadHint: "Mekân görseli yükle veya sürükle-bırak (PNG, JPG, JPEG)",
      SelectAreaLabel: "Değiştirilecek alan",
      SelectAreaButton: "Görselden alan seç",
      RegionSelectedReselect: "Alanı yeniden seç",
      PromptLabel: "Ek yönerge",
      PromptPlaceholder: "İsteğe bağlı: örn. 'gün batımı ışığı', 'iç mekân olarak kalsın'",
    },
    "Aspect Ratio": "En Boy Oranı",
    "Scale Factor": "Büyütme Faktörü",
    Language: {
      Turkish: "Türkçe",
      English: "İngilizce(ABD)",
      Spanish: "İspanyolca",
      French: "Fransızca",
      German: "Almanca",
      Chinese: "Çince",
      Azerbaijani: "Azerice",
      Arabic: "Arapça",
      Russian: "Rusça",
      Japanese: "Japonca",
      Portuguese: "Portekizce(BR)",
    },
    GuideMultiInput: {
      flow_items_title: "Akış Öğeleri",
      add_click: "Tıklama Ekle",
      add_input: "Giriş Ekle",
      empty_items: "Henüz öğe yok. Yukarıdaki butonlarla tıklama veya giriş öğesi ekleyin.",
      kind_click: "Tıklama",
      kind_input: "Giriş",
      label: "Etiket",
      label_placeholder: "İsteğe bağlı etiket",
      item_color: "Öğe Rengi",
      success_message: "Başarı Mesajı",
      success_placeholder: "Örn. Harika iş!",
      failure_message: "Hata Mesajı",
      failure_placeholder: "Örn. Yazımı kontrol edin",
      on_click_label: "Tıklamada",
      onClick_next_item: "Sonraki öğeye git",
      onClick_step: "Belirli bir sahneye git",
      target_step_label: "Hedef Sahne",
      pick_target: "— Bir sahne seçin —",
      click_here: "Buraya tıklayın",
      tag: "Etiket (isteğe bağlı, sonra referans için)",
      tag_placeholder: "Örn. adSoyad",
      validation_mode: "Doğrulama Modu",
      validation_exact: "Tam eşleşme",
      validation_random: "Rastgele (karakter sınırı)",
      expected_value: "Beklenen Değer",
      min_chars: "Min",
      max_chars: "Maks",
      move_up: "Yukarı taşı",
      move_down: "Aşağı taşı",
      delete_item: "Sil",
      delete: "Sil",
      expand_item: "Genişlet",
      collapse_item: "Daralt",
      expand_all: "Tümünü genişlet",
      collapse_all: "Tümünü daralt",
    },
    EditorShortcuts: {
      mini_preview: "Mini ön izleme",
    },
    Original: "Orijinal",
    Versions: "Geçmiş",
    "Loading versions": "Geçmiş yükleniyor",
    Animate: "Canlandır",
    Replace: "Değiştir",
    Reference: "Referans",
    "Text to Image": "Metinden Görsel",
    Infographic: "İnfografik",
    Attempt: "Deneme",
    Version: "Sürüm",
    "No history": "Geçmiş yok",
    Result: "Sonuç",
    Failed: "Başarısız",
    "Result will appear here": "Sonuç burada görünecek",
    Scene: "Sahne",
    Scenes: "Sahneler",
    Settings: "Ayarlar",
    AnimationLabel: "Animasyon",
    Effect: "Efekt",
    "Edit Text": "Metni Düzenle",
    "Edit HTML": "HTML Düzenle",
    "Replace File": "Dosyayı Değiştir",
    "Plugin Settings": "Eklenti Ayarı",
    "Fit to Screen": "Ekrana Sığdır",
    "Fit to Document": "Belgeye Sığdır",
    "Text Size": "Metin Boyutu",
    "Increase Text": "Metni Büyüt",
    "Decrease Text": "Metni Küçült",
    // === Task 44 === Workflow / Scene Interaction Workflow translations
    Workflow: {
      title: "İş akışı",
      EmptyScene: "Bu sahnede henüz içerik yok.",
      EmptySceneHint: "İçerik ekledikçe workflow burada görünür.",
      trigger: "Tetikleyici",
      variable: "Değişken",
      template: "Şablon",
      simulate: "Simüle Et",
      add_action: "Eylem ekle",
      delete_trigger: "Tetikleyiciyi sil",
      close: "Kapat",
      generating: "İş akışı oluşturuluyor…",
      done: "Tamam",
      failed: "Oluşturma başarısız",
      close_to_widget: "Kapat (widget'ta çalışmaya devam et)",
      suggestions: "Öneriler",
      make_suggestion: "Öneri Oluştur",
      no_suggestions: "Henüz öneri yok.",
      scope_scene: "Kapsam: bu anlatım",
      scope_course: "Kapsam: tüm kurs",
      insert_after: "Hangi sahneden sonra eklensin?",
      insert_beginning: "(başlangıçta)",
      fab: "İş akışını aç",
      fab_tooltip: "İş akışı düzenleyiciyi aç",
      fab_chip: "iş akışı",
      add_interaction: "Etkileşim Ekle",
      click_hint: "incelemek için herhangi bir tetikleyiciye tıklayın →",
      // === Interactivity Studio (Tasks 1-28) ===
      add_trigger: "Tetikleyici",
      add_variable: "Değişken",
      add_template: "Şablon",
      back_to_graph: "Grafiğe dön",
      no_suggestions_yet: "Bu eğitim için henüz öneri yok",
      suggestions_explainer:
        "AI sahnelerinizi inceleyebilir ve etkileşim eklemenin öğrenmeyi nasıl derinleştireceğini önerebilir.",
      generate_for_scene: "Şunun için oluştur:",
      generate_for_course: "Tüm kurs için",
      suggestions_hint:
        "Sahne başına yineleme yaparken idealdir; tüm kurs eğitim başına bir kez yapılan bir temeldir.",
      scene_has_no_content: "Bu sahnede henüz içerik yok",
      no_workflow_yet: "Henüz iş akışı yok",
      no_workflow_explainer:
        "Bu eğitimin herhangi bir etkileşim kuralı yok. Sahne sıranızı ve mevcut değerlendirmelerinizi yansıtan bir taban oluşturabiliriz — sonradan düzenleyebilirsiniz.",
      generate_workflow: "İş Akışı Oluştur",
      fill_empties_hint: "Zaten iş akışı kuralları olan bölümler atlanacaktır.",
      generating_for: "Oluşturuluyor…",
      view_progress: "İlerlemeyi göster",
      cancel: "İptal",
      loading: "Yükleniyor…",
      export_title: "İş akışını JSON olarak dışa aktar",
      import_title: "İş akışını JSON'dan içe aktar",
      presets_select_plugin_first: "Şablon uygulamak için bir InteractivePlugin seçin.",
      use_wizard_instead: "Bunun yerine sihirbazı kullan",
      review_tooltip: "Bu iş akışının pedagojik incelemesini yap",
      review_workflow: "İş akışını incele",
      translate_tooltip: "Geçerli sahnenin etkileşimlerini çevir",
      translate_scene: "Sahneyi çevir",
      event: "Olay",
      scene: "Sahne",
      no_scenes: "(sahne yok)",
      plugin_box: "Etkileşimli kutu",
      any_box: "Herhangi biri (*)",
      create: "Oluştur",
      scoring_mode: "Puanlama modu",
      translate_picker_title: "Sahneyi şu dile çevir…",
      translating: "Çevriliyor…",
      highlight_unreachable: "Ulaşılamayan düğümleri vurgula",
      unreachable_count: "{{count}} ulaşılamayan düğüm",
      unreachable: "ulaşılamaz",
      delete_variable: "Değişkeni sil",
      variable_invalid_id: "lowerCamelCase kullanın (harf/rakam; küçük harfle başlamalı).",
      variable_duplicate_id: "Bu kimliğe sahip bir değişken zaten var.",
      variables: "Değişkenler",
      variable_id_placeholder: "ad (ör. score)",
      variable_initial_placeholder: "başlangıç değeri",
      add: "Ekle",
      variables_empty:
        "Henüz değişken yok. setVar / dallanma eylemlerinde kullanmak için bir tane ekleyin.",
    },
    InteractivityStudio: {
      title: "Etkileşim Stüdyosu",
      scene: "Sahne",
      close: "Kapat",
      tab: {
        workflow: "İş Akışı",
        suggestions: "Öneriler",
        flow_viewer: "Akış Görüntüleyici",
      },
    },
    Wizard: {
      q1: "Ne tür bir etkileşim?",
      q2: "Öğrenci bunu yaptığında ne olur?",
      q3_branch: "YANLIŞ yol nereye gider?",
      q3_review: "Seçimlerinizi gözden geçirin",
      back: "Geri",
      create: "Oluştur",
      pick_scene: "Bir sahne seçin…",
    },
    Akis: {
      title: "AKIŞ ÖĞELERİ",
      empty: "Henüz öğe yok. Eklemek için yukarıdaki düğmeleri kullanın.",
      label: "Etiket",
      triggers: "tetikleyici bağlı",
      remove: "Kaldır",
    },
    AiSuggestions: {
      button: "Öneriler",
    },
    FlowViewer: {
      title: "Akış Görüntüleyici",
      current_context: "geçerli sahne bağlamı",
      mode: {
        all: "Tümünü Göster",
        scene: "Sahneyi Göster",
        storyboard: "Hikaye Panosu",
      },
    },
    LeftPanel: {
      scenes: "SAHNELER",
      flow_viewer: "Akış görüntüleyici",
      flow_viewer_tooltip: "Akış Görüntüleyiciyi Aç",
    },
    SkipInteractive: {
      label: "Etkileşimi Atla",
      button: "Atla",
      help: "İşaretlendiğinde, etkileşimli an sırasında görüntü alanının sağ alt köşesinde bir Atla düğmesi görünür.",
    },
    // === /Task 44 ===
    layersPanel: {
      title: "Katmanlar",
      showAll: "Tümünü göster",
      hideAll: "Tümünü gizle",
      lockAll: "Tümünü kilitle",
      unlockAll: "Tümünün kilidini aç",
      show: "Göster",
      hide: "Gizle",
      lock: "Kilitle",
      unlock: "Kilidi aç",
      lockedNoDrag: "Kilitli",
      dragToReorder: "Sıralamak için sürükle",
      dragGroup: "Tüm grubu taşımak için sürükleyin",
      elements: "öğe",
    },
    scenePaste: {
      copyScene: "Sahneyi kopyala",
      copied: "Sahne kopyalandı — dilediğin eğitime yapıştırabilirsin.",
      title: "Sahne bu eğitime eklensin mi?",
      contains: "İçerik",
      image: "resim",
      images: "resim",
      video: "video",
      videos: "video",
      sound: "ses",
      sounds: "ses",
      narration: "anlatım",
      narrations: "anlatım",
      mediaCopied: "Medyası bu eğitime kopyalanacak.",
      mediaReused: "Medyası yeniden kullanılacak.",
      addScene: "Sahneyi ekle",
      copying: "Kopyalanıyor…",
      done: "Tamamlandı — sahne eklendi.",
      error: "Sahne yapıştırılamadı: ",
    },
    "Edit Image v2": "Görseli Düzenle v3",
  },
};

export { tr };
